import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token: Scalars['String'];
};

export type BillState = {
  __typename?: 'BillState';
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  is_visible: Scalars['Boolean'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type BillStateCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  is_visible?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type BillStateOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  order?: Maybe<OrderByArg>;
  is_visible?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type BillStateUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  is_visible?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type BillStateWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  order?: Maybe<IntFilter>;
  is_visible?: Maybe<BooleanFilter>;
  created_at?: Maybe<NullableDateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<BillStateWhereInput>>;
  OR?: Maybe<Array<BillStateWhereInput>>;
  NOT?: Maybe<Array<BillStateWhereInput>>;
};

export type BillStateWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Bills = {
  __typename?: 'Bills';
  /** Número de cuenta */
  cuenta: Scalars['Int'];
  /** Tipo */
  tipo: Scalars['String'];
  /** Punto */
  punto: Scalars['String'];
  registros: Array<DataBills>;
};

export type BillsByUserInput = {
  company_id?: Maybe<Scalars['String']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
};

export type BooleanFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<Scalars['Boolean']>;
};

export type CashSource = {
  __typename?: 'CashSource';
  id: Scalars['String'];
  name: Scalars['String'];
  bill: Array<Bill>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type CashSourceBillArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillWhereUniqueInput>;
  after?: Maybe<BillWhereUniqueInput>;
};

export type CashSourceCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill?: Maybe<BillCreateManyWithoutCash_SourceInput>;
};

export type CashSourceCreateOneWithoutBillInput = {
  create?: Maybe<CashSourceCreateWithoutBillInput>;
  connect?: Maybe<CashSourceWhereUniqueInput>;
};

export type CashSourceCreateWithoutBillInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type CashSourceOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type CashSourceUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill?: Maybe<BillUpdateManyWithoutCash_SourceInput>;
};

export type CashSourceUpdateOneWithoutBillInput = {
  create?: Maybe<CashSourceCreateWithoutBillInput>;
  connect?: Maybe<CashSourceWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CashSourceUpdateWithoutBillDataInput>;
  upsert?: Maybe<CashSourceUpsertWithoutBillInput>;
};

export type CashSourceUpdateWithoutBillDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type CashSourceUpsertWithoutBillInput = {
  update: CashSourceUpdateWithoutBillDataInput;
  create: CashSourceCreateWithoutBillInput;
};

export type CashSourceWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  bill?: Maybe<BillFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<CashSourceWhereInput>>;
  OR?: Maybe<Array<CashSourceWhereInput>>;
  NOT?: Maybe<Array<CashSourceWhereInput>>;
};

export type CashSourceWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ChangePasswordInput = {
  user: Scalars['String'];
  password: Scalars['String'];
};

export type CountTotalService = {
  __typename?: 'CountTotalService';
  id: Scalars['String'];
  name: Scalars['String'];
  icon: Scalars['String'];
  total: Scalars['Int'];
};

export type DataBills = {
  __typename?: 'DataBills';
  /** id */
  id: Scalars['Int'];
  /** Img. factura */
  img_factura: Scalars['String'];
  /** Img. comprobante */
  img_comprob: Scalars['String'];
  /** Descripcion */
  descripcion: Scalars['String'];
  /** Fecha creación */
  created_at: Scalars['String'];
  UserFactura: Array<UserFactura>;
  UserComprob: Array<UserFactura>;
};


export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  not?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
};

export type FloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  not?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  notIn?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
};

export type InputGetPercentageBill = {
  regional?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Scalars['String']>>;
  date_begin?: Maybe<Scalars['String']>;
  date_end?: Maybe<Scalars['String']>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  not?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  notIn?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
};


export type Mutation = {
  __typename?: 'Mutation';
  getMoviiBill: MoviiResponse;
  signIn: AuthPayload;
  refreshToken: AuthPayload;
  changePassword: User;
  createOneuser: User;
  updateOneuser?: Maybe<User>;
  deleteOneuser?: Maybe<User>;
  deleteManyUsers: Scalars['String'];
  createOneuserApplicationRol: UserApplicationRol;
  updateOneuserApplicationRol?: Maybe<UserApplicationRol>;
  deleteOneuserApplicationRol?: Maybe<UserApplicationRol>;
  deleteManyUserApplicationRol: Scalars['String'];
  createOnerol: Rol;
  updateOnerol?: Maybe<Rol>;
  deleteOnerol?: Maybe<Rol>;
  createOneapplication: Application;
  updateOneapplication?: Maybe<Application>;
  deleteOneapplication?: Maybe<Application>;
  createOnecompany: Company;
  updateOnecompany?: Maybe<Company>;
  deleteOnecompany?: Maybe<Company>;
  createOneconcept: Concept;
  updateOneconcept?: Maybe<Concept>;
  deleteOneconcept?: Maybe<Concept>;
  createOneservice: Service;
  updateOneservice?: Maybe<Service>;
  deleteOneservice?: Maybe<Service>;
  createOneaccount: Account;
  updateOneaccount?: Maybe<Account>;
  deleteOneaccount?: Maybe<Account>;
  createOneregional: Regional;
  updateOneregional?: Maybe<Regional>;
  deleteOneregional?: Maybe<Regional>;
  createOnePropertyLevel: PropertyLevel;
  updateOnePropertyLevel?: Maybe<PropertyLevel>;
  deleteOnePropertyLevel?: Maybe<PropertyLevel>;
  createOnemarketer: Marketer;
  updateOnemarketer?: Maybe<Marketer>;
  deleteOnemarketer?: Maybe<Marketer>;
  createOnebill: Bill;
  updateOnebill?: Maybe<Bill>;
  deleteOnebill?: Maybe<Bill>;
  createOneBill: Bill;
  Reportdatameters: Scalars['String'];
  ReportPagos: Scalars['String'];
  ReportDigitadores: Scalars['String'];
  ReportConsolidados: Scalars['String'];
  createOneplace: Place;
  updateOneplace?: Maybe<Place>;
  deleteOneplace?: Maybe<Place>;
  createOnePaymentMethod: PaymentMethod;
  updateOnePaymentMethod?: Maybe<PaymentMethod>;
  deleteOnePaymentMethod?: Maybe<PaymentMethod>;
  createOnePaymentMethodMarketer: PaymentMethodMarketer;
  updateOnePaymentMethodMarketer?: Maybe<PaymentMethodMarketer>;
  deleteOnePaymentMethodMarketer?: Maybe<PaymentMethodMarketer>;
  deleteAmounts: Scalars['String'];
  createOnebank: Bank;
  updateOnebank?: Maybe<Bank>;
  deleteOnebank?: Maybe<Bank>;
  createOneCashSource: CashSource;
  updateOneCashSource?: Maybe<CashSource>;
  deleteOneCashSource?: Maybe<CashSource>;
  createOnesession: Session;
  updateOnesession?: Maybe<Session>;
  deleteOnesession?: Maybe<Session>;
  createOneaudit: Audit;
  updateOneaudit?: Maybe<Audit>;
  deleteOneaudit?: Maybe<Audit>;
  createOnedomain: Domain;
  updateOnedomain?: Maybe<Domain>;
  deleteOnedomain?: Maybe<Domain>;
  createOneBillState: BillState;
  updateOneBillState?: Maybe<BillState>;
  deleteOneBillState?: Maybe<BillState>;
  createOneRegionalUser: RegionalUser;
  updateOneRegionalUser?: Maybe<RegionalUser>;
  deleteOneRegionalUser?: Maybe<RegionalUser>;
  createOnesetting: Setting;
  updateOnesetting?: Maybe<Setting>;
  deleteOnesetting?: Maybe<Setting>;
};


export type MutationGetMoviiBillArgs = {
  bill_id?: Maybe<Scalars['String']>;
};


export type MutationSignInArgs = {
  payload?: Maybe<SignIn>;
};


export type MutationChangePasswordArgs = {
  payload?: Maybe<ChangePasswordInput>;
};


export type MutationCreateOneuserArgs = {
  data: UserCreateInput;
};


export type MutationUpdateOneuserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneuserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteManyUsersArgs = {
  IntList?: Maybe<IntList>;
};


export type MutationCreateOneuserApplicationRolArgs = {
  data: UserApplicationRolCreateInput;
};


export type MutationUpdateOneuserApplicationRolArgs = {
  data: UserApplicationRolUpdateInput;
  where: UserApplicationRolWhereUniqueInput;
};


export type MutationDeleteOneuserApplicationRolArgs = {
  where: UserApplicationRolWhereUniqueInput;
};


export type MutationDeleteManyUserApplicationRolArgs = {
  IntList?: Maybe<IntList>;
};


export type MutationCreateOnerolArgs = {
  data: RolCreateInput;
};


export type MutationUpdateOnerolArgs = {
  data: RolUpdateInput;
  where: RolWhereUniqueInput;
};


export type MutationDeleteOnerolArgs = {
  where: RolWhereUniqueInput;
};


export type MutationCreateOneapplicationArgs = {
  data: ApplicationCreateInput;
};


export type MutationUpdateOneapplicationArgs = {
  data: ApplicationUpdateInput;
  where: ApplicationWhereUniqueInput;
};


export type MutationDeleteOneapplicationArgs = {
  where: ApplicationWhereUniqueInput;
};


export type MutationCreateOnecompanyArgs = {
  data: CompanyCreateInput;
};


export type MutationUpdateOnecompanyArgs = {
  data: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};


export type MutationDeleteOnecompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationCreateOneconceptArgs = {
  data: ConceptCreateInput;
};


export type MutationUpdateOneconceptArgs = {
  data: ConceptUpdateInput;
  where: ConceptWhereUniqueInput;
};


export type MutationDeleteOneconceptArgs = {
  where: ConceptWhereUniqueInput;
};


export type MutationCreateOneserviceArgs = {
  data: ServiceCreateInput;
};


export type MutationUpdateOneserviceArgs = {
  data: ServiceUpdateInput;
  where: ServiceWhereUniqueInput;
};


export type MutationDeleteOneserviceArgs = {
  where: ServiceWhereUniqueInput;
};


export type MutationCreateOneaccountArgs = {
  data: AccountCreateInput;
};


export type MutationUpdateOneaccountArgs = {
  data: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationDeleteOneaccountArgs = {
  where: AccountWhereUniqueInput;
};


export type MutationCreateOneregionalArgs = {
  data: RegionalCreateInput;
};


export type MutationUpdateOneregionalArgs = {
  data: RegionalUpdateInput;
  where: RegionalWhereUniqueInput;
};


export type MutationDeleteOneregionalArgs = {
  where: RegionalWhereUniqueInput;
};


export type MutationCreateOnePropertyLevelArgs = {
  data: PropertyLevelCreateInput;
};


export type MutationUpdateOnePropertyLevelArgs = {
  data: PropertyLevelUpdateInput;
  where: PropertyLevelWhereUniqueInput;
};


export type MutationDeleteOnePropertyLevelArgs = {
  where: PropertyLevelWhereUniqueInput;
};


export type MutationCreateOnemarketerArgs = {
  data: MarketerCreateInput;
};


export type MutationUpdateOnemarketerArgs = {
  data: MarketerUpdateInput;
  where: MarketerWhereUniqueInput;
};


export type MutationDeleteOnemarketerArgs = {
  where: MarketerWhereUniqueInput;
};


export type MutationCreateOnebillArgs = {
  data: BillCreateInput;
};


export type MutationUpdateOnebillArgs = {
  data: BillUpdateInput;
  where: BillWhereUniqueInput;
};


export type MutationDeleteOnebillArgs = {
  where: BillWhereUniqueInput;
};


export type MutationCreateOneBillArgs = {
  BillCreate?: Maybe<BillCreate>;
};


export type MutationReportdatametersArgs = {
  ReportMeters?: Maybe<ReportMeters>;
};


export type MutationReportPagosArgs = {
  ReportPagos?: Maybe<ReportPagos>;
};


export type MutationReportDigitadoresArgs = {
  ReportDigitadores?: Maybe<ReportDigitadores>;
};


export type MutationReportConsolidadosArgs = {
  ReportConsolidados?: Maybe<ReportConsolidados>;
};


export type MutationCreateOneplaceArgs = {
  data: PlaceCreateInput;
};


export type MutationUpdateOneplaceArgs = {
  data: PlaceUpdateInput;
  where: PlaceWhereUniqueInput;
};


export type MutationDeleteOneplaceArgs = {
  where: PlaceWhereUniqueInput;
};


export type MutationCreateOnePaymentMethodArgs = {
  data: PaymentMethodCreateInput;
};


export type MutationUpdateOnePaymentMethodArgs = {
  data: PaymentMethodUpdateInput;
  where: PaymentMethodWhereUniqueInput;
};


export type MutationDeleteOnePaymentMethodArgs = {
  where: PaymentMethodWhereUniqueInput;
};


export type MutationCreateOnePaymentMethodMarketerArgs = {
  data: PaymentMethodMarketerCreateInput;
};


export type MutationUpdateOnePaymentMethodMarketerArgs = {
  data: PaymentMethodMarketerUpdateInput;
  where: PaymentMethodMarketerWhereUniqueInput;
};


export type MutationDeleteOnePaymentMethodMarketerArgs = {
  where: PaymentMethodMarketerWhereUniqueInput;
};


export type MutationDeleteAmountsArgs = {
  bill_id: Scalars['String'];
};


export type MutationCreateOnebankArgs = {
  data: BankCreateInput;
};


export type MutationUpdateOnebankArgs = {
  data: BankUpdateInput;
  where: BankWhereUniqueInput;
};


export type MutationDeleteOnebankArgs = {
  where: BankWhereUniqueInput;
};


export type MutationCreateOneCashSourceArgs = {
  data: CashSourceCreateInput;
};


export type MutationUpdateOneCashSourceArgs = {
  data: CashSourceUpdateInput;
  where: CashSourceWhereUniqueInput;
};


export type MutationDeleteOneCashSourceArgs = {
  where: CashSourceWhereUniqueInput;
};


export type MutationCreateOnesessionArgs = {
  data: SessionCreateInput;
};


export type MutationUpdateOnesessionArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationDeleteOnesessionArgs = {
  where: SessionWhereUniqueInput;
};


export type MutationCreateOneauditArgs = {
  data: AuditCreateInput;
};


export type MutationUpdateOneauditArgs = {
  data: AuditUpdateInput;
  where: AuditWhereUniqueInput;
};


export type MutationDeleteOneauditArgs = {
  where: AuditWhereUniqueInput;
};


export type MutationCreateOnedomainArgs = {
  data: DomainCreateInput;
};


export type MutationUpdateOnedomainArgs = {
  data: DomainUpdateInput;
  where: DomainWhereUniqueInput;
};


export type MutationDeleteOnedomainArgs = {
  where: DomainWhereUniqueInput;
};


export type MutationCreateOneBillStateArgs = {
  data: BillStateCreateInput;
};


export type MutationUpdateOneBillStateArgs = {
  data: BillStateUpdateInput;
  where: BillStateWhereUniqueInput;
};


export type MutationDeleteOneBillStateArgs = {
  where: BillStateWhereUniqueInput;
};


export type MutationCreateOneRegionalUserArgs = {
  data: RegionalUserCreateInput;
};


export type MutationUpdateOneRegionalUserArgs = {
  data: RegionalUserUpdateInput;
  where: RegionalUserWhereUniqueInput;
};


export type MutationDeleteOneRegionalUserArgs = {
  where: RegionalUserWhereUniqueInput;
};


export type MutationCreateOnesettingArgs = {
  data: SettingCreateInput;
};


export type MutationUpdateOnesettingArgs = {
  data: SettingUpdateInput;
  where: SettingWhereUniqueInput;
};


export type MutationDeleteOnesettingArgs = {
  where: SettingWhereUniqueInput;
};

export type NullableBooleanFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<Scalars['Boolean']>;
};

export type NullableDateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  not?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
};

export type NullableFloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  not?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  notIn?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
};

export type NullableIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  not?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  notIn?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
};

export type NullableStringFilter = {
  equals?: Maybe<Scalars['String']>;
  not?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  notIn?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
};

export enum OrderByArg {
  Asc = 'asc',
  Desc = 'desc'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  id: Scalars['String'];
  name: Scalars['String'];
  payment_method_marketer: Array<PaymentMethodMarketer>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type PaymentMethodPayment_Method_MarketerArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
  after?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
};

export type PaymentMethodCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateManyWithoutPayment_MethodInput>;
};

export type PaymentMethodCreateOneWithoutPayment_Method_MarketerInput = {
  create?: Maybe<PaymentMethodCreateWithoutPayment_Method_MarketerInput>;
  connect?: Maybe<PaymentMethodWhereUniqueInput>;
};

export type PaymentMethodCreateWithoutPayment_Method_MarketerInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethodMarketer = {
  __typename?: 'PaymentMethodMarketer';
  id: Scalars['String'];
  payment_method_id: Scalars['String'];
  payment_method: PaymentMethod;
  payment_method_name: Scalars['String'];
  priority: Scalars['Int'];
  bank_id: Scalars['String'];
  bank: Bank;
  bank_name?: Maybe<Scalars['String']>;
  marketer_id: Scalars['String'];
  marketer: Marketer;
  marketer_name: Scalars['String'];
  type: Scalars['String'];
  reference_number: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  bill: Array<Bill>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type PaymentMethodMarketerBillArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillWhereUniqueInput>;
  after?: Maybe<BillWhereUniqueInput>;
};

export type PaymentMethodMarketerCreateInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name: Scalars['String'];
  payment_field?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  bank_name?: Maybe<Scalars['String']>;
  marketer_name: Scalars['String'];
  type: Scalars['String'];
  reference_number: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method: PaymentMethodCreateOneWithoutPayment_Method_MarketerInput;
  bank: BankCreateOneWithoutPaymentMethodMarketerInput;
  marketer: MarketerCreateOneWithoutPaymentMethodMarketerInput;
  bill?: Maybe<BillCreateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerCreateManyWithoutBankInput = {
  create?: Maybe<Array<PaymentMethodMarketerCreateWithoutBankInput>>;
  connect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
};

export type PaymentMethodMarketerCreateManyWithoutMarketerInput = {
  create?: Maybe<Array<PaymentMethodMarketerCreateWithoutMarketerInput>>;
  connect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
};

export type PaymentMethodMarketerCreateManyWithoutPayment_MethodInput = {
  create?: Maybe<Array<PaymentMethodMarketerCreateWithoutPayment_MethodInput>>;
  connect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
};

export type PaymentMethodMarketerCreateOneWithoutBillInput = {
  create?: Maybe<PaymentMethodMarketerCreateWithoutBillInput>;
  connect?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
};

export type PaymentMethodMarketerCreateWithoutBankInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name: Scalars['String'];
  payment_field?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  bank_name?: Maybe<Scalars['String']>;
  marketer_name: Scalars['String'];
  type: Scalars['String'];
  reference_number: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method: PaymentMethodCreateOneWithoutPayment_Method_MarketerInput;
  marketer: MarketerCreateOneWithoutPaymentMethodMarketerInput;
  bill?: Maybe<BillCreateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerCreateWithoutBillInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name: Scalars['String'];
  payment_field?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  bank_name?: Maybe<Scalars['String']>;
  marketer_name: Scalars['String'];
  type: Scalars['String'];
  reference_number: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method: PaymentMethodCreateOneWithoutPayment_Method_MarketerInput;
  bank: BankCreateOneWithoutPaymentMethodMarketerInput;
  marketer: MarketerCreateOneWithoutPaymentMethodMarketerInput;
};

export type PaymentMethodMarketerCreateWithoutMarketerInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name: Scalars['String'];
  payment_field?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  bank_name?: Maybe<Scalars['String']>;
  marketer_name: Scalars['String'];
  type: Scalars['String'];
  reference_number: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method: PaymentMethodCreateOneWithoutPayment_Method_MarketerInput;
  bank: BankCreateOneWithoutPaymentMethodMarketerInput;
  bill?: Maybe<BillCreateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerCreateWithoutPayment_MethodInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name: Scalars['String'];
  payment_field?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  bank_name?: Maybe<Scalars['String']>;
  marketer_name: Scalars['String'];
  type: Scalars['String'];
  reference_number: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bank: BankCreateOneWithoutPaymentMethodMarketerInput;
  marketer: MarketerCreateOneWithoutPaymentMethodMarketerInput;
  bill?: Maybe<BillCreateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerFilter = {
  every?: Maybe<PaymentMethodMarketerWhereInput>;
  some?: Maybe<PaymentMethodMarketerWhereInput>;
  none?: Maybe<PaymentMethodMarketerWhereInput>;
};

export type PaymentMethodMarketerOrderByInput = {
  id?: Maybe<OrderByArg>;
  payment_method_id?: Maybe<OrderByArg>;
  payment_method_name?: Maybe<OrderByArg>;
  payment_field?: Maybe<OrderByArg>;
  priority?: Maybe<OrderByArg>;
  bank_id?: Maybe<OrderByArg>;
  bank_name?: Maybe<OrderByArg>;
  marketer_id?: Maybe<OrderByArg>;
  marketer_name?: Maybe<OrderByArg>;
  type?: Maybe<OrderByArg>;
  reference_number?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type PaymentMethodMarketerScalarWhereInput = {
  id?: Maybe<StringFilter>;
  payment_method_id?: Maybe<StringFilter>;
  payment_method_name?: Maybe<StringFilter>;
  payment_field?: Maybe<NullableStringFilter>;
  priority?: Maybe<IntFilter>;
  bank_id?: Maybe<StringFilter>;
  bank_name?: Maybe<NullableStringFilter>;
  marketer_id?: Maybe<StringFilter>;
  marketer_name?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  reference_number?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  bill?: Maybe<BillFilter>;
  AND?: Maybe<Array<PaymentMethodMarketerScalarWhereInput>>;
  OR?: Maybe<Array<PaymentMethodMarketerScalarWhereInput>>;
  NOT?: Maybe<Array<PaymentMethodMarketerScalarWhereInput>>;
};

export type PaymentMethodMarketerUpdateInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name?: Maybe<Scalars['String']>;
  payment_field?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  reference_number?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method?: Maybe<PaymentMethodUpdateOneRequiredWithoutPayment_Method_MarketerInput>;
  bank?: Maybe<BankUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  marketer?: Maybe<MarketerUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name?: Maybe<Scalars['String']>;
  payment_field?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  reference_number?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethodMarketerUpdateManyWithWhereNestedInput = {
  where: PaymentMethodMarketerScalarWhereInput;
  data: PaymentMethodMarketerUpdateManyDataInput;
};

export type PaymentMethodMarketerUpdateManyWithoutBankInput = {
  create?: Maybe<Array<PaymentMethodMarketerCreateWithoutBankInput>>;
  connect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  set?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  disconnect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  delete?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  update?: Maybe<Array<PaymentMethodMarketerUpdateWithWhereUniqueWithoutBankInput>>;
  updateMany?: Maybe<Array<PaymentMethodMarketerUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<PaymentMethodMarketerScalarWhereInput>>;
  upsert?: Maybe<Array<PaymentMethodMarketerUpsertWithWhereUniqueWithoutBankInput>>;
};

export type PaymentMethodMarketerUpdateManyWithoutMarketerInput = {
  create?: Maybe<Array<PaymentMethodMarketerCreateWithoutMarketerInput>>;
  connect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  set?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  disconnect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  delete?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  update?: Maybe<Array<PaymentMethodMarketerUpdateWithWhereUniqueWithoutMarketerInput>>;
  updateMany?: Maybe<Array<PaymentMethodMarketerUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<PaymentMethodMarketerScalarWhereInput>>;
  upsert?: Maybe<Array<PaymentMethodMarketerUpsertWithWhereUniqueWithoutMarketerInput>>;
};

export type PaymentMethodMarketerUpdateManyWithoutPayment_MethodInput = {
  create?: Maybe<Array<PaymentMethodMarketerCreateWithoutPayment_MethodInput>>;
  connect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  set?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  disconnect?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  delete?: Maybe<Array<PaymentMethodMarketerWhereUniqueInput>>;
  update?: Maybe<Array<PaymentMethodMarketerUpdateWithWhereUniqueWithoutPayment_MethodInput>>;
  updateMany?: Maybe<Array<PaymentMethodMarketerUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<PaymentMethodMarketerScalarWhereInput>>;
  upsert?: Maybe<Array<PaymentMethodMarketerUpsertWithWhereUniqueWithoutPayment_MethodInput>>;
};

export type PaymentMethodMarketerUpdateOneWithoutBillInput = {
  create?: Maybe<PaymentMethodMarketerCreateWithoutBillInput>;
  connect?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PaymentMethodMarketerUpdateWithoutBillDataInput>;
  upsert?: Maybe<PaymentMethodMarketerUpsertWithoutBillInput>;
};

export type PaymentMethodMarketerUpdateWithWhereUniqueWithoutBankInput = {
  where: PaymentMethodMarketerWhereUniqueInput;
  data: PaymentMethodMarketerUpdateWithoutBankDataInput;
};

export type PaymentMethodMarketerUpdateWithWhereUniqueWithoutMarketerInput = {
  where: PaymentMethodMarketerWhereUniqueInput;
  data: PaymentMethodMarketerUpdateWithoutMarketerDataInput;
};

export type PaymentMethodMarketerUpdateWithWhereUniqueWithoutPayment_MethodInput = {
  where: PaymentMethodMarketerWhereUniqueInput;
  data: PaymentMethodMarketerUpdateWithoutPayment_MethodDataInput;
};

export type PaymentMethodMarketerUpdateWithoutBankDataInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name?: Maybe<Scalars['String']>;
  payment_field?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  reference_number?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method?: Maybe<PaymentMethodUpdateOneRequiredWithoutPayment_Method_MarketerInput>;
  marketer?: Maybe<MarketerUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerUpdateWithoutBillDataInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name?: Maybe<Scalars['String']>;
  payment_field?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  reference_number?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method?: Maybe<PaymentMethodUpdateOneRequiredWithoutPayment_Method_MarketerInput>;
  bank?: Maybe<BankUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  marketer?: Maybe<MarketerUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
};

export type PaymentMethodMarketerUpdateWithoutMarketerDataInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name?: Maybe<Scalars['String']>;
  payment_field?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  reference_number?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method?: Maybe<PaymentMethodUpdateOneRequiredWithoutPayment_Method_MarketerInput>;
  bank?: Maybe<BankUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerUpdateWithoutPayment_MethodDataInput = {
  id?: Maybe<Scalars['String']>;
  payment_method_name?: Maybe<Scalars['String']>;
  payment_field?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  reference_number?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bank?: Maybe<BankUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  marketer?: Maybe<MarketerUpdateOneRequiredWithoutPaymentMethodMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodMarketerUpsertWithWhereUniqueWithoutBankInput = {
  where: PaymentMethodMarketerWhereUniqueInput;
  update: PaymentMethodMarketerUpdateWithoutBankDataInput;
  create: PaymentMethodMarketerCreateWithoutBankInput;
};

export type PaymentMethodMarketerUpsertWithWhereUniqueWithoutMarketerInput = {
  where: PaymentMethodMarketerWhereUniqueInput;
  update: PaymentMethodMarketerUpdateWithoutMarketerDataInput;
  create: PaymentMethodMarketerCreateWithoutMarketerInput;
};

export type PaymentMethodMarketerUpsertWithWhereUniqueWithoutPayment_MethodInput = {
  where: PaymentMethodMarketerWhereUniqueInput;
  update: PaymentMethodMarketerUpdateWithoutPayment_MethodDataInput;
  create: PaymentMethodMarketerCreateWithoutPayment_MethodInput;
};

export type PaymentMethodMarketerUpsertWithoutBillInput = {
  update: PaymentMethodMarketerUpdateWithoutBillDataInput;
  create: PaymentMethodMarketerCreateWithoutBillInput;
};

export type PaymentMethodMarketerWhereInput = {
  id?: Maybe<StringFilter>;
  payment_method_id?: Maybe<StringFilter>;
  payment_method_name?: Maybe<StringFilter>;
  payment_field?: Maybe<NullableStringFilter>;
  priority?: Maybe<IntFilter>;
  bank_id?: Maybe<StringFilter>;
  bank_name?: Maybe<NullableStringFilter>;
  marketer_id?: Maybe<StringFilter>;
  marketer_name?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  reference_number?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  bill?: Maybe<BillFilter>;
  AND?: Maybe<Array<PaymentMethodMarketerWhereInput>>;
  OR?: Maybe<Array<PaymentMethodMarketerWhereInput>>;
  NOT?: Maybe<Array<PaymentMethodMarketerWhereInput>>;
  payment_method?: Maybe<PaymentMethodWhereInput>;
  bank?: Maybe<BankWhereInput>;
  marketer?: Maybe<MarketerWhereInput>;
};

export type PaymentMethodMarketerWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type PaymentMethodOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type PaymentMethodUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateManyWithoutPayment_MethodInput>;
};

export type PaymentMethodUpdateOneRequiredWithoutPayment_Method_MarketerInput = {
  create?: Maybe<PaymentMethodCreateWithoutPayment_Method_MarketerInput>;
  connect?: Maybe<PaymentMethodWhereUniqueInput>;
  update?: Maybe<PaymentMethodUpdateWithoutPayment_Method_MarketerDataInput>;
  upsert?: Maybe<PaymentMethodUpsertWithoutPayment_Method_MarketerInput>;
};

export type PaymentMethodUpdateWithoutPayment_Method_MarketerDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethodUpsertWithoutPayment_Method_MarketerInput = {
  update: PaymentMethodUpdateWithoutPayment_Method_MarketerDataInput;
  create: PaymentMethodCreateWithoutPayment_Method_MarketerInput;
};

export type PaymentMethodWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<PaymentMethodWhereInput>>;
  OR?: Maybe<Array<PaymentMethodWhereInput>>;
  NOT?: Maybe<Array<PaymentMethodWhereInput>>;
};

export type PaymentMethodWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PerBills = {
  __typename?: 'PerBills';
  Total_bills: Scalars['String'];
  Total_bills_state: Scalars['String'];
  regional_name: Scalars['String'];
  regional_id: Scalars['String'];
  percentage: Scalars['String'];
};

export type PerBillsTotal = {
  __typename?: 'PerBillsTotal';
  company_id: Scalars['String'];
  total_facturas: Scalars['String'];
  total_reportadas: Scalars['String'];
};

export type PropertyLevel = {
  __typename?: 'PropertyLevel';
  id: Scalars['String'];
  name: Scalars['String'];
  accounts: Array<Account>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type PropertyLevelAccountsArgs = {
  where?: Maybe<AccountWhereInput>;
  orderBy?: Maybe<AccountOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};

export type PropertyLevelCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountCreateManyWithoutProperty_LevelInput>;
};

export type PropertyLevelCreateOneWithoutAccountsInput = {
  create?: Maybe<PropertyLevelCreateWithoutAccountsInput>;
  connect?: Maybe<PropertyLevelWhereUniqueInput>;
};

export type PropertyLevelCreateWithoutAccountsInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type PropertyLevelOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type PropertyLevelUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountUpdateManyWithoutProperty_LevelInput>;
};

export type PropertyLevelUpdateOneWithoutAccountsInput = {
  create?: Maybe<PropertyLevelCreateWithoutAccountsInput>;
  connect?: Maybe<PropertyLevelWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<PropertyLevelUpdateWithoutAccountsDataInput>;
  upsert?: Maybe<PropertyLevelUpsertWithoutAccountsInput>;
};

export type PropertyLevelUpdateWithoutAccountsDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type PropertyLevelUpsertWithoutAccountsInput = {
  update: PropertyLevelUpdateWithoutAccountsDataInput;
  create: PropertyLevelCreateWithoutAccountsInput;
};

export type PropertyLevelWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<PropertyLevelWhereInput>>;
  OR?: Maybe<Array<PropertyLevelWhereInput>>;
  NOT?: Maybe<Array<PropertyLevelWhereInput>>;
};

export type PropertyLevelWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  application?: Maybe<Application>;
  applications: Array<Application>;
  account?: Maybe<Account>;
  AccountCount: Scalars['Int'];
  accounts: Array<Account>;
  amount?: Maybe<Amount>;
  AmountCount: Scalars['Int'];
  amounts: Array<Amount>;
  audit?: Maybe<Audit>;
  audits: Array<Audit>;
  bank?: Maybe<Bank>;
  banks: Array<Bank>;
  bill?: Maybe<Bill>;
  BillsCount: Scalars['Int'];
  bills: Array<Bill>;
  selectBills: Array<GetBills>;
  perBillPaid: Array<PerBills>;
  perBillPaidTotal: Array<PerBillsTotal>;
  RepGeneralCarga: Array<RepGeneralCarga>;
  billState?: Maybe<BillState>;
  BillStateCount: Scalars['Int'];
  billStates: Array<BillState>;
  cashSource?: Maybe<CashSource>;
  cashSources: Array<CashSource>;
  company?: Maybe<Company>;
  companies: Array<Company>;
  companiesCount: Scalars['Int'];
  concept?: Maybe<Concept>;
  ConceptCount: Scalars['Int'];
  concepts: Array<Concept>;
  domain?: Maybe<Domain>;
  domains: Array<Domain>;
  horario?: Maybe<Horario>;
  horarios: Array<Horario>;
  horariosCount: Scalars['Int'];
  marketer?: Maybe<Marketer>;
  marketers: Array<Marketer>;
  marketersCount: Scalars['Int'];
  meter?: Maybe<Meter>;
  meters: Array<Meter>;
  metersCount: Scalars['Int'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethods: Array<PaymentMethod>;
  paymentMethodMarketer?: Maybe<PaymentMethodMarketer>;
  paymentMethodMarketers: Array<PaymentMethodMarketer>;
  place?: Maybe<Place>;
  places: Array<Place>;
  placesCount: Scalars['Int'];
  propertyLevel?: Maybe<PropertyLevel>;
  propertyLevels: Array<PropertyLevel>;
  propertyLevelsCount: Scalars['Int'];
  reportStatus?: Maybe<ReportStatus>;
  reportStatuses: Array<ReportStatus>;
  reportStatusCount: Scalars['Int'];
  regional?: Maybe<Regional>;
  regionals: Array<Regional>;
  regionalsCount: Scalars['Int'];
  regionalUser?: Maybe<RegionalUser>;
  regionalUsers: Array<RegionalUser>;
  RegionalUserCount: Scalars['Int'];
  RegionalsByUser: Array<RegionalUser>;
  rol?: Maybe<Rol>;
  rols: Array<Rol>;
  service?: Maybe<Service>;
  services: Array<Service>;
  user?: Maybe<User>;
  users: Array<User>;
  billsByUser: Array<BillByUser>;
  userApplicationRol?: Maybe<UserApplicationRol>;
  userApplicationRols: Array<UserApplicationRol>;
  setting?: Maybe<Setting>;
  settings: Array<Setting>;
  settingsCount: Scalars['Int'];
};


export type QueryApplicationArgs = {
  where: ApplicationWhereUniqueInput;
};


export type QueryApplicationsArgs = {
  where?: Maybe<ApplicationWhereInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ApplicationWhereUniqueInput>;
  after?: Maybe<ApplicationWhereUniqueInput>;
};


export type QueryAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type QueryAccountCountArgs = {
  where?: Maybe<AccountWhereInput>;
};


export type QueryAccountsArgs = {
  where?: Maybe<AccountWhereInput>;
  orderBy?: Maybe<AccountOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};


export type QueryAmountArgs = {
  where: AmountWhereUniqueInput;
};


export type QueryAmountCountArgs = {
  where?: Maybe<AmountWhereInput>;
};


export type QueryAmountsArgs = {
  where?: Maybe<AmountWhereInput>;
  orderBy?: Maybe<AmountOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AmountWhereUniqueInput>;
  after?: Maybe<AmountWhereUniqueInput>;
};


export type QueryAuditArgs = {
  where: AuditWhereUniqueInput;
};


export type QueryAuditsArgs = {
  where?: Maybe<AuditWhereInput>;
  orderBy?: Maybe<AuditOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AuditWhereUniqueInput>;
  after?: Maybe<AuditWhereUniqueInput>;
};


export type QueryBankArgs = {
  where: BankWhereUniqueInput;
};


export type QueryBanksArgs = {
  where?: Maybe<BankWhereInput>;
  orderBy?: Maybe<BankOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BankWhereUniqueInput>;
  after?: Maybe<BankWhereUniqueInput>;
};


export type QueryBillArgs = {
  where: BillWhereUniqueInput;
};


export type QueryBillsCountArgs = {
  where?: Maybe<BillWhereInput>;
};


export type QueryBillsArgs = {
  where?: Maybe<BillWhereInput>;
  orderBy?: Maybe<BillOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillWhereUniqueInput>;
  after?: Maybe<BillWhereUniqueInput>;
};


export type QuerySelectBillsArgs = {
  payload?: Maybe<SelectBillsInput>;
};


export type QueryPerBillPaidArgs = {
  payload?: Maybe<InputGetPercentageBill>;
};


export type QueryPerBillPaidTotalArgs = {
  year: Scalars['Int'];
};


export type QueryRepGeneralCargaArgs = {
  search?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
  first: Scalars['Int'];
  last: Scalars['Int'];
};


export type QueryBillStateArgs = {
  where: BillStateWhereUniqueInput;
};


export type QueryBillStateCountArgs = {
  where?: Maybe<BillStateWhereInput>;
};


export type QueryBillStatesArgs = {
  where?: Maybe<BillStateWhereInput>;
  orderBy?: Maybe<BillStateOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillStateWhereUniqueInput>;
  after?: Maybe<BillStateWhereUniqueInput>;
};


export type QueryCashSourceArgs = {
  where: CashSourceWhereUniqueInput;
};


export type QueryCashSourcesArgs = {
  where?: Maybe<CashSourceWhereInput>;
  orderBy?: Maybe<CashSourceOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<CashSourceWhereUniqueInput>;
  after?: Maybe<CashSourceWhereUniqueInput>;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type QueryCompaniesArgs = {
  where?: Maybe<CompanyWhereInput>;
  orderBy?: Maybe<CompanyOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<CompanyWhereUniqueInput>;
  after?: Maybe<CompanyWhereUniqueInput>;
};


export type QueryCompaniesCountArgs = {
  where?: Maybe<CompanyWhereInput>;
};


export type QueryConceptArgs = {
  where: ConceptWhereUniqueInput;
};


export type QueryConceptCountArgs = {
  where?: Maybe<ConceptWhereInput>;
};


export type QueryConceptsArgs = {
  where?: Maybe<ConceptWhereInput>;
  orderBy?: Maybe<ConceptOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ConceptWhereUniqueInput>;
  after?: Maybe<ConceptWhereUniqueInput>;
};


export type QueryDomainArgs = {
  where: DomainWhereUniqueInput;
};


export type QueryDomainsArgs = {
  where?: Maybe<DomainWhereInput>;
  orderBy?: Maybe<DomainOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<DomainWhereUniqueInput>;
  after?: Maybe<DomainWhereUniqueInput>;
};


export type QueryHorarioArgs = {
  where: HorarioWhereUniqueInput;
};


export type QueryHorariosArgs = {
  where?: Maybe<HorarioWhereInput>;
  orderBy?: Maybe<HorarioOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<HorarioWhereUniqueInput>;
  after?: Maybe<HorarioWhereUniqueInput>;
};


export type QueryHorariosCountArgs = {
  where?: Maybe<HorarioWhereInput>;
};


export type QueryMarketerArgs = {
  where: MarketerWhereUniqueInput;
};


export type QueryMarketersArgs = {
  where?: Maybe<MarketerWhereInput>;
  orderBy?: Maybe<MarketerOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<MarketerWhereUniqueInput>;
  after?: Maybe<MarketerWhereUniqueInput>;
};


export type QueryMarketersCountArgs = {
  where?: Maybe<MarketerWhereInput>;
};


export type QueryMeterArgs = {
  where: MeterWhereUniqueInput;
};


export type QueryMetersArgs = {
  where?: Maybe<MeterWhereInput>;
  orderBy?: Maybe<MeterOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<MeterWhereUniqueInput>;
  after?: Maybe<MeterWhereUniqueInput>;
};


export type QueryMetersCountArgs = {
  where?: Maybe<MeterWhereInput>;
};


export type QueryPaymentMethodArgs = {
  where: PaymentMethodWhereUniqueInput;
};


export type QueryPaymentMethodsArgs = {
  where?: Maybe<PaymentMethodWhereInput>;
  orderBy?: Maybe<PaymentMethodOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PaymentMethodWhereUniqueInput>;
  after?: Maybe<PaymentMethodWhereUniqueInput>;
};


export type QueryPaymentMethodMarketerArgs = {
  where: PaymentMethodMarketerWhereUniqueInput;
};


export type QueryPaymentMethodMarketersArgs = {
  where?: Maybe<PaymentMethodMarketerWhereInput>;
  orderBy?: Maybe<PaymentMethodMarketerOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
  after?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
};


export type QueryPlaceArgs = {
  where: PlaceWhereUniqueInput;
};


export type QueryPlacesArgs = {
  where?: Maybe<PlaceWhereInput>;
  orderBy?: Maybe<PlaceOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PlaceWhereUniqueInput>;
  after?: Maybe<PlaceWhereUniqueInput>;
};


export type QueryPlacesCountArgs = {
  where?: Maybe<PlaceWhereInput>;
};


export type QueryPropertyLevelArgs = {
  where: PropertyLevelWhereUniqueInput;
};


export type QueryPropertyLevelsArgs = {
  where?: Maybe<PropertyLevelWhereInput>;
  orderBy?: Maybe<PropertyLevelOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PropertyLevelWhereUniqueInput>;
  after?: Maybe<PropertyLevelWhereUniqueInput>;
};


export type QueryPropertyLevelsCountArgs = {
  where?: Maybe<PropertyLevelWhereInput>;
};


export type QueryReportStatusArgs = {
  where: ReportStatusWhereUniqueInput;
};


export type QueryReportStatusesArgs = {
  where?: Maybe<ReportStatusWhereInput>;
  orderBy?: Maybe<ReportStatusOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ReportStatusWhereUniqueInput>;
  after?: Maybe<ReportStatusWhereUniqueInput>;
};


export type QueryReportStatusCountArgs = {
  where?: Maybe<ReportStatusWhereInput>;
};


export type QueryRegionalArgs = {
  where: RegionalWhereUniqueInput;
};


export type QueryRegionalsArgs = {
  where?: Maybe<RegionalWhereInput>;
  orderBy?: Maybe<RegionalOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<RegionalWhereUniqueInput>;
  after?: Maybe<RegionalWhereUniqueInput>;
};


export type QueryRegionalsCountArgs = {
  where?: Maybe<RegionalWhereInput>;
};


export type QueryRegionalUserArgs = {
  where: RegionalUserWhereUniqueInput;
};


export type QueryRegionalUsersArgs = {
  where?: Maybe<RegionalUserWhereInput>;
  orderBy?: Maybe<RegionalUserOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<RegionalUserWhereUniqueInput>;
  after?: Maybe<RegionalUserWhereUniqueInput>;
};


export type QueryRegionalUserCountArgs = {
  where?: Maybe<RegionalUserWhereInput>;
};


export type QueryRolArgs = {
  where: RolWhereUniqueInput;
};


export type QueryRolsArgs = {
  where?: Maybe<RolWhereInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<RolWhereUniqueInput>;
  after?: Maybe<RolWhereUniqueInput>;
};


export type QueryServiceArgs = {
  where: ServiceWhereUniqueInput;
};


export type QueryServicesArgs = {
  where?: Maybe<ServiceWhereInput>;
  orderBy?: Maybe<ServiceOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ServiceWhereUniqueInput>;
  after?: Maybe<ServiceWhereUniqueInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  where?: Maybe<UserWhereInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<UserWhereUniqueInput>;
  after?: Maybe<UserWhereUniqueInput>;
};


export type QueryBillsByUserArgs = {
  payload?: Maybe<BillsByUserInput>;
};


export type QueryUserApplicationRolArgs = {
  where: UserApplicationRolWhereUniqueInput;
};


export type QueryUserApplicationRolsArgs = {
  where?: Maybe<UserApplicationRolWhereInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<UserApplicationRolWhereUniqueInput>;
  after?: Maybe<UserApplicationRolWhereUniqueInput>;
};


export type QuerySettingArgs = {
  where: SettingWhereUniqueInput;
};


export type QuerySettingsArgs = {
  where?: Maybe<SettingWhereInput>;
  orderBy?: Maybe<SettingOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<SettingWhereUniqueInput>;
  after?: Maybe<SettingWhereUniqueInput>;
};


export type QuerySettingsCountArgs = {
  where?: Maybe<SettingWhereInput>;
};

export type RegionalUser = {
  __typename?: 'RegionalUser';
  id: Scalars['String'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  user_id: Scalars['String'];
  user_name: Scalars['String'];
  user_email: Scalars['String'];
  user_login: Scalars['String'];
  user_type: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type RegionalUserCreateInput = {
  id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  user_id: Scalars['String'];
  user_name: Scalars['String'];
  user_email: Scalars['String'];
  user_login: Scalars['String'];
  user_type: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyCreateOneWithoutRegionalsUsersInput>;
};

export type RegionalUserCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<RegionalUserCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<RegionalUserWhereUniqueInput>>;
};

export type RegionalUserCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  user_id: Scalars['String'];
  user_name: Scalars['String'];
  user_email: Scalars['String'];
  user_login: Scalars['String'];
  user_type: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type RegionalUserFilter = {
  every?: Maybe<RegionalUserWhereInput>;
  some?: Maybe<RegionalUserWhereInput>;
  none?: Maybe<RegionalUserWhereInput>;
};

export type RegionalUserOrderByInput = {
  id?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  company_name?: Maybe<OrderByArg>;
  regional_id?: Maybe<OrderByArg>;
  regional_name?: Maybe<OrderByArg>;
  user_id?: Maybe<OrderByArg>;
  user_name?: Maybe<OrderByArg>;
  user_email?: Maybe<OrderByArg>;
  user_login?: Maybe<OrderByArg>;
  user_type?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type RegionalUserScalarWhereInput = {
  id?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  company_name?: Maybe<NullableStringFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<StringFilter>;
  user_id?: Maybe<StringFilter>;
  user_name?: Maybe<StringFilter>;
  user_email?: Maybe<StringFilter>;
  user_login?: Maybe<StringFilter>;
  user_type?: Maybe<StringFilter>;
  created_at?: Maybe<NullableDateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<RegionalUserScalarWhereInput>>;
  OR?: Maybe<Array<RegionalUserScalarWhereInput>>;
  NOT?: Maybe<Array<RegionalUserScalarWhereInput>>;
};

export type RegionalUserUpdateInput = {
  id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
  user_login?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneWithoutRegionalsUsersInput>;
};

export type RegionalUserUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
  user_login?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type RegionalUserUpdateManyWithWhereNestedInput = {
  where: RegionalUserScalarWhereInput;
  data: RegionalUserUpdateManyDataInput;
};

export type RegionalUserUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<RegionalUserCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<RegionalUserWhereUniqueInput>>;
  set?: Maybe<Array<RegionalUserWhereUniqueInput>>;
  disconnect?: Maybe<Array<RegionalUserWhereUniqueInput>>;
  delete?: Maybe<Array<RegionalUserWhereUniqueInput>>;
  update?: Maybe<Array<RegionalUserUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<RegionalUserUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<RegionalUserScalarWhereInput>>;
  upsert?: Maybe<Array<RegionalUserUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type RegionalUserUpdateWithWhereUniqueWithoutCompanyInput = {
  where: RegionalUserWhereUniqueInput;
  data: RegionalUserUpdateWithoutCompanyDataInput;
};

export type RegionalUserUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
  user_login?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type RegionalUserUpsertWithWhereUniqueWithoutCompanyInput = {
  where: RegionalUserWhereUniqueInput;
  update: RegionalUserUpdateWithoutCompanyDataInput;
  create: RegionalUserCreateWithoutCompanyInput;
};

export type RegionalUserWhereInput = {
  id?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  company_name?: Maybe<NullableStringFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<StringFilter>;
  user_id?: Maybe<StringFilter>;
  user_name?: Maybe<StringFilter>;
  user_email?: Maybe<StringFilter>;
  user_login?: Maybe<StringFilter>;
  user_type?: Maybe<StringFilter>;
  created_at?: Maybe<NullableDateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<RegionalUserWhereInput>>;
  OR?: Maybe<Array<RegionalUserWhereInput>>;
  NOT?: Maybe<Array<RegionalUserWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
};

export type RegionalUserWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  UniqueCompanyRegionalUserTypeIndex?: Maybe<UniqueCompanyRegionalUserTypeIndexCompoundUniqueInput>;
};

export type SearchBills = {
  __typename?: 'SearchBills';
  registros: Array<Bills>;
};

export type SelectBillsInput = {
  regional?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  marketers?: Maybe<Array<Scalars['String']>>;
  order_by?: Maybe<SelectBillsOrder>;
};

export type SelectBillsOrder = {
  mes?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Boolean']>;
};

export type StringFilter = {
  equals?: Maybe<Scalars['String']>;
  not?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  notIn?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  reportUpdated: ReportStatus;
};

export enum TypeOfBill {
  Factura = 'FACTURA',
  CuentaDeCobro = 'CUENTA_DE_COBRO'
}

export type UniqueAccountAndNumberAndCompanyIndexCompoundUniqueInput = {
  id: Scalars['String'];
  number: Scalars['String'];
  company_id: Scalars['String'];
};

export type UniqueAccountAndServiceIndexCompoundUniqueInput = {
  name: Scalars['String'];
  service_id: Scalars['String'];
};

export type UniqueCompanyRegionalUserTypeIndexCompoundUniqueInput = {
  company_id: Scalars['String'];
  regional_id: Scalars['String'];
  user_id: Scalars['String'];
  user_type: Scalars['String'];
};

export type UniquePlaceAndCompanyIndexCompoundUniqueInput = {
  name: Scalars['String'];
  regional_id: Scalars['String'];
  company_id: Scalars['String'];
};

export type UniqueRegionalAndCompanyIndexCompoundUniqueInput = {
  name: Scalars['String'];
  company_id: Scalars['String'];
};

export type UserFactura = {
  __typename?: 'UserFactura';
  /** id usuario */
  id: Scalars['String'];
  /** Nombre usuario */
  name: Scalars['String'];
};

export type Account = {
  __typename?: 'account';
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay: Scalars['Boolean'];
  account_parent?: Maybe<Scalars['String']>;
  payment_aut: Scalars['Boolean'];
  id: Scalars['String'];
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  place_id: Scalars['String'];
  place: Place;
  place_name?: Maybe<Scalars['String']>;
  service_id?: Maybe<Scalars['String']>;
  service?: Maybe<Service>;
  service_name?: Maybe<Scalars['String']>;
  sdl_id?: Maybe<Scalars['String']>;
  sdl?: Maybe<Sdl>;
  sdl_name?: Maybe<Scalars['String']>;
  property_level_id?: Maybe<Scalars['String']>;
  property_level?: Maybe<PropertyLevel>;
  marketer_id?: Maybe<Scalars['String']>;
  marketer?: Maybe<Marketer>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_id: Scalars['String'];
  company: Company;
  company_name?: Maybe<Scalars['String']>;
  regional_id: Scalars['String'];
  regional: Regional;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
};

export type AccountCreateInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place: PlaceCreateOneWithoutAccountsInput;
  service?: Maybe<ServiceCreateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelCreateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerCreateOneWithoutAccountsInput>;
  company: CompanyCreateOneWithoutAccountInput;
  regional: RegionalCreateOneWithoutAccountInput;
};

export type AccountCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<AccountCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountCreateManyWithoutMarketerInput = {
  create?: Maybe<Array<AccountCreateWithoutMarketerInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountCreateManyWithoutPlaceInput = {
  create?: Maybe<Array<AccountCreateWithoutPlaceInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountCreateManyWithoutProperty_LevelInput = {
  create?: Maybe<Array<AccountCreateWithoutProperty_LevelInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountCreateManyWithoutRegionalInput = {
  create?: Maybe<Array<AccountCreateWithoutRegionalInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountCreateManyWithoutServiceInput = {
  create?: Maybe<Array<AccountCreateWithoutServiceInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
};

export type AccountCreateWithoutCompanyInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place: PlaceCreateOneWithoutAccountsInput;
  service?: Maybe<ServiceCreateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelCreateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerCreateOneWithoutAccountsInput>;
  regional: RegionalCreateOneWithoutAccountInput;
};

export type AccountCreateWithoutMarketerInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place: PlaceCreateOneWithoutAccountsInput;
  service?: Maybe<ServiceCreateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelCreateOneWithoutAccountsInput>;
  company: CompanyCreateOneWithoutAccountInput;
  regional: RegionalCreateOneWithoutAccountInput;
};

export type AccountCreateWithoutPlaceInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  service?: Maybe<ServiceCreateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelCreateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerCreateOneWithoutAccountsInput>;
  company: CompanyCreateOneWithoutAccountInput;
  regional: RegionalCreateOneWithoutAccountInput;
};

export type AccountCreateWithoutProperty_LevelInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place: PlaceCreateOneWithoutAccountsInput;
  service?: Maybe<ServiceCreateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerCreateOneWithoutAccountsInput>;
  company: CompanyCreateOneWithoutAccountInput;
  regional: RegionalCreateOneWithoutAccountInput;
};

export type AccountCreateWithoutRegionalInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place: PlaceCreateOneWithoutAccountsInput;
  service?: Maybe<ServiceCreateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelCreateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerCreateOneWithoutAccountsInput>;
  company: CompanyCreateOneWithoutAccountInput;
};

export type AccountCreateWithoutServiceInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place: PlaceCreateOneWithoutAccountsInput;
  sdl?: Maybe<SdlCreateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelCreateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerCreateOneWithoutAccountsInput>;
  company: CompanyCreateOneWithoutAccountInput;
  regional: RegionalCreateOneWithoutAccountInput;
};

export type AccountFilter = {
  every?: Maybe<AccountWhereInput>;
  some?: Maybe<AccountWhereInput>;
  none?: Maybe<AccountWhereInput>;
};

export type AccountOrderByInput = {
  account_parent?: Maybe<OrderByArg>;
  id?: Maybe<OrderByArg>;
  budget?: Maybe<OrderByArg>;
  vertebra_pay?: Maybe<OrderByArg>;
  payment_aut?: Maybe<OrderByArg>;
  number?: Maybe<OrderByArg>;
  place_id?: Maybe<OrderByArg>;
  place_name?: Maybe<OrderByArg>;
  service_id?: Maybe<OrderByArg>;
  service_name?: Maybe<OrderByArg>;
  sdl_id?: Maybe<OrderByArg>;
  sdl_name?: Maybe<OrderByArg>;
  property_level_id?: Maybe<OrderByArg>;
  frequency?: Maybe<OrderByArg>;
  estimate_issue_date?: Maybe<OrderByArg>;
  estimate_timely_payment_date?: Maybe<OrderByArg>;
  notification_email?: Maybe<OrderByArg>;
  marketer_id?: Maybe<OrderByArg>;
  marketer_name?: Maybe<OrderByArg>;
  numeral_v?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  company_name?: Maybe<OrderByArg>;
  regional_id?: Maybe<OrderByArg>;
  regional_name?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
  is_active?: Maybe<OrderByArg>;
};

export type AccountScalarWhereInput = {
  account_parent?: Maybe<NullableStringFilter>;
  id?: Maybe<StringFilter>;
  budget?: Maybe<NullableFloatFilter>;
  vertebra_pay?: Maybe<BooleanFilter>;
  payment_aut?: Maybe<BooleanFilter>;
  number?: Maybe<StringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<NullableStringFilter>;
  service_id?: Maybe<NullableStringFilter>;
  service_name?: Maybe<NullableStringFilter>;
  sdl_id?: Maybe<NullableStringFilter>;
  sdl_name?: Maybe<NullableStringFilter>;
  property_level_id?: Maybe<NullableStringFilter>;
  frequency?: Maybe<NullableStringFilter>;
  estimate_issue_date?: Maybe<NullableIntFilter>;
  estimate_timely_payment_date?: Maybe<NullableIntFilter>;
  notification_email?: Maybe<NullableStringFilter>;
  marketer_id?: Maybe<NullableStringFilter>;
  marketer_name?: Maybe<NullableStringFilter>;
  numeral_v?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  company_name?: Maybe<NullableStringFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<NullableStringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  AND?: Maybe<Array<AccountScalarWhereInput>>;
  OR?: Maybe<Array<AccountScalarWhereInput>>;
  NOT?: Maybe<Array<AccountScalarWhereInput>>;
};

export type AccountUpdateInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutAccountsInput>;
  service?: Maybe<ServiceUpdateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelUpdateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerUpdateOneWithoutAccountsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutAccountInput>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpdateManyDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
};

export type AccountUpdateManyWithWhereNestedInput = {
  where: AccountScalarWhereInput;
  data: AccountUpdateManyDataInput;
};

export type AccountUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<AccountCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  delete?: Maybe<Array<AccountWhereUniqueInput>>;
  update?: Maybe<Array<AccountUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<AccountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AccountScalarWhereInput>>;
  upsert?: Maybe<Array<AccountUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type AccountUpdateManyWithoutMarketerInput = {
  create?: Maybe<Array<AccountCreateWithoutMarketerInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  delete?: Maybe<Array<AccountWhereUniqueInput>>;
  update?: Maybe<Array<AccountUpdateWithWhereUniqueWithoutMarketerInput>>;
  updateMany?: Maybe<Array<AccountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AccountScalarWhereInput>>;
  upsert?: Maybe<Array<AccountUpsertWithWhereUniqueWithoutMarketerInput>>;
};

export type AccountUpdateManyWithoutPlaceInput = {
  create?: Maybe<Array<AccountCreateWithoutPlaceInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  delete?: Maybe<Array<AccountWhereUniqueInput>>;
  update?: Maybe<Array<AccountUpdateWithWhereUniqueWithoutPlaceInput>>;
  updateMany?: Maybe<Array<AccountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AccountScalarWhereInput>>;
  upsert?: Maybe<Array<AccountUpsertWithWhereUniqueWithoutPlaceInput>>;
};

export type AccountUpdateManyWithoutProperty_LevelInput = {
  create?: Maybe<Array<AccountCreateWithoutProperty_LevelInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  delete?: Maybe<Array<AccountWhereUniqueInput>>;
  update?: Maybe<Array<AccountUpdateWithWhereUniqueWithoutProperty_LevelInput>>;
  updateMany?: Maybe<Array<AccountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AccountScalarWhereInput>>;
  upsert?: Maybe<Array<AccountUpsertWithWhereUniqueWithoutProperty_LevelInput>>;
};

export type AccountUpdateManyWithoutRegionalInput = {
  create?: Maybe<Array<AccountCreateWithoutRegionalInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  delete?: Maybe<Array<AccountWhereUniqueInput>>;
  update?: Maybe<Array<AccountUpdateWithWhereUniqueWithoutRegionalInput>>;
  updateMany?: Maybe<Array<AccountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AccountScalarWhereInput>>;
  upsert?: Maybe<Array<AccountUpsertWithWhereUniqueWithoutRegionalInput>>;
};

export type AccountUpdateManyWithoutServiceInput = {
  create?: Maybe<Array<AccountCreateWithoutServiceInput>>;
  connect?: Maybe<Array<AccountWhereUniqueInput>>;
  set?: Maybe<Array<AccountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AccountWhereUniqueInput>>;
  delete?: Maybe<Array<AccountWhereUniqueInput>>;
  update?: Maybe<Array<AccountUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<AccountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AccountScalarWhereInput>>;
  upsert?: Maybe<Array<AccountUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type AccountUpdateWithWhereUniqueWithoutCompanyInput = {
  where: AccountWhereUniqueInput;
  data: AccountUpdateWithoutCompanyDataInput;
};

export type AccountUpdateWithWhereUniqueWithoutMarketerInput = {
  where: AccountWhereUniqueInput;
  data: AccountUpdateWithoutMarketerDataInput;
};

export type AccountUpdateWithWhereUniqueWithoutPlaceInput = {
  where: AccountWhereUniqueInput;
  data: AccountUpdateWithoutPlaceDataInput;
};

export type AccountUpdateWithWhereUniqueWithoutProperty_LevelInput = {
  where: AccountWhereUniqueInput;
  data: AccountUpdateWithoutProperty_LevelDataInput;
};

export type AccountUpdateWithWhereUniqueWithoutRegionalInput = {
  where: AccountWhereUniqueInput;
  data: AccountUpdateWithoutRegionalDataInput;
};

export type AccountUpdateWithWhereUniqueWithoutServiceInput = {
  where: AccountWhereUniqueInput;
  data: AccountUpdateWithoutServiceDataInput;
};

export type AccountUpdateWithoutCompanyDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutAccountsInput>;
  service?: Maybe<ServiceUpdateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelUpdateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerUpdateOneWithoutAccountsInput>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpdateWithoutMarketerDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutAccountsInput>;
  service?: Maybe<ServiceUpdateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelUpdateOneWithoutAccountsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutAccountInput>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpdateWithoutPlaceDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  service?: Maybe<ServiceUpdateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelUpdateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerUpdateOneWithoutAccountsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutAccountInput>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpdateWithoutProperty_LevelDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutAccountsInput>;
  service?: Maybe<ServiceUpdateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerUpdateOneWithoutAccountsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutAccountInput>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpdateWithoutRegionalDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutAccountsInput>;
  service?: Maybe<ServiceUpdateOneWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelUpdateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerUpdateOneWithoutAccountsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpdateWithoutServiceDataInput = {
  account_parent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  estimate_issue_date?: Maybe<Scalars['Int']>;
  estimate_timely_payment_date?: Maybe<Scalars['Int']>;
  notification_email?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutAccountsInput>;
  sdl?: Maybe<SdlUpdateOneWithoutAccountsInput>;
  property_level?: Maybe<PropertyLevelUpdateOneWithoutAccountsInput>;
  marketer?: Maybe<MarketerUpdateOneWithoutAccountsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutAccountInput>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutAccountInput>;
};

export type AccountUpsertWithWhereUniqueWithoutCompanyInput = {
  where: AccountWhereUniqueInput;
  update: AccountUpdateWithoutCompanyDataInput;
  create: AccountCreateWithoutCompanyInput;
};

export type AccountUpsertWithWhereUniqueWithoutMarketerInput = {
  where: AccountWhereUniqueInput;
  update: AccountUpdateWithoutMarketerDataInput;
  create: AccountCreateWithoutMarketerInput;
};

export type AccountUpsertWithWhereUniqueWithoutPlaceInput = {
  where: AccountWhereUniqueInput;
  update: AccountUpdateWithoutPlaceDataInput;
  create: AccountCreateWithoutPlaceInput;
};

export type AccountUpsertWithWhereUniqueWithoutProperty_LevelInput = {
  where: AccountWhereUniqueInput;
  update: AccountUpdateWithoutProperty_LevelDataInput;
  create: AccountCreateWithoutProperty_LevelInput;
};

export type AccountUpsertWithWhereUniqueWithoutRegionalInput = {
  where: AccountWhereUniqueInput;
  update: AccountUpdateWithoutRegionalDataInput;
  create: AccountCreateWithoutRegionalInput;
};

export type AccountUpsertWithWhereUniqueWithoutServiceInput = {
  where: AccountWhereUniqueInput;
  update: AccountUpdateWithoutServiceDataInput;
  create: AccountCreateWithoutServiceInput;
};

export type AccountWhereInput = {
  account_parent?: Maybe<NullableStringFilter>;
  id?: Maybe<StringFilter>;
  budget?: Maybe<NullableFloatFilter>;
  vertebra_pay?: Maybe<BooleanFilter>;
  payment_aut?: Maybe<BooleanFilter>;
  number?: Maybe<StringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<NullableStringFilter>;
  service_id?: Maybe<NullableStringFilter>;
  service_name?: Maybe<NullableStringFilter>;
  sdl_id?: Maybe<NullableStringFilter>;
  sdl_name?: Maybe<NullableStringFilter>;
  property_level_id?: Maybe<NullableStringFilter>;
  frequency?: Maybe<NullableStringFilter>;
  estimate_issue_date?: Maybe<NullableIntFilter>;
  estimate_timely_payment_date?: Maybe<NullableIntFilter>;
  notification_email?: Maybe<NullableStringFilter>;
  marketer_id?: Maybe<NullableStringFilter>;
  marketer_name?: Maybe<NullableStringFilter>;
  numeral_v?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  company_name?: Maybe<NullableStringFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<NullableStringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  AND?: Maybe<Array<AccountWhereInput>>;
  OR?: Maybe<Array<AccountWhereInput>>;
  NOT?: Maybe<Array<AccountWhereInput>>;
  place?: Maybe<PlaceWhereInput>;
  service?: Maybe<ServiceWhereInput>;
  sdl?: Maybe<SdlWhereInput>;
  property_level?: Maybe<PropertyLevelWhereInput>;
  marketer?: Maybe<MarketerWhereInput>;
  company?: Maybe<CompanyWhereInput>;
  regional?: Maybe<RegionalWhereInput>;
};

export type AccountWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  UniqueAccountAndNumberAndCompanyIndex?: Maybe<UniqueAccountAndNumberAndCompanyIndexCompoundUniqueInput>;
};

export type Amount = {
  __typename?: 'amount';
  id: Scalars['String'];
  price: Scalars['Float'];
  bill_id: Scalars['String'];
  bill: Bill;
  concept_id: Scalars['String'];
  concept: Concept;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  concept_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type AmountCreateManyWithoutBillInput = {
  create?: Maybe<Array<AmountCreateWithoutBillInput>>;
  connect?: Maybe<Array<AmountWhereUniqueInput>>;
};

export type AmountCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<AmountCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<AmountWhereUniqueInput>>;
};

export type AmountCreateManyWithoutConceptInput = {
  create?: Maybe<Array<AmountCreateWithoutConceptInput>>;
  connect?: Maybe<Array<AmountWhereUniqueInput>>;
};

export type AmountCreateWithoutBillInput = {
  id?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  concept_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  concept: ConceptCreateOneWithoutAmountInput;
  company?: Maybe<CompanyCreateOneWithoutAmountInput>;
};

export type AmountCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  concept_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill: BillCreateOneWithoutAmountsInput;
  concept: ConceptCreateOneWithoutAmountInput;
};

export type AmountCreateWithoutConceptInput = {
  id?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  concept_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill: BillCreateOneWithoutAmountsInput;
  company?: Maybe<CompanyCreateOneWithoutAmountInput>;
};

export type AmountFilter = {
  every?: Maybe<AmountWhereInput>;
  some?: Maybe<AmountWhereInput>;
  none?: Maybe<AmountWhereInput>;
};

export type AmountOrderByInput = {
  id?: Maybe<OrderByArg>;
  price?: Maybe<OrderByArg>;
  bill_id?: Maybe<OrderByArg>;
  concept_id?: Maybe<OrderByArg>;
  companyId?: Maybe<OrderByArg>;
  concept_name?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type AmountScalarWhereInput = {
  id?: Maybe<StringFilter>;
  price?: Maybe<FloatFilter>;
  bill_id?: Maybe<StringFilter>;
  concept_id?: Maybe<StringFilter>;
  companyId?: Maybe<NullableStringFilter>;
  concept_name?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<AmountScalarWhereInput>>;
  OR?: Maybe<Array<AmountScalarWhereInput>>;
  NOT?: Maybe<Array<AmountScalarWhereInput>>;
};

export type AmountUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  concept_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type AmountUpdateManyWithWhereNestedInput = {
  where: AmountScalarWhereInput;
  data: AmountUpdateManyDataInput;
};

export type AmountUpdateManyWithoutBillInput = {
  create?: Maybe<Array<AmountCreateWithoutBillInput>>;
  connect?: Maybe<Array<AmountWhereUniqueInput>>;
  set?: Maybe<Array<AmountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AmountWhereUniqueInput>>;
  delete?: Maybe<Array<AmountWhereUniqueInput>>;
  update?: Maybe<Array<AmountUpdateWithWhereUniqueWithoutBillInput>>;
  updateMany?: Maybe<Array<AmountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AmountScalarWhereInput>>;
  upsert?: Maybe<Array<AmountUpsertWithWhereUniqueWithoutBillInput>>;
};

export type AmountUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<AmountCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<AmountWhereUniqueInput>>;
  set?: Maybe<Array<AmountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AmountWhereUniqueInput>>;
  delete?: Maybe<Array<AmountWhereUniqueInput>>;
  update?: Maybe<Array<AmountUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<AmountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AmountScalarWhereInput>>;
  upsert?: Maybe<Array<AmountUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type AmountUpdateManyWithoutConceptInput = {
  create?: Maybe<Array<AmountCreateWithoutConceptInput>>;
  connect?: Maybe<Array<AmountWhereUniqueInput>>;
  set?: Maybe<Array<AmountWhereUniqueInput>>;
  disconnect?: Maybe<Array<AmountWhereUniqueInput>>;
  delete?: Maybe<Array<AmountWhereUniqueInput>>;
  update?: Maybe<Array<AmountUpdateWithWhereUniqueWithoutConceptInput>>;
  updateMany?: Maybe<Array<AmountUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<AmountScalarWhereInput>>;
  upsert?: Maybe<Array<AmountUpsertWithWhereUniqueWithoutConceptInput>>;
};

export type AmountUpdateWithWhereUniqueWithoutBillInput = {
  where: AmountWhereUniqueInput;
  data: AmountUpdateWithoutBillDataInput;
};

export type AmountUpdateWithWhereUniqueWithoutCompanyInput = {
  where: AmountWhereUniqueInput;
  data: AmountUpdateWithoutCompanyDataInput;
};

export type AmountUpdateWithWhereUniqueWithoutConceptInput = {
  where: AmountWhereUniqueInput;
  data: AmountUpdateWithoutConceptDataInput;
};

export type AmountUpdateWithoutBillDataInput = {
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  concept_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  concept?: Maybe<ConceptUpdateOneRequiredWithoutAmountInput>;
  company?: Maybe<CompanyUpdateOneWithoutAmountInput>;
};

export type AmountUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  concept_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill?: Maybe<BillUpdateOneRequiredWithoutAmountsInput>;
  concept?: Maybe<ConceptUpdateOneRequiredWithoutAmountInput>;
};

export type AmountUpdateWithoutConceptDataInput = {
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  concept_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill?: Maybe<BillUpdateOneRequiredWithoutAmountsInput>;
  company?: Maybe<CompanyUpdateOneWithoutAmountInput>;
};

export type AmountUpsertWithWhereUniqueWithoutBillInput = {
  where: AmountWhereUniqueInput;
  update: AmountUpdateWithoutBillDataInput;
  create: AmountCreateWithoutBillInput;
};

export type AmountUpsertWithWhereUniqueWithoutCompanyInput = {
  where: AmountWhereUniqueInput;
  update: AmountUpdateWithoutCompanyDataInput;
  create: AmountCreateWithoutCompanyInput;
};

export type AmountUpsertWithWhereUniqueWithoutConceptInput = {
  where: AmountWhereUniqueInput;
  update: AmountUpdateWithoutConceptDataInput;
  create: AmountCreateWithoutConceptInput;
};

export type AmountWhereInput = {
  id?: Maybe<StringFilter>;
  price?: Maybe<FloatFilter>;
  bill_id?: Maybe<StringFilter>;
  concept_id?: Maybe<StringFilter>;
  companyId?: Maybe<NullableStringFilter>;
  concept_name?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<AmountWhereInput>>;
  OR?: Maybe<Array<AmountWhereInput>>;
  NOT?: Maybe<Array<AmountWhereInput>>;
  bill?: Maybe<BillWhereInput>;
  concept?: Maybe<ConceptWhereInput>;
  company?: Maybe<CompanyWhereInput>;
};

export type AmountWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Application = {
  __typename?: 'application';
  id: Scalars['String'];
  name: Scalars['String'];
  roles_aplication: Array<UserApplicationRol>;
  rol: Array<Rol>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type ApplicationRoles_AplicationArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<UserApplicationRolWhereUniqueInput>;
  after?: Maybe<UserApplicationRolWhereUniqueInput>;
};


export type ApplicationRolArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<RolWhereUniqueInput>;
  after?: Maybe<RolWhereUniqueInput>;
};

export type ApplicationCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutApplicationsInput>;
  rol?: Maybe<RolCreateManyWithoutApplicationInput>;
};

export type ApplicationCreateOneWithoutRolInput = {
  create?: Maybe<ApplicationCreateWithoutRolInput>;
  connect?: Maybe<ApplicationWhereUniqueInput>;
};

export type ApplicationCreateOneWithoutRoles_AplicationInput = {
  create?: Maybe<ApplicationCreateWithoutRoles_AplicationInput>;
  connect?: Maybe<ApplicationWhereUniqueInput>;
};

export type ApplicationCreateWithoutRolInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutApplicationsInput>;
};

export type ApplicationCreateWithoutRoles_AplicationInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  rol?: Maybe<RolCreateManyWithoutApplicationInput>;
};

export type ApplicationUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutApplicationsInput>;
  rol?: Maybe<RolUpdateManyWithoutApplicationInput>;
};

export type ApplicationUpdateOneRequiredWithoutRolInput = {
  create?: Maybe<ApplicationCreateWithoutRolInput>;
  connect?: Maybe<ApplicationWhereUniqueInput>;
  update?: Maybe<ApplicationUpdateWithoutRolDataInput>;
  upsert?: Maybe<ApplicationUpsertWithoutRolInput>;
};

export type ApplicationUpdateOneRequiredWithoutRoles_AplicationInput = {
  create?: Maybe<ApplicationCreateWithoutRoles_AplicationInput>;
  connect?: Maybe<ApplicationWhereUniqueInput>;
  update?: Maybe<ApplicationUpdateWithoutRoles_AplicationDataInput>;
  upsert?: Maybe<ApplicationUpsertWithoutRoles_AplicationInput>;
};

export type ApplicationUpdateWithoutRolDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutApplicationsInput>;
};

export type ApplicationUpdateWithoutRoles_AplicationDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  rol?: Maybe<RolUpdateManyWithoutApplicationInput>;
};

export type ApplicationUpsertWithoutRolInput = {
  update: ApplicationUpdateWithoutRolDataInput;
  create: ApplicationCreateWithoutRolInput;
};

export type ApplicationUpsertWithoutRoles_AplicationInput = {
  update: ApplicationUpdateWithoutRoles_AplicationDataInput;
  create: ApplicationCreateWithoutRoles_AplicationInput;
};

export type ApplicationWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  roles_aplication?: Maybe<UserApplicationRolFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  rol?: Maybe<RolFilter>;
  AND?: Maybe<Array<ApplicationWhereInput>>;
  OR?: Maybe<Array<ApplicationWhereInput>>;
  NOT?: Maybe<Array<ApplicationWhereInput>>;
};

export type ApplicationWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Audit = {
  __typename?: 'audit';
  id: Scalars['String'];
  user_id: Scalars['String'];
  operation: Scalars['String'];
  operation_date?: Maybe<Scalars['DateTime']>;
  old_data?: Maybe<Scalars['Json']>;
  new_data?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type AuditCreateInput = {
  id?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  operation: Scalars['String'];
  old_data?: Maybe<Scalars['Json']>;
  new_data?: Maybe<Scalars['Json']>;
  operation_date?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type AuditOrderByInput = {
  id?: Maybe<OrderByArg>;
  user_id?: Maybe<OrderByArg>;
  operation?: Maybe<OrderByArg>;
  old_data?: Maybe<OrderByArg>;
  new_data?: Maybe<OrderByArg>;
  operation_date?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type AuditUpdateInput = {
  id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['String']>;
  old_data?: Maybe<Scalars['Json']>;
  new_data?: Maybe<Scalars['Json']>;
  operation_date?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type AuditWhereInput = {
  id?: Maybe<StringFilter>;
  user_id?: Maybe<StringFilter>;
  operation?: Maybe<StringFilter>;
  operation_date?: Maybe<NullableDateTimeFilter>;
  created_at?: Maybe<NullableDateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<AuditWhereInput>>;
  OR?: Maybe<Array<AuditWhereInput>>;
  NOT?: Maybe<Array<AuditWhereInput>>;
};

export type AuditWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Bank = {
  __typename?: 'bank';
  id: Scalars['String'];
  nit: Scalars['String'];
  name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  PaymentMethodMarketer: Array<PaymentMethodMarketer>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type BankPaymentMethodMarketerArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
  after?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
};

export type BankCreateInput = {
  id?: Maybe<Scalars['String']>;
  nit: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerCreateManyWithoutBankInput>;
};

export type BankCreateOneWithoutPaymentMethodMarketerInput = {
  create?: Maybe<BankCreateWithoutPaymentMethodMarketerInput>;
  connect?: Maybe<BankWhereUniqueInput>;
};

export type BankCreateWithoutPaymentMethodMarketerInput = {
  id?: Maybe<Scalars['String']>;
  nit: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type BankOrderByInput = {
  id?: Maybe<OrderByArg>;
  nit?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  status?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type BankUpdateInput = {
  id?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerUpdateManyWithoutBankInput>;
};

export type BankUpdateOneRequiredWithoutPaymentMethodMarketerInput = {
  create?: Maybe<BankCreateWithoutPaymentMethodMarketerInput>;
  connect?: Maybe<BankWhereUniqueInput>;
  update?: Maybe<BankUpdateWithoutPaymentMethodMarketerDataInput>;
  upsert?: Maybe<BankUpsertWithoutPaymentMethodMarketerInput>;
};

export type BankUpdateWithoutPaymentMethodMarketerDataInput = {
  id?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type BankUpsertWithoutPaymentMethodMarketerInput = {
  update: BankUpdateWithoutPaymentMethodMarketerDataInput;
  create: BankCreateWithoutPaymentMethodMarketerInput;
};

export type BankWhereInput = {
  id?: Maybe<StringFilter>;
  nit?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<BooleanFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerFilter>;
  AND?: Maybe<Array<BankWhereInput>>;
  OR?: Maybe<Array<BankWhereInput>>;
  NOT?: Maybe<Array<BankWhereInput>>;
};

export type BankWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Bill = {
  __typename?: 'bill';
  id: Scalars['String'];
  warnings?: Maybe<Scalars['Json']>;
  account_parent?: Maybe<Scalars['String']>;
  vertebra_pay: Scalars['Boolean'];
  payment_aut: Scalars['Boolean'];
  budget?: Maybe<Scalars['Float']>;
  is_legible: Scalars['Boolean'];
  payment_reference?: Maybe<Scalars['String']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_id?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  marketer?: Maybe<Marketer>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_id?: Maybe<Scalars['String']>;
  payment_method_marketer?: Maybe<PaymentMethodMarketer>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  cash_source_id?: Maybe<Scalars['String']>;
  cash_source?: Maybe<CashSource>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_id: Scalars['String'];
  service: Service;
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  amounts: Array<Amount>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  user_id: Scalars['String'];
  user: User;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  real_payment?: Maybe<Scalars['Float']>;
  is_approved_movii: Scalars['Boolean'];
  voluntary_contribution?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type BillAmountsArgs = {
  where?: Maybe<AmountWhereInput>;
  orderBy?: Maybe<AmountOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AmountWhereUniqueInput>;
  after?: Maybe<AmountWhereUniqueInput>;
};

export type BillByUser = {
  __typename?: 'billByUser';
  id: Scalars['String'];
  name: Scalars['String'];
  last_name: Scalars['String'];
  total: Scalars['Int'];
  services: Array<CountTotalService>;
};

export type BillCreate = {
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  service_id?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  marketer_id?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  date_bill?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  payment_date?: Maybe<Scalars['String']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
};

export type BillCreateInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerCreateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceCreateOneWithoutBillInput>;
  service: ServiceCreateOneWithoutBillInput;
  amounts?: Maybe<AmountCreateManyWithoutBillInput>;
  user: UserCreateOneWithoutBillInput;
};

export type BillCreateManyWithoutCash_SourceInput = {
  create?: Maybe<Array<BillCreateWithoutCash_SourceInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
};

export type BillCreateManyWithoutMarketerInput = {
  create?: Maybe<Array<BillCreateWithoutMarketerInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
};

export type BillCreateManyWithoutPayment_Method_MarketerInput = {
  create?: Maybe<Array<BillCreateWithoutPayment_Method_MarketerInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
};

export type BillCreateManyWithoutServiceInput = {
  create?: Maybe<Array<BillCreateWithoutServiceInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
};

export type BillCreateManyWithoutUserInput = {
  create?: Maybe<Array<BillCreateWithoutUserInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
};

export type BillCreateOneWithoutAmountsInput = {
  create?: Maybe<BillCreateWithoutAmountsInput>;
  connect?: Maybe<BillWhereUniqueInput>;
};

export type BillCreateWithoutAmountsInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerCreateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceCreateOneWithoutBillInput>;
  service: ServiceCreateOneWithoutBillInput;
  user: UserCreateOneWithoutBillInput;
};

export type BillCreateWithoutCash_SourceInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerCreateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateOneWithoutBillInput>;
  service: ServiceCreateOneWithoutBillInput;
  amounts?: Maybe<AmountCreateManyWithoutBillInput>;
  user: UserCreateOneWithoutBillInput;
};

export type BillCreateWithoutMarketerInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceCreateOneWithoutBillInput>;
  service: ServiceCreateOneWithoutBillInput;
  amounts?: Maybe<AmountCreateManyWithoutBillInput>;
  user: UserCreateOneWithoutBillInput;
};

export type BillCreateWithoutPayment_Method_MarketerInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerCreateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceCreateOneWithoutBillInput>;
  service: ServiceCreateOneWithoutBillInput;
  amounts?: Maybe<AmountCreateManyWithoutBillInput>;
  user: UserCreateOneWithoutBillInput;
};

export type BillCreateWithoutServiceInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerCreateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceCreateOneWithoutBillInput>;
  amounts?: Maybe<AmountCreateManyWithoutBillInput>;
  user: UserCreateOneWithoutBillInput;
};

export type BillCreateWithoutUserInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  company_id: Scalars['String'];
  company_name: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  account_id: Scalars['String'];
  account_name: Scalars['String'];
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill: Scalars['DateTime'];
  service_name: Scalars['String'];
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name: Scalars['String'];
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerCreateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerCreateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceCreateOneWithoutBillInput>;
  service: ServiceCreateOneWithoutBillInput;
  amounts?: Maybe<AmountCreateManyWithoutBillInput>;
};

export type BillFilter = {
  every?: Maybe<BillWhereInput>;
  some?: Maybe<BillWhereInput>;
  none?: Maybe<BillWhereInput>;
};

export type BillOrderByInput = {
  id?: Maybe<OrderByArg>;
  warnings?: Maybe<OrderByArg>;
  payment_reference?: Maybe<OrderByArg>;
  account_parent?: Maybe<OrderByArg>;
  is_legible?: Maybe<OrderByArg>;
  budget?: Maybe<OrderByArg>;
  vertebra_pay?: Maybe<OrderByArg>;
  payment_aut?: Maybe<OrderByArg>;
  regional_id?: Maybe<OrderByArg>;
  regional_name?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  company_name?: Maybe<OrderByArg>;
  place_id?: Maybe<OrderByArg>;
  place_name?: Maybe<OrderByArg>;
  account_id?: Maybe<OrderByArg>;
  account_name?: Maybe<OrderByArg>;
  marketer_id?: Maybe<OrderByArg>;
  marketer_name?: Maybe<OrderByArg>;
  number_bill?: Maybe<OrderByArg>;
  average?: Maybe<OrderByArg>;
  issue_date?: Maybe<OrderByArg>;
  suspension_date?: Maybe<OrderByArg>;
  timely_payment_date?: Maybe<OrderByArg>;
  begin_date?: Maybe<OrderByArg>;
  end_date?: Maybe<OrderByArg>;
  voucher_number?: Maybe<OrderByArg>;
  date_paid?: Maybe<OrderByArg>;
  payment_method_marketer_id?: Maybe<OrderByArg>;
  payment_method_marketer_name?: Maybe<OrderByArg>;
  real_payment?: Maybe<OrderByArg>;
  cash_source_id?: Maybe<OrderByArg>;
  cash_source_name?: Maybe<OrderByArg>;
  image_bill?: Maybe<OrderByArg>;
  image_voucher?: Maybe<OrderByArg>;
  observation?: Maybe<OrderByArg>;
  date_bill?: Maybe<OrderByArg>;
  service_id?: Maybe<OrderByArg>;
  service_name?: Maybe<OrderByArg>;
  type_of_bill?: Maybe<OrderByArg>;
  public_lighting?: Maybe<OrderByArg>;
  total_others?: Maybe<OrderByArg>;
  user_id?: Maybe<OrderByArg>;
  user_name?: Maybe<OrderByArg>;
  status_bill?: Maybe<OrderByArg>;
  general_bill_description?: Maybe<OrderByArg>;
  voluntary_contribution?: Maybe<OrderByArg>;
  general_bill_amount?: Maybe<OrderByArg>;
  total?: Maybe<OrderByArg>;
  cleaning_price?: Maybe<OrderByArg>;
  cleaning_contribution?: Maybe<OrderByArg>;
  cleaning_total?: Maybe<OrderByArg>;
  amounts_not_justificate?: Maybe<OrderByArg>;
  energy_current_measure_active?: Maybe<OrderByArg>;
  energy_last_measure_active?: Maybe<OrderByArg>;
  energy_factor_active?: Maybe<OrderByArg>;
  energy_consumption_active?: Maybe<OrderByArg>;
  energy_rate_active?: Maybe<OrderByArg>;
  energy_price_active?: Maybe<OrderByArg>;
  energy_price_contribution_active?: Maybe<OrderByArg>;
  energy_current_measure_reactive?: Maybe<OrderByArg>;
  energy_last_measure_reactive?: Maybe<OrderByArg>;
  energy_factor_reactive?: Maybe<OrderByArg>;
  energy_consumption_reactive?: Maybe<OrderByArg>;
  energy_rate_reactive?: Maybe<OrderByArg>;
  energy_price_reactive?: Maybe<OrderByArg>;
  energy_price_contribution_reactive?: Maybe<OrderByArg>;
  energy_hours_interruption?: Maybe<OrderByArg>;
  energy_total?: Maybe<OrderByArg>;
  water_current_measure?: Maybe<OrderByArg>;
  water_consumption?: Maybe<OrderByArg>;
  water_last_measure?: Maybe<OrderByArg>;
  water_rate_basic_aqueduct?: Maybe<OrderByArg>;
  water_rate_compl_aqueduct?: Maybe<OrderByArg>;
  water_rate_sumpt_aqueduct?: Maybe<OrderByArg>;
  water_price_fixed_basic_aqueduct?: Maybe<OrderByArg>;
  water_price_fixed_compl_aqueduct?: Maybe<OrderByArg>;
  water_price_fixed_sumpt_aqueduct?: Maybe<OrderByArg>;
  water_price_aqueduct?: Maybe<OrderByArg>;
  water_contribution_aqueduct?: Maybe<OrderByArg>;
  water_contribution_price_fixed_aqueduct?: Maybe<OrderByArg>;
  water_rate_compl_sewerage?: Maybe<OrderByArg>;
  water_rate_basic_sewerage?: Maybe<OrderByArg>;
  water_rate_sumpt_sewerage?: Maybe<OrderByArg>;
  water_price_fixed_basic_sewerage?: Maybe<OrderByArg>;
  water_price_fixed_compl_sewerage?: Maybe<OrderByArg>;
  water_price_fixed_sumpt_sewerage?: Maybe<OrderByArg>;
  water_price_sewerage?: Maybe<OrderByArg>;
  water_price_fixed_aqueduct?: Maybe<OrderByArg>;
  water_price_fixed_sewerage?: Maybe<OrderByArg>;
  water_contribution_sewerage?: Maybe<OrderByArg>;
  water_contribution_price_fixed_sewerage?: Maybe<OrderByArg>;
  water_total?: Maybe<OrderByArg>;
  sewerage_total?: Maybe<OrderByArg>;
  user_transcriber?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  user_aproved_bill?: Maybe<OrderByArg>;
  user_uploaded_bill?: Maybe<OrderByArg>;
  user_uploaded_voucher?: Maybe<OrderByArg>;
  is_approved_movii?: Maybe<OrderByArg>;
  payment_date?: Maybe<OrderByArg>;
  date_bill_uploaded?: Maybe<OrderByArg>;
  date_voucher_uploaded?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type BillScalarWhereInput = {
  id?: Maybe<StringFilter>;
  payment_reference?: Maybe<NullableStringFilter>;
  account_parent?: Maybe<NullableStringFilter>;
  is_legible?: Maybe<BooleanFilter>;
  budget?: Maybe<NullableFloatFilter>;
  vertebra_pay?: Maybe<BooleanFilter>;
  payment_aut?: Maybe<BooleanFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  company_name?: Maybe<StringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  account_id?: Maybe<StringFilter>;
  account_name?: Maybe<StringFilter>;
  marketer_id?: Maybe<NullableStringFilter>;
  marketer_name?: Maybe<NullableStringFilter>;
  number_bill?: Maybe<NullableStringFilter>;
  average?: Maybe<NullableBooleanFilter>;
  issue_date?: Maybe<NullableDateTimeFilter>;
  suspension_date?: Maybe<NullableDateTimeFilter>;
  timely_payment_date?: Maybe<NullableDateTimeFilter>;
  begin_date?: Maybe<NullableDateTimeFilter>;
  end_date?: Maybe<NullableDateTimeFilter>;
  voucher_number?: Maybe<NullableStringFilter>;
  date_paid?: Maybe<NullableDateTimeFilter>;
  payment_method_marketer_id?: Maybe<NullableStringFilter>;
  payment_method_marketer_name?: Maybe<NullableStringFilter>;
  real_payment?: Maybe<NullableFloatFilter>;
  cash_source_id?: Maybe<NullableStringFilter>;
  cash_source_name?: Maybe<NullableStringFilter>;
  image_bill?: Maybe<NullableStringFilter>;
  image_voucher?: Maybe<NullableStringFilter>;
  observation?: Maybe<NullableStringFilter>;
  date_bill?: Maybe<DateTimeFilter>;
  service_id?: Maybe<StringFilter>;
  service_name?: Maybe<StringFilter>;
  type_of_bill?: Maybe<TypeOfBill>;
  amounts?: Maybe<AmountFilter>;
  public_lighting?: Maybe<NullableFloatFilter>;
  total_others?: Maybe<NullableFloatFilter>;
  user_id?: Maybe<StringFilter>;
  user_name?: Maybe<StringFilter>;
  status_bill?: Maybe<NullableStringFilter>;
  voluntary_contribution?: Maybe<NullableFloatFilter>;
  general_bill_amount?: Maybe<NullableFloatFilter>;
  total?: Maybe<NullableFloatFilter>;
  cleaning_price?: Maybe<NullableFloatFilter>;
  cleaning_contribution?: Maybe<NullableFloatFilter>;
  cleaning_total?: Maybe<NullableFloatFilter>;
  amounts_not_justificate?: Maybe<NullableFloatFilter>;
  energy_current_measure_active?: Maybe<NullableFloatFilter>;
  energy_last_measure_active?: Maybe<NullableFloatFilter>;
  energy_factor_active?: Maybe<NullableIntFilter>;
  energy_consumption_active?: Maybe<NullableFloatFilter>;
  energy_rate_active?: Maybe<NullableFloatFilter>;
  energy_price_active?: Maybe<NullableFloatFilter>;
  energy_price_contribution_active?: Maybe<NullableFloatFilter>;
  energy_current_measure_reactive?: Maybe<NullableFloatFilter>;
  energy_last_measure_reactive?: Maybe<NullableFloatFilter>;
  energy_factor_reactive?: Maybe<NullableIntFilter>;
  energy_consumption_reactive?: Maybe<NullableFloatFilter>;
  energy_rate_reactive?: Maybe<NullableFloatFilter>;
  energy_price_reactive?: Maybe<NullableFloatFilter>;
  energy_price_contribution_reactive?: Maybe<NullableFloatFilter>;
  energy_hours_interruption?: Maybe<NullableIntFilter>;
  energy_total?: Maybe<NullableFloatFilter>;
  water_current_measure?: Maybe<NullableFloatFilter>;
  water_consumption?: Maybe<NullableFloatFilter>;
  water_last_measure?: Maybe<NullableFloatFilter>;
  water_rate_basic_aqueduct?: Maybe<NullableFloatFilter>;
  water_rate_compl_aqueduct?: Maybe<NullableFloatFilter>;
  water_rate_sumpt_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_basic_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_compl_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_sumpt_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_aqueduct?: Maybe<NullableFloatFilter>;
  water_contribution_aqueduct?: Maybe<NullableFloatFilter>;
  water_contribution_price_fixed_aqueduct?: Maybe<NullableFloatFilter>;
  water_rate_compl_sewerage?: Maybe<NullableFloatFilter>;
  water_rate_basic_sewerage?: Maybe<NullableFloatFilter>;
  water_rate_sumpt_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_basic_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_compl_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_sumpt_sewerage?: Maybe<NullableFloatFilter>;
  water_price_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_sewerage?: Maybe<NullableFloatFilter>;
  water_contribution_sewerage?: Maybe<NullableFloatFilter>;
  water_contribution_price_fixed_sewerage?: Maybe<NullableFloatFilter>;
  water_total?: Maybe<NullableFloatFilter>;
  sewerage_total?: Maybe<NullableFloatFilter>;
  user_transcriber?: Maybe<NullableStringFilter>;
  user_updated?: Maybe<NullableStringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  user_aproved_bill?: Maybe<NullableStringFilter>;
  user_uploaded_bill?: Maybe<NullableStringFilter>;
  user_uploaded_voucher?: Maybe<NullableStringFilter>;
  is_approved_movii?: Maybe<BooleanFilter>;
  payment_date?: Maybe<NullableDateTimeFilter>;
  date_bill_uploaded?: Maybe<NullableDateTimeFilter>;
  date_voucher_uploaded?: Maybe<NullableDateTimeFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<BillScalarWhereInput>>;
  OR?: Maybe<Array<BillScalarWhereInput>>;
  NOT?: Maybe<Array<BillScalarWhereInput>>;
};

export type BillUpdateInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerUpdateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceUpdateOneWithoutBillInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutBillInput>;
  amounts?: Maybe<AmountUpdateManyWithoutBillInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBillInput>;
};

export type BillUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type BillUpdateManyWithWhereNestedInput = {
  where: BillScalarWhereInput;
  data: BillUpdateManyDataInput;
};

export type BillUpdateManyWithoutCash_SourceInput = {
  create?: Maybe<Array<BillCreateWithoutCash_SourceInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
  set?: Maybe<Array<BillWhereUniqueInput>>;
  disconnect?: Maybe<Array<BillWhereUniqueInput>>;
  delete?: Maybe<Array<BillWhereUniqueInput>>;
  update?: Maybe<Array<BillUpdateWithWhereUniqueWithoutCash_SourceInput>>;
  updateMany?: Maybe<Array<BillUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<BillScalarWhereInput>>;
  upsert?: Maybe<Array<BillUpsertWithWhereUniqueWithoutCash_SourceInput>>;
};

export type BillUpdateManyWithoutMarketerInput = {
  create?: Maybe<Array<BillCreateWithoutMarketerInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
  set?: Maybe<Array<BillWhereUniqueInput>>;
  disconnect?: Maybe<Array<BillWhereUniqueInput>>;
  delete?: Maybe<Array<BillWhereUniqueInput>>;
  update?: Maybe<Array<BillUpdateWithWhereUniqueWithoutMarketerInput>>;
  updateMany?: Maybe<Array<BillUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<BillScalarWhereInput>>;
  upsert?: Maybe<Array<BillUpsertWithWhereUniqueWithoutMarketerInput>>;
};

export type BillUpdateManyWithoutPayment_Method_MarketerInput = {
  create?: Maybe<Array<BillCreateWithoutPayment_Method_MarketerInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
  set?: Maybe<Array<BillWhereUniqueInput>>;
  disconnect?: Maybe<Array<BillWhereUniqueInput>>;
  delete?: Maybe<Array<BillWhereUniqueInput>>;
  update?: Maybe<Array<BillUpdateWithWhereUniqueWithoutPayment_Method_MarketerInput>>;
  updateMany?: Maybe<Array<BillUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<BillScalarWhereInput>>;
  upsert?: Maybe<Array<BillUpsertWithWhereUniqueWithoutPayment_Method_MarketerInput>>;
};

export type BillUpdateManyWithoutServiceInput = {
  create?: Maybe<Array<BillCreateWithoutServiceInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
  set?: Maybe<Array<BillWhereUniqueInput>>;
  disconnect?: Maybe<Array<BillWhereUniqueInput>>;
  delete?: Maybe<Array<BillWhereUniqueInput>>;
  update?: Maybe<Array<BillUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<BillUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<BillScalarWhereInput>>;
  upsert?: Maybe<Array<BillUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type BillUpdateManyWithoutUserInput = {
  create?: Maybe<Array<BillCreateWithoutUserInput>>;
  connect?: Maybe<Array<BillWhereUniqueInput>>;
  set?: Maybe<Array<BillWhereUniqueInput>>;
  disconnect?: Maybe<Array<BillWhereUniqueInput>>;
  delete?: Maybe<Array<BillWhereUniqueInput>>;
  update?: Maybe<Array<BillUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<BillUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<BillScalarWhereInput>>;
  upsert?: Maybe<Array<BillUpsertWithWhereUniqueWithoutUserInput>>;
};

export type BillUpdateOneRequiredWithoutAmountsInput = {
  create?: Maybe<BillCreateWithoutAmountsInput>;
  connect?: Maybe<BillWhereUniqueInput>;
  update?: Maybe<BillUpdateWithoutAmountsDataInput>;
  upsert?: Maybe<BillUpsertWithoutAmountsInput>;
};

export type BillUpdateWithWhereUniqueWithoutCash_SourceInput = {
  where: BillWhereUniqueInput;
  data: BillUpdateWithoutCash_SourceDataInput;
};

export type BillUpdateWithWhereUniqueWithoutMarketerInput = {
  where: BillWhereUniqueInput;
  data: BillUpdateWithoutMarketerDataInput;
};

export type BillUpdateWithWhereUniqueWithoutPayment_Method_MarketerInput = {
  where: BillWhereUniqueInput;
  data: BillUpdateWithoutPayment_Method_MarketerDataInput;
};

export type BillUpdateWithWhereUniqueWithoutServiceInput = {
  where: BillWhereUniqueInput;
  data: BillUpdateWithoutServiceDataInput;
};

export type BillUpdateWithWhereUniqueWithoutUserInput = {
  where: BillWhereUniqueInput;
  data: BillUpdateWithoutUserDataInput;
};

export type BillUpdateWithoutAmountsDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerUpdateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceUpdateOneWithoutBillInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutBillInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBillInput>;
};

export type BillUpdateWithoutCash_SourceDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerUpdateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateOneWithoutBillInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutBillInput>;
  amounts?: Maybe<AmountUpdateManyWithoutBillInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBillInput>;
};

export type BillUpdateWithoutMarketerDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceUpdateOneWithoutBillInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutBillInput>;
  amounts?: Maybe<AmountUpdateManyWithoutBillInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBillInput>;
};

export type BillUpdateWithoutPayment_Method_MarketerDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerUpdateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceUpdateOneWithoutBillInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutBillInput>;
  amounts?: Maybe<AmountUpdateManyWithoutBillInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBillInput>;
};

export type BillUpdateWithoutServiceDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerUpdateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceUpdateOneWithoutBillInput>;
  amounts?: Maybe<AmountUpdateManyWithoutBillInput>;
  user?: Maybe<UserUpdateOneRequiredWithoutBillInput>;
};

export type BillUpdateWithoutUserDataInput = {
  id?: Maybe<Scalars['String']>;
  warnings?: Maybe<Scalars['Json']>;
  payment_reference?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  is_legible?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  number_bill?: Maybe<Scalars['String']>;
  average?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['DateTime']>;
  suspension_date?: Maybe<Scalars['DateTime']>;
  timely_payment_date?: Maybe<Scalars['DateTime']>;
  begin_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  voucher_number?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['DateTime']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  real_payment?: Maybe<Scalars['Float']>;
  cash_source_name?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  image_voucher?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  date_bill?: Maybe<Scalars['DateTime']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  public_lighting?: Maybe<Scalars['Float']>;
  total_others?: Maybe<Scalars['Float']>;
  user_name?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  general_bill_description?: Maybe<Scalars['Json']>;
  voluntary_contribution?: Maybe<Scalars['Float']>;
  general_bill_amount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  cleaning_price?: Maybe<Scalars['Float']>;
  cleaning_contribution?: Maybe<Scalars['Float']>;
  cleaning_total?: Maybe<Scalars['Float']>;
  amounts_not_justificate?: Maybe<Scalars['Float']>;
  energy_current_measure_active?: Maybe<Scalars['Float']>;
  energy_last_measure_active?: Maybe<Scalars['Float']>;
  energy_factor_active?: Maybe<Scalars['Int']>;
  energy_consumption_active?: Maybe<Scalars['Float']>;
  energy_rate_active?: Maybe<Scalars['Float']>;
  energy_price_active?: Maybe<Scalars['Float']>;
  energy_price_contribution_active?: Maybe<Scalars['Float']>;
  energy_current_measure_reactive?: Maybe<Scalars['Float']>;
  energy_last_measure_reactive?: Maybe<Scalars['Float']>;
  energy_factor_reactive?: Maybe<Scalars['Int']>;
  energy_consumption_reactive?: Maybe<Scalars['Float']>;
  energy_rate_reactive?: Maybe<Scalars['Float']>;
  energy_price_reactive?: Maybe<Scalars['Float']>;
  energy_price_contribution_reactive?: Maybe<Scalars['Float']>;
  energy_hours_interruption?: Maybe<Scalars['Int']>;
  energy_total?: Maybe<Scalars['Float']>;
  water_current_measure?: Maybe<Scalars['Float']>;
  water_consumption?: Maybe<Scalars['Float']>;
  water_last_measure?: Maybe<Scalars['Float']>;
  water_rate_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_aqueduct?: Maybe<Scalars['Float']>;
  water_price_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_aqueduct?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_rate_compl_sewerage?: Maybe<Scalars['Float']>;
  water_rate_basic_sewerage?: Maybe<Scalars['Float']>;
  water_rate_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_basic_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_compl_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_sumpt_sewerage?: Maybe<Scalars['Float']>;
  water_price_sewerage?: Maybe<Scalars['Float']>;
  water_price_fixed_aqueduct?: Maybe<Scalars['Float']>;
  water_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_sewerage?: Maybe<Scalars['Float']>;
  water_contribution_price_fixed_sewerage?: Maybe<Scalars['Float']>;
  water_total?: Maybe<Scalars['Float']>;
  sewerage_total?: Maybe<Scalars['Float']>;
  user_transcriber?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_aproved_bill?: Maybe<Scalars['String']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['Boolean']>;
  payment_date?: Maybe<Scalars['DateTime']>;
  date_bill_uploaded?: Maybe<Scalars['DateTime']>;
  date_voucher_uploaded?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketer?: Maybe<MarketerUpdateOneWithoutBillInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerUpdateOneWithoutBillInput>;
  cash_source?: Maybe<CashSourceUpdateOneWithoutBillInput>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutBillInput>;
  amounts?: Maybe<AmountUpdateManyWithoutBillInput>;
};

export type BillUpsertWithWhereUniqueWithoutCash_SourceInput = {
  where: BillWhereUniqueInput;
  update: BillUpdateWithoutCash_SourceDataInput;
  create: BillCreateWithoutCash_SourceInput;
};

export type BillUpsertWithWhereUniqueWithoutMarketerInput = {
  where: BillWhereUniqueInput;
  update: BillUpdateWithoutMarketerDataInput;
  create: BillCreateWithoutMarketerInput;
};

export type BillUpsertWithWhereUniqueWithoutPayment_Method_MarketerInput = {
  where: BillWhereUniqueInput;
  update: BillUpdateWithoutPayment_Method_MarketerDataInput;
  create: BillCreateWithoutPayment_Method_MarketerInput;
};

export type BillUpsertWithWhereUniqueWithoutServiceInput = {
  where: BillWhereUniqueInput;
  update: BillUpdateWithoutServiceDataInput;
  create: BillCreateWithoutServiceInput;
};

export type BillUpsertWithWhereUniqueWithoutUserInput = {
  where: BillWhereUniqueInput;
  update: BillUpdateWithoutUserDataInput;
  create: BillCreateWithoutUserInput;
};

export type BillUpsertWithoutAmountsInput = {
  update: BillUpdateWithoutAmountsDataInput;
  create: BillCreateWithoutAmountsInput;
};

export type BillWhereInput = {
  id?: Maybe<StringFilter>;
  payment_reference?: Maybe<NullableStringFilter>;
  account_parent?: Maybe<NullableStringFilter>;
  is_legible?: Maybe<BooleanFilter>;
  budget?: Maybe<NullableFloatFilter>;
  vertebra_pay?: Maybe<BooleanFilter>;
  payment_aut?: Maybe<BooleanFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  company_name?: Maybe<StringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  account_id?: Maybe<StringFilter>;
  account_name?: Maybe<StringFilter>;
  marketer_id?: Maybe<NullableStringFilter>;
  marketer_name?: Maybe<NullableStringFilter>;
  number_bill?: Maybe<NullableStringFilter>;
  average?: Maybe<NullableBooleanFilter>;
  issue_date?: Maybe<NullableDateTimeFilter>;
  suspension_date?: Maybe<NullableDateTimeFilter>;
  timely_payment_date?: Maybe<NullableDateTimeFilter>;
  begin_date?: Maybe<NullableDateTimeFilter>;
  end_date?: Maybe<NullableDateTimeFilter>;
  voucher_number?: Maybe<NullableStringFilter>;
  date_paid?: Maybe<NullableDateTimeFilter>;
  payment_method_marketer_id?: Maybe<NullableStringFilter>;
  payment_method_marketer_name?: Maybe<NullableStringFilter>;
  real_payment?: Maybe<NullableFloatFilter>;
  cash_source_id?: Maybe<NullableStringFilter>;
  cash_source_name?: Maybe<NullableStringFilter>;
  image_bill?: Maybe<NullableStringFilter>;
  image_voucher?: Maybe<NullableStringFilter>;
  observation?: Maybe<NullableStringFilter>;
  date_bill?: Maybe<DateTimeFilter>;
  service_id?: Maybe<StringFilter>;
  service_name?: Maybe<StringFilter>;
  type_of_bill?: Maybe<TypeOfBill>;
  amounts?: Maybe<AmountFilter>;
  public_lighting?: Maybe<NullableFloatFilter>;
  total_others?: Maybe<NullableFloatFilter>;
  user_id?: Maybe<StringFilter>;
  user_name?: Maybe<StringFilter>;
  status_bill?: Maybe<NullableStringFilter>;
  voluntary_contribution?: Maybe<NullableFloatFilter>;
  general_bill_amount?: Maybe<NullableFloatFilter>;
  total?: Maybe<NullableFloatFilter>;
  cleaning_price?: Maybe<NullableFloatFilter>;
  cleaning_contribution?: Maybe<NullableFloatFilter>;
  cleaning_total?: Maybe<NullableFloatFilter>;
  amounts_not_justificate?: Maybe<NullableFloatFilter>;
  energy_current_measure_active?: Maybe<NullableFloatFilter>;
  energy_last_measure_active?: Maybe<NullableFloatFilter>;
  energy_factor_active?: Maybe<NullableIntFilter>;
  energy_consumption_active?: Maybe<NullableFloatFilter>;
  energy_rate_active?: Maybe<NullableFloatFilter>;
  energy_price_active?: Maybe<NullableFloatFilter>;
  energy_price_contribution_active?: Maybe<NullableFloatFilter>;
  energy_current_measure_reactive?: Maybe<NullableFloatFilter>;
  energy_last_measure_reactive?: Maybe<NullableFloatFilter>;
  energy_factor_reactive?: Maybe<NullableIntFilter>;
  energy_consumption_reactive?: Maybe<NullableFloatFilter>;
  energy_rate_reactive?: Maybe<NullableFloatFilter>;
  energy_price_reactive?: Maybe<NullableFloatFilter>;
  energy_price_contribution_reactive?: Maybe<NullableFloatFilter>;
  energy_hours_interruption?: Maybe<NullableIntFilter>;
  energy_total?: Maybe<NullableFloatFilter>;
  water_current_measure?: Maybe<NullableFloatFilter>;
  water_consumption?: Maybe<NullableFloatFilter>;
  water_last_measure?: Maybe<NullableFloatFilter>;
  water_rate_basic_aqueduct?: Maybe<NullableFloatFilter>;
  water_rate_compl_aqueduct?: Maybe<NullableFloatFilter>;
  water_rate_sumpt_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_basic_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_compl_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_sumpt_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_aqueduct?: Maybe<NullableFloatFilter>;
  water_contribution_aqueduct?: Maybe<NullableFloatFilter>;
  water_contribution_price_fixed_aqueduct?: Maybe<NullableFloatFilter>;
  water_rate_compl_sewerage?: Maybe<NullableFloatFilter>;
  water_rate_basic_sewerage?: Maybe<NullableFloatFilter>;
  water_rate_sumpt_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_basic_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_compl_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_sumpt_sewerage?: Maybe<NullableFloatFilter>;
  water_price_sewerage?: Maybe<NullableFloatFilter>;
  water_price_fixed_aqueduct?: Maybe<NullableFloatFilter>;
  water_price_fixed_sewerage?: Maybe<NullableFloatFilter>;
  water_contribution_sewerage?: Maybe<NullableFloatFilter>;
  water_contribution_price_fixed_sewerage?: Maybe<NullableFloatFilter>;
  water_total?: Maybe<NullableFloatFilter>;
  sewerage_total?: Maybe<NullableFloatFilter>;
  user_transcriber?: Maybe<NullableStringFilter>;
  user_updated?: Maybe<NullableStringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  user_aproved_bill?: Maybe<NullableStringFilter>;
  user_uploaded_bill?: Maybe<NullableStringFilter>;
  user_uploaded_voucher?: Maybe<NullableStringFilter>;
  is_approved_movii?: Maybe<BooleanFilter>;
  payment_date?: Maybe<NullableDateTimeFilter>;
  date_bill_uploaded?: Maybe<NullableDateTimeFilter>;
  date_voucher_uploaded?: Maybe<NullableDateTimeFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<BillWhereInput>>;
  OR?: Maybe<Array<BillWhereInput>>;
  NOT?: Maybe<Array<BillWhereInput>>;
  marketer?: Maybe<MarketerWhereInput>;
  payment_method_marketer?: Maybe<PaymentMethodMarketerWhereInput>;
  cash_source?: Maybe<CashSourceWhereInput>;
  service?: Maybe<ServiceWhereInput>;
  user?: Maybe<UserWhereInput>;
};

export type BillWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'company';
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['Boolean'];
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user: Array<User>;
  regionals: Array<Regional>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  amount: Array<Amount>;
  concept: Array<Concept>;
  place: Array<Place>;
  account: Array<Account>;
  meter: Array<Meter>;
  datameter: Array<Datameter>;
  horario: Array<Horario>;
  reportStatus: Array<ReportStatus>;
  regionalsUsers: Array<RegionalUser>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  setting: Array<Setting>;
  is_active?: Maybe<Scalars['Boolean']>;
};


export type CompanyUserArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<UserWhereUniqueInput>;
  after?: Maybe<UserWhereUniqueInput>;
};


export type CompanyRegionalsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<RegionalWhereUniqueInput>;
  after?: Maybe<RegionalWhereUniqueInput>;
};


export type CompanyAmountArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AmountWhereUniqueInput>;
  after?: Maybe<AmountWhereUniqueInput>;
};


export type CompanyConceptArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ConceptWhereUniqueInput>;
  after?: Maybe<ConceptWhereUniqueInput>;
};


export type CompanyPlaceArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PlaceWhereUniqueInput>;
  after?: Maybe<PlaceWhereUniqueInput>;
};


export type CompanyAccountArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};


export type CompanyMeterArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<MeterWhereUniqueInput>;
  after?: Maybe<MeterWhereUniqueInput>;
};


export type CompanyDatameterArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<DatameterWhereUniqueInput>;
  after?: Maybe<DatameterWhereUniqueInput>;
};


export type CompanyHorarioArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<HorarioWhereUniqueInput>;
  after?: Maybe<HorarioWhereUniqueInput>;
};


export type CompanyReportStatusArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ReportStatusWhereUniqueInput>;
  after?: Maybe<ReportStatusWhereUniqueInput>;
};


export type CompanyRegionalsUsersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<RegionalUserWhereUniqueInput>;
  after?: Maybe<RegionalUserWhereUniqueInput>;
};


export type CompanySettingArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<SettingWhereUniqueInput>;
  after?: Maybe<SettingWhereUniqueInput>;
};

export type CompanyCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateOneWithoutAccountInput = {
  create?: Maybe<CompanyCreateWithoutAccountInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutAmountInput = {
  create?: Maybe<CompanyCreateWithoutAmountInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutConceptInput = {
  create?: Maybe<CompanyCreateWithoutConceptInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutMeterInput = {
  create?: Maybe<CompanyCreateWithoutMeterInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutPlaceInput = {
  create?: Maybe<CompanyCreateWithoutPlaceInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutRegionalsInput = {
  create?: Maybe<CompanyCreateWithoutRegionalsInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutRegionalsUsersInput = {
  create?: Maybe<CompanyCreateWithoutRegionalsUsersInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutReportStatusInput = {
  create?: Maybe<CompanyCreateWithoutReportStatusInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutSettingInput = {
  create?: Maybe<CompanyCreateWithoutSettingInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOneWithoutUserInput = {
  create?: Maybe<CompanyCreateWithoutUserInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateWithoutAccountInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutAmountInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutConceptInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutMeterInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutPlaceInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutRegionalsInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutRegionalsUsersInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutReportStatusInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutSettingInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserCreateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutUserInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regionals?: Maybe<RegionalCreateManyWithoutCompanyInput>;
  amount?: Maybe<AmountCreateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptCreateManyWithoutCompanyInput>;
  place?: Maybe<PlaceCreateManyWithoutCompanyInput>;
  account?: Maybe<AccountCreateManyWithoutCompanyInput>;
  meter?: Maybe<MeterCreateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterCreateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioCreateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserCreateManyWithoutCompanyInput>;
  setting?: Maybe<SettingCreateManyWithoutCompanyInput>;
};

export type CompanyOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  status?: Maybe<OrderByArg>;
  manager?: Maybe<OrderByArg>;
  nit?: Maybe<OrderByArg>;
  type?: Maybe<OrderByArg>;
  imagen?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
  is_active?: Maybe<OrderByArg>;
};

export type CompanyUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateOneRequiredWithoutAccountInput = {
  create?: Maybe<CompanyCreateWithoutAccountInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutAccountDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutAccountInput>;
};

export type CompanyUpdateOneRequiredWithoutPlaceInput = {
  create?: Maybe<CompanyCreateWithoutPlaceInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutPlaceDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutPlaceInput>;
};

export type CompanyUpdateOneRequiredWithoutRegionalsInput = {
  create?: Maybe<CompanyCreateWithoutRegionalsInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutRegionalsDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutRegionalsInput>;
};

export type CompanyUpdateOneRequiredWithoutSettingInput = {
  create?: Maybe<CompanyCreateWithoutSettingInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutSettingDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutSettingInput>;
};

export type CompanyUpdateOneRequiredWithoutUserInput = {
  create?: Maybe<CompanyCreateWithoutUserInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutUserDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutUserInput>;
};

export type CompanyUpdateOneWithoutAmountInput = {
  create?: Maybe<CompanyCreateWithoutAmountInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutAmountDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutAmountInput>;
};

export type CompanyUpdateOneWithoutConceptInput = {
  create?: Maybe<CompanyCreateWithoutConceptInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutConceptDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutConceptInput>;
};

export type CompanyUpdateOneWithoutMeterInput = {
  create?: Maybe<CompanyCreateWithoutMeterInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutMeterDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutMeterInput>;
};

export type CompanyUpdateOneWithoutRegionalsUsersInput = {
  create?: Maybe<CompanyCreateWithoutRegionalsUsersInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutRegionalsUsersDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutRegionalsUsersInput>;
};

export type CompanyUpdateOneWithoutReportStatusInput = {
  create?: Maybe<CompanyCreateWithoutReportStatusInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutReportStatusDataInput>;
  upsert?: Maybe<CompanyUpsertWithoutReportStatusInput>;
};

export type CompanyUpdateWithoutAccountDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutAmountDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutConceptDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutMeterDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutPlaceDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutRegionalsDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutRegionalsUsersDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutReportStatusDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutSettingDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserUpdateManyWithoutCompanyInput>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
};

export type CompanyUpdateWithoutUserDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regionals?: Maybe<RegionalUpdateManyWithoutCompanyInput>;
  amount?: Maybe<AmountUpdateManyWithoutCompanyInput>;
  concept?: Maybe<ConceptUpdateManyWithoutCompanyInput>;
  place?: Maybe<PlaceUpdateManyWithoutCompanyInput>;
  account?: Maybe<AccountUpdateManyWithoutCompanyInput>;
  meter?: Maybe<MeterUpdateManyWithoutCompanyInput>;
  datameter?: Maybe<DatameterUpdateManyWithoutCompanyInput>;
  horario?: Maybe<HorarioUpdateManyWithoutCompanyInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutCompanyInput>;
  regionalsUsers?: Maybe<RegionalUserUpdateManyWithoutCompanyInput>;
  setting?: Maybe<SettingUpdateManyWithoutCompanyInput>;
};

export type CompanyUpsertWithoutAccountInput = {
  update: CompanyUpdateWithoutAccountDataInput;
  create: CompanyCreateWithoutAccountInput;
};

export type CompanyUpsertWithoutAmountInput = {
  update: CompanyUpdateWithoutAmountDataInput;
  create: CompanyCreateWithoutAmountInput;
};

export type CompanyUpsertWithoutConceptInput = {
  update: CompanyUpdateWithoutConceptDataInput;
  create: CompanyCreateWithoutConceptInput;
};

export type CompanyUpsertWithoutMeterInput = {
  update: CompanyUpdateWithoutMeterDataInput;
  create: CompanyCreateWithoutMeterInput;
};

export type CompanyUpsertWithoutPlaceInput = {
  update: CompanyUpdateWithoutPlaceDataInput;
  create: CompanyCreateWithoutPlaceInput;
};

export type CompanyUpsertWithoutRegionalsInput = {
  update: CompanyUpdateWithoutRegionalsDataInput;
  create: CompanyCreateWithoutRegionalsInput;
};

export type CompanyUpsertWithoutRegionalsUsersInput = {
  update: CompanyUpdateWithoutRegionalsUsersDataInput;
  create: CompanyCreateWithoutRegionalsUsersInput;
};

export type CompanyUpsertWithoutReportStatusInput = {
  update: CompanyUpdateWithoutReportStatusDataInput;
  create: CompanyCreateWithoutReportStatusInput;
};

export type CompanyUpsertWithoutSettingInput = {
  update: CompanyUpdateWithoutSettingDataInput;
  create: CompanyCreateWithoutSettingInput;
};

export type CompanyUpsertWithoutUserInput = {
  update: CompanyUpdateWithoutUserDataInput;
  create: CompanyCreateWithoutUserInput;
};

export type CompanyWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<BooleanFilter>;
  manager?: Maybe<NullableStringFilter>;
  nit?: Maybe<NullableStringFilter>;
  type?: Maybe<NullableStringFilter>;
  imagen?: Maybe<NullableStringFilter>;
  user?: Maybe<UserFilter>;
  regionals?: Maybe<RegionalFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  amount?: Maybe<AmountFilter>;
  concept?: Maybe<ConceptFilter>;
  place?: Maybe<PlaceFilter>;
  account?: Maybe<AccountFilter>;
  meter?: Maybe<MeterFilter>;
  datameter?: Maybe<DatameterFilter>;
  horario?: Maybe<HorarioFilter>;
  reportStatus?: Maybe<ReportStatusFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  regionalsUsers?: Maybe<RegionalUserFilter>;
  setting?: Maybe<SettingFilter>;
  AND?: Maybe<Array<CompanyWhereInput>>;
  OR?: Maybe<Array<CompanyWhereInput>>;
  NOT?: Maybe<Array<CompanyWhereInput>>;
};

export type CompanyWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Concept = {
  __typename?: 'concept';
  id: Scalars['String'];
  name: Scalars['String'];
  service_id: Scalars['String'];
  service: Service;
  service_name: Scalars['String'];
  company_id?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  amount: Array<Amount>;
  water: Scalars['Boolean'];
  energy: Scalars['Boolean'];
  cleaning: Scalars['Boolean'];
  general: Scalars['Boolean'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type ConceptAmountArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AmountWhereUniqueInput>;
  after?: Maybe<AmountWhereUniqueInput>;
};

export type ConceptCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  service_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutConceptInput;
  company?: Maybe<CompanyCreateOneWithoutConceptInput>;
  amount?: Maybe<AmountCreateManyWithoutConceptInput>;
};

export type ConceptCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<ConceptCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<ConceptWhereUniqueInput>>;
};

export type ConceptCreateManyWithoutServiceInput = {
  create?: Maybe<Array<ConceptCreateWithoutServiceInput>>;
  connect?: Maybe<Array<ConceptWhereUniqueInput>>;
};

export type ConceptCreateOneWithoutAmountInput = {
  create?: Maybe<ConceptCreateWithoutAmountInput>;
  connect?: Maybe<ConceptWhereUniqueInput>;
};

export type ConceptCreateWithoutAmountInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  service_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutConceptInput;
  company?: Maybe<CompanyCreateOneWithoutConceptInput>;
};

export type ConceptCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  service_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutConceptInput;
  amount?: Maybe<AmountCreateManyWithoutConceptInput>;
};

export type ConceptCreateWithoutServiceInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  service_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyCreateOneWithoutConceptInput>;
  amount?: Maybe<AmountCreateManyWithoutConceptInput>;
};

export type ConceptFilter = {
  every?: Maybe<ConceptWhereInput>;
  some?: Maybe<ConceptWhereInput>;
  none?: Maybe<ConceptWhereInput>;
};

export type ConceptOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  service_id?: Maybe<OrderByArg>;
  service_name?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  water?: Maybe<OrderByArg>;
  energy?: Maybe<OrderByArg>;
  cleaning?: Maybe<OrderByArg>;
  general?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type ConceptScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  service_id?: Maybe<StringFilter>;
  service_name?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  amount?: Maybe<AmountFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  water?: Maybe<BooleanFilter>;
  energy?: Maybe<BooleanFilter>;
  cleaning?: Maybe<BooleanFilter>;
  general?: Maybe<BooleanFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<ConceptScalarWhereInput>>;
  OR?: Maybe<Array<ConceptScalarWhereInput>>;
  NOT?: Maybe<Array<ConceptScalarWhereInput>>;
};

export type ConceptUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutConceptInput>;
  company?: Maybe<CompanyUpdateOneWithoutConceptInput>;
  amount?: Maybe<AmountUpdateManyWithoutConceptInput>;
};

export type ConceptUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type ConceptUpdateManyWithWhereNestedInput = {
  where: ConceptScalarWhereInput;
  data: ConceptUpdateManyDataInput;
};

export type ConceptUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<ConceptCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<ConceptWhereUniqueInput>>;
  set?: Maybe<Array<ConceptWhereUniqueInput>>;
  disconnect?: Maybe<Array<ConceptWhereUniqueInput>>;
  delete?: Maybe<Array<ConceptWhereUniqueInput>>;
  update?: Maybe<Array<ConceptUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<ConceptUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<ConceptScalarWhereInput>>;
  upsert?: Maybe<Array<ConceptUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type ConceptUpdateManyWithoutServiceInput = {
  create?: Maybe<Array<ConceptCreateWithoutServiceInput>>;
  connect?: Maybe<Array<ConceptWhereUniqueInput>>;
  set?: Maybe<Array<ConceptWhereUniqueInput>>;
  disconnect?: Maybe<Array<ConceptWhereUniqueInput>>;
  delete?: Maybe<Array<ConceptWhereUniqueInput>>;
  update?: Maybe<Array<ConceptUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<ConceptUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<ConceptScalarWhereInput>>;
  upsert?: Maybe<Array<ConceptUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ConceptUpdateOneRequiredWithoutAmountInput = {
  create?: Maybe<ConceptCreateWithoutAmountInput>;
  connect?: Maybe<ConceptWhereUniqueInput>;
  update?: Maybe<ConceptUpdateWithoutAmountDataInput>;
  upsert?: Maybe<ConceptUpsertWithoutAmountInput>;
};

export type ConceptUpdateWithWhereUniqueWithoutCompanyInput = {
  where: ConceptWhereUniqueInput;
  data: ConceptUpdateWithoutCompanyDataInput;
};

export type ConceptUpdateWithWhereUniqueWithoutServiceInput = {
  where: ConceptWhereUniqueInput;
  data: ConceptUpdateWithoutServiceDataInput;
};

export type ConceptUpdateWithoutAmountDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutConceptInput>;
  company?: Maybe<CompanyUpdateOneWithoutConceptInput>;
};

export type ConceptUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutConceptInput>;
  amount?: Maybe<AmountUpdateManyWithoutConceptInput>;
};

export type ConceptUpdateWithoutServiceDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  water?: Maybe<Scalars['Boolean']>;
  energy?: Maybe<Scalars['Boolean']>;
  cleaning?: Maybe<Scalars['Boolean']>;
  general?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneWithoutConceptInput>;
  amount?: Maybe<AmountUpdateManyWithoutConceptInput>;
};

export type ConceptUpsertWithWhereUniqueWithoutCompanyInput = {
  where: ConceptWhereUniqueInput;
  update: ConceptUpdateWithoutCompanyDataInput;
  create: ConceptCreateWithoutCompanyInput;
};

export type ConceptUpsertWithWhereUniqueWithoutServiceInput = {
  where: ConceptWhereUniqueInput;
  update: ConceptUpdateWithoutServiceDataInput;
  create: ConceptCreateWithoutServiceInput;
};

export type ConceptUpsertWithoutAmountInput = {
  update: ConceptUpdateWithoutAmountDataInput;
  create: ConceptCreateWithoutAmountInput;
};

export type ConceptWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  service_id?: Maybe<StringFilter>;
  service_name?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  amount?: Maybe<AmountFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  water?: Maybe<BooleanFilter>;
  energy?: Maybe<BooleanFilter>;
  cleaning?: Maybe<BooleanFilter>;
  general?: Maybe<BooleanFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<ConceptWhereInput>>;
  OR?: Maybe<Array<ConceptWhereInput>>;
  NOT?: Maybe<Array<ConceptWhereInput>>;
  service?: Maybe<ServiceWhereInput>;
  company?: Maybe<CompanyWhereInput>;
};

export type ConceptWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  UniqueAccountAndServiceIndex?: Maybe<UniqueAccountAndServiceIndexCompoundUniqueInput>;
};

export type Datameter = {
  __typename?: 'datameter';
  id: Scalars['Int'];
  meter_name: Scalars['String'];
  meter_id: Scalars['String'];
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  date_time: Scalars['DateTime'];
  voltaje_l1: Scalars['Float'];
  voltaje_l2: Scalars['Float'];
  voltaje_l3: Scalars['Float'];
  voltaje_rms: Scalars['Float'];
  current_l1: Scalars['Float'];
  current_l2: Scalars['Float'];
  current_l3: Scalars['Float'];
  current_rms: Scalars['Float'];
  power_factor_l1: Scalars['Float'];
  power_factor_l2: Scalars['Float'];
  power_factor_l3: Scalars['Float'];
  power_factor_rms: Scalars['Float'];
  power_l1: Scalars['Float'];
  power_l2: Scalars['Float'];
  power_l3: Scalars['Float'];
  power_rms: Scalars['Float'];
  energy_l1: Scalars['Float'];
  energy_l2: Scalars['Float'];
  energy_l3: Scalars['Float'];
  energy_rms: Scalars['Float'];
  thd_l1: Scalars['Float'];
  thd_l2: Scalars['Float'];
  thd_l3: Scalars['Float'];
  thd_rms: Scalars['Float'];
  event_type: Array<Event>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type DatameterEvent_TypeArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<EventWhereUniqueInput>;
  after?: Maybe<EventWhereUniqueInput>;
};

export type DatameterCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<DatameterCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<DatameterWhereUniqueInput>>;
};

export type DatameterCreateWithoutCompanyInput = {
  meter_name: Scalars['String'];
  meter_id: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  regional_id: Scalars['String'];
  regional_name: Scalars['String'];
  date_time: Scalars['DateTime'];
  voltaje_l1: Scalars['Float'];
  voltaje_l2: Scalars['Float'];
  voltaje_l3: Scalars['Float'];
  voltaje_rms: Scalars['Float'];
  current_l1: Scalars['Float'];
  current_l2: Scalars['Float'];
  current_l3: Scalars['Float'];
  current_rms: Scalars['Float'];
  power_factor_l1: Scalars['Float'];
  power_factor_l2: Scalars['Float'];
  power_factor_l3: Scalars['Float'];
  power_factor_rms: Scalars['Float'];
  power_l1: Scalars['Float'];
  power_l2: Scalars['Float'];
  power_l3: Scalars['Float'];
  power_rms: Scalars['Float'];
  energy_l1: Scalars['Float'];
  energy_l2: Scalars['Float'];
  energy_l3: Scalars['Float'];
  energy_rms: Scalars['Float'];
  thd_l1: Scalars['Float'];
  thd_l2: Scalars['Float'];
  thd_l3: Scalars['Float'];
  thd_rms: Scalars['Float'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  event_type?: Maybe<EventCreateManyWithoutDatameterInput>;
};

export type DatameterFilter = {
  every?: Maybe<DatameterWhereInput>;
  some?: Maybe<DatameterWhereInput>;
  none?: Maybe<DatameterWhereInput>;
};

export type DatameterScalarWhereInput = {
  id?: Maybe<IntFilter>;
  meter_name?: Maybe<StringFilter>;
  meter_id?: Maybe<StringFilter>;
  companyId?: Maybe<NullableStringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<StringFilter>;
  date_time?: Maybe<DateTimeFilter>;
  voltaje_l1?: Maybe<FloatFilter>;
  voltaje_l2?: Maybe<FloatFilter>;
  voltaje_l3?: Maybe<FloatFilter>;
  voltaje_rms?: Maybe<FloatFilter>;
  current_l1?: Maybe<FloatFilter>;
  current_l2?: Maybe<FloatFilter>;
  current_l3?: Maybe<FloatFilter>;
  current_rms?: Maybe<FloatFilter>;
  power_factor_l1?: Maybe<FloatFilter>;
  power_factor_l2?: Maybe<FloatFilter>;
  power_factor_l3?: Maybe<FloatFilter>;
  power_factor_rms?: Maybe<FloatFilter>;
  power_l1?: Maybe<FloatFilter>;
  power_l2?: Maybe<FloatFilter>;
  power_l3?: Maybe<FloatFilter>;
  power_rms?: Maybe<FloatFilter>;
  energy_l1?: Maybe<FloatFilter>;
  energy_l2?: Maybe<FloatFilter>;
  energy_l3?: Maybe<FloatFilter>;
  energy_rms?: Maybe<FloatFilter>;
  thd_l1?: Maybe<FloatFilter>;
  thd_l2?: Maybe<FloatFilter>;
  thd_l3?: Maybe<FloatFilter>;
  thd_rms?: Maybe<FloatFilter>;
  event_type?: Maybe<EventFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<DatameterScalarWhereInput>>;
  OR?: Maybe<Array<DatameterScalarWhereInput>>;
  NOT?: Maybe<Array<DatameterScalarWhereInput>>;
};

export type DatameterUpdateManyDataInput = {
  id?: Maybe<Scalars['Int']>;
  meter_name?: Maybe<Scalars['String']>;
  meter_id?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  date_time?: Maybe<Scalars['DateTime']>;
  voltaje_l1?: Maybe<Scalars['Float']>;
  voltaje_l2?: Maybe<Scalars['Float']>;
  voltaje_l3?: Maybe<Scalars['Float']>;
  voltaje_rms?: Maybe<Scalars['Float']>;
  current_l1?: Maybe<Scalars['Float']>;
  current_l2?: Maybe<Scalars['Float']>;
  current_l3?: Maybe<Scalars['Float']>;
  current_rms?: Maybe<Scalars['Float']>;
  power_factor_l1?: Maybe<Scalars['Float']>;
  power_factor_l2?: Maybe<Scalars['Float']>;
  power_factor_l3?: Maybe<Scalars['Float']>;
  power_factor_rms?: Maybe<Scalars['Float']>;
  power_l1?: Maybe<Scalars['Float']>;
  power_l2?: Maybe<Scalars['Float']>;
  power_l3?: Maybe<Scalars['Float']>;
  power_rms?: Maybe<Scalars['Float']>;
  energy_l1?: Maybe<Scalars['Float']>;
  energy_l2?: Maybe<Scalars['Float']>;
  energy_l3?: Maybe<Scalars['Float']>;
  energy_rms?: Maybe<Scalars['Float']>;
  thd_l1?: Maybe<Scalars['Float']>;
  thd_l2?: Maybe<Scalars['Float']>;
  thd_l3?: Maybe<Scalars['Float']>;
  thd_rms?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type DatameterUpdateManyWithWhereNestedInput = {
  where: DatameterScalarWhereInput;
  data: DatameterUpdateManyDataInput;
};

export type DatameterUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<DatameterCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<DatameterWhereUniqueInput>>;
  set?: Maybe<Array<DatameterWhereUniqueInput>>;
  disconnect?: Maybe<Array<DatameterWhereUniqueInput>>;
  delete?: Maybe<Array<DatameterWhereUniqueInput>>;
  update?: Maybe<Array<DatameterUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<DatameterUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<DatameterScalarWhereInput>>;
  upsert?: Maybe<Array<DatameterUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type DatameterUpdateWithWhereUniqueWithoutCompanyInput = {
  where: DatameterWhereUniqueInput;
  data: DatameterUpdateWithoutCompanyDataInput;
};

export type DatameterUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['Int']>;
  meter_name?: Maybe<Scalars['String']>;
  meter_id?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  date_time?: Maybe<Scalars['DateTime']>;
  voltaje_l1?: Maybe<Scalars['Float']>;
  voltaje_l2?: Maybe<Scalars['Float']>;
  voltaje_l3?: Maybe<Scalars['Float']>;
  voltaje_rms?: Maybe<Scalars['Float']>;
  current_l1?: Maybe<Scalars['Float']>;
  current_l2?: Maybe<Scalars['Float']>;
  current_l3?: Maybe<Scalars['Float']>;
  current_rms?: Maybe<Scalars['Float']>;
  power_factor_l1?: Maybe<Scalars['Float']>;
  power_factor_l2?: Maybe<Scalars['Float']>;
  power_factor_l3?: Maybe<Scalars['Float']>;
  power_factor_rms?: Maybe<Scalars['Float']>;
  power_l1?: Maybe<Scalars['Float']>;
  power_l2?: Maybe<Scalars['Float']>;
  power_l3?: Maybe<Scalars['Float']>;
  power_rms?: Maybe<Scalars['Float']>;
  energy_l1?: Maybe<Scalars['Float']>;
  energy_l2?: Maybe<Scalars['Float']>;
  energy_l3?: Maybe<Scalars['Float']>;
  energy_rms?: Maybe<Scalars['Float']>;
  thd_l1?: Maybe<Scalars['Float']>;
  thd_l2?: Maybe<Scalars['Float']>;
  thd_l3?: Maybe<Scalars['Float']>;
  thd_rms?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  event_type?: Maybe<EventUpdateManyWithoutDatameterInput>;
};

export type DatameterUpsertWithWhereUniqueWithoutCompanyInput = {
  where: DatameterWhereUniqueInput;
  update: DatameterUpdateWithoutCompanyDataInput;
  create: DatameterCreateWithoutCompanyInput;
};

export type DatameterWhereInput = {
  id?: Maybe<IntFilter>;
  meter_name?: Maybe<StringFilter>;
  meter_id?: Maybe<StringFilter>;
  companyId?: Maybe<NullableStringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  regional_id?: Maybe<StringFilter>;
  regional_name?: Maybe<StringFilter>;
  date_time?: Maybe<DateTimeFilter>;
  voltaje_l1?: Maybe<FloatFilter>;
  voltaje_l2?: Maybe<FloatFilter>;
  voltaje_l3?: Maybe<FloatFilter>;
  voltaje_rms?: Maybe<FloatFilter>;
  current_l1?: Maybe<FloatFilter>;
  current_l2?: Maybe<FloatFilter>;
  current_l3?: Maybe<FloatFilter>;
  current_rms?: Maybe<FloatFilter>;
  power_factor_l1?: Maybe<FloatFilter>;
  power_factor_l2?: Maybe<FloatFilter>;
  power_factor_l3?: Maybe<FloatFilter>;
  power_factor_rms?: Maybe<FloatFilter>;
  power_l1?: Maybe<FloatFilter>;
  power_l2?: Maybe<FloatFilter>;
  power_l3?: Maybe<FloatFilter>;
  power_rms?: Maybe<FloatFilter>;
  energy_l1?: Maybe<FloatFilter>;
  energy_l2?: Maybe<FloatFilter>;
  energy_l3?: Maybe<FloatFilter>;
  energy_rms?: Maybe<FloatFilter>;
  thd_l1?: Maybe<FloatFilter>;
  thd_l2?: Maybe<FloatFilter>;
  thd_l3?: Maybe<FloatFilter>;
  thd_rms?: Maybe<FloatFilter>;
  event_type?: Maybe<EventFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<DatameterWhereInput>>;
  OR?: Maybe<Array<DatameterWhereInput>>;
  NOT?: Maybe<Array<DatameterWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
};

export type DatameterWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type Domain = {
  __typename?: 'domain';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type DomainCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type DomainOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  type?: Maybe<OrderByArg>;
  parent?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type DomainUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type DomainWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  parent?: Maybe<NullableStringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<DomainWhereInput>>;
  OR?: Maybe<Array<DomainWhereInput>>;
  NOT?: Maybe<Array<DomainWhereInput>>;
};

export type DomainWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'event';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  datameter_id: Scalars['Int'];
  datameter: Datameter;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type EventCreateManyWithoutDatameterInput = {
  create?: Maybe<Array<EventCreateWithoutDatameterInput>>;
  connect?: Maybe<Array<EventWhereUniqueInput>>;
};

export type EventCreateWithoutDatameterInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type EventFilter = {
  every?: Maybe<EventWhereInput>;
  some?: Maybe<EventWhereInput>;
  none?: Maybe<EventWhereInput>;
};

export type EventScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  datameter_id?: Maybe<IntFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<EventScalarWhereInput>>;
  OR?: Maybe<Array<EventScalarWhereInput>>;
  NOT?: Maybe<Array<EventScalarWhereInput>>;
};

export type EventUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type EventUpdateManyWithWhereNestedInput = {
  where: EventScalarWhereInput;
  data: EventUpdateManyDataInput;
};

export type EventUpdateManyWithoutDatameterInput = {
  create?: Maybe<Array<EventCreateWithoutDatameterInput>>;
  connect?: Maybe<Array<EventWhereUniqueInput>>;
  set?: Maybe<Array<EventWhereUniqueInput>>;
  disconnect?: Maybe<Array<EventWhereUniqueInput>>;
  delete?: Maybe<Array<EventWhereUniqueInput>>;
  update?: Maybe<Array<EventUpdateWithWhereUniqueWithoutDatameterInput>>;
  updateMany?: Maybe<Array<EventUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<EventScalarWhereInput>>;
  upsert?: Maybe<Array<EventUpsertWithWhereUniqueWithoutDatameterInput>>;
};

export type EventUpdateWithWhereUniqueWithoutDatameterInput = {
  where: EventWhereUniqueInput;
  data: EventUpdateWithoutDatameterDataInput;
};

export type EventUpdateWithoutDatameterDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type EventUpsertWithWhereUniqueWithoutDatameterInput = {
  where: EventWhereUniqueInput;
  update: EventUpdateWithoutDatameterDataInput;
  create: EventCreateWithoutDatameterInput;
};

export type EventWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  datameter_id?: Maybe<IntFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<EventWhereInput>>;
  OR?: Maybe<Array<EventWhereInput>>;
  NOT?: Maybe<Array<EventWhereInput>>;
  datameter?: Maybe<DatameterWhereInput>;
};

export type EventWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type GetBills = {
  __typename?: 'getBills';
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  account_parent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  marketer_id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  numeral_v?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  property_level_id?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  sdl_id?: Maybe<Scalars['String']>;
  service_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  payment_method_marketer_name?: Maybe<Scalars['String']>;
  cash_source_name?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  sdl_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  getbillsbyaccount?: Maybe<Scalars['Json']>;
  user_uploaded_bill?: Maybe<Scalars['String']>;
  user_uploaded_voucher?: Maybe<Scalars['String']>;
  status_bill?: Maybe<Scalars['String']>;
  payment_date?: Maybe<Scalars['String']>;
  is_approved_movii?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  office_code?: Maybe<Scalars['Boolean']>;
  real_payment?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  budget?: Maybe<Scalars['Float']>;
  vertebra_pay: Scalars['Boolean'];
  payment_aut: Scalars['Boolean'];
};

export type GetStates = {
  __typename?: 'getStates';
  enum_schema: Scalars['String'];
  enum_name: Scalars['String'];
  enum_value: Scalars['String'];
};

export type Horario = {
  __typename?: 'horario';
  id: Scalars['String'];
  monday_open: Scalars['String'];
  monday_close: Scalars['String'];
  tuesday_open: Scalars['String'];
  tuesday_close: Scalars['String'];
  thursday_open: Scalars['String'];
  thursday_close: Scalars['String'];
  wednesday_open: Scalars['String'];
  wednesday_close: Scalars['String'];
  friday_open: Scalars['String'];
  friday_close: Scalars['String'];
  saturday_open: Scalars['String'];
  saturday_close: Scalars['String'];
  sunday_open: Scalars['String'];
  sunday_close: Scalars['String'];
  festive_open: Scalars['String'];
  festive_close: Scalars['String'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['String']>;
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type HorarioCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<HorarioCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<HorarioWhereUniqueInput>>;
};

export type HorarioCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  monday_open: Scalars['String'];
  monday_close: Scalars['String'];
  tuesday_open: Scalars['String'];
  tuesday_close: Scalars['String'];
  thursday_open: Scalars['String'];
  thursday_close: Scalars['String'];
  wednesday_open: Scalars['String'];
  wednesday_close: Scalars['String'];
  friday_open: Scalars['String'];
  friday_close: Scalars['String'];
  saturday_open: Scalars['String'];
  saturday_close: Scalars['String'];
  sunday_open: Scalars['String'];
  sunday_close: Scalars['String'];
  festive_open: Scalars['String'];
  festive_close: Scalars['String'];
  place_id: Scalars['String'];
  place_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type HorarioFilter = {
  every?: Maybe<HorarioWhereInput>;
  some?: Maybe<HorarioWhereInput>;
  none?: Maybe<HorarioWhereInput>;
};

export type HorarioOrderByInput = {
  id?: Maybe<OrderByArg>;
  monday_open?: Maybe<OrderByArg>;
  monday_close?: Maybe<OrderByArg>;
  tuesday_open?: Maybe<OrderByArg>;
  tuesday_close?: Maybe<OrderByArg>;
  thursday_open?: Maybe<OrderByArg>;
  thursday_close?: Maybe<OrderByArg>;
  wednesday_open?: Maybe<OrderByArg>;
  wednesday_close?: Maybe<OrderByArg>;
  friday_open?: Maybe<OrderByArg>;
  friday_close?: Maybe<OrderByArg>;
  saturday_open?: Maybe<OrderByArg>;
  saturday_close?: Maybe<OrderByArg>;
  sunday_open?: Maybe<OrderByArg>;
  sunday_close?: Maybe<OrderByArg>;
  festive_open?: Maybe<OrderByArg>;
  festive_close?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  place_id?: Maybe<OrderByArg>;
  place_name?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type HorarioScalarWhereInput = {
  id?: Maybe<StringFilter>;
  monday_open?: Maybe<StringFilter>;
  monday_close?: Maybe<StringFilter>;
  tuesday_open?: Maybe<StringFilter>;
  tuesday_close?: Maybe<StringFilter>;
  thursday_open?: Maybe<StringFilter>;
  thursday_close?: Maybe<StringFilter>;
  wednesday_open?: Maybe<StringFilter>;
  wednesday_close?: Maybe<StringFilter>;
  friday_open?: Maybe<StringFilter>;
  friday_close?: Maybe<StringFilter>;
  saturday_open?: Maybe<StringFilter>;
  saturday_close?: Maybe<StringFilter>;
  sunday_open?: Maybe<StringFilter>;
  sunday_close?: Maybe<StringFilter>;
  festive_open?: Maybe<StringFilter>;
  festive_close?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<HorarioScalarWhereInput>>;
  OR?: Maybe<Array<HorarioScalarWhereInput>>;
  NOT?: Maybe<Array<HorarioScalarWhereInput>>;
};

export type HorarioUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  monday_open?: Maybe<Scalars['String']>;
  monday_close?: Maybe<Scalars['String']>;
  tuesday_open?: Maybe<Scalars['String']>;
  tuesday_close?: Maybe<Scalars['String']>;
  thursday_open?: Maybe<Scalars['String']>;
  thursday_close?: Maybe<Scalars['String']>;
  wednesday_open?: Maybe<Scalars['String']>;
  wednesday_close?: Maybe<Scalars['String']>;
  friday_open?: Maybe<Scalars['String']>;
  friday_close?: Maybe<Scalars['String']>;
  saturday_open?: Maybe<Scalars['String']>;
  saturday_close?: Maybe<Scalars['String']>;
  sunday_open?: Maybe<Scalars['String']>;
  sunday_close?: Maybe<Scalars['String']>;
  festive_open?: Maybe<Scalars['String']>;
  festive_close?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type HorarioUpdateManyWithWhereNestedInput = {
  where: HorarioScalarWhereInput;
  data: HorarioUpdateManyDataInput;
};

export type HorarioUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<HorarioCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<HorarioWhereUniqueInput>>;
  set?: Maybe<Array<HorarioWhereUniqueInput>>;
  disconnect?: Maybe<Array<HorarioWhereUniqueInput>>;
  delete?: Maybe<Array<HorarioWhereUniqueInput>>;
  update?: Maybe<Array<HorarioUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<HorarioUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<HorarioScalarWhereInput>>;
  upsert?: Maybe<Array<HorarioUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type HorarioUpdateWithWhereUniqueWithoutCompanyInput = {
  where: HorarioWhereUniqueInput;
  data: HorarioUpdateWithoutCompanyDataInput;
};

export type HorarioUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  monday_open?: Maybe<Scalars['String']>;
  monday_close?: Maybe<Scalars['String']>;
  tuesday_open?: Maybe<Scalars['String']>;
  tuesday_close?: Maybe<Scalars['String']>;
  thursday_open?: Maybe<Scalars['String']>;
  thursday_close?: Maybe<Scalars['String']>;
  wednesday_open?: Maybe<Scalars['String']>;
  wednesday_close?: Maybe<Scalars['String']>;
  friday_open?: Maybe<Scalars['String']>;
  friday_close?: Maybe<Scalars['String']>;
  saturday_open?: Maybe<Scalars['String']>;
  saturday_close?: Maybe<Scalars['String']>;
  sunday_open?: Maybe<Scalars['String']>;
  sunday_close?: Maybe<Scalars['String']>;
  festive_open?: Maybe<Scalars['String']>;
  festive_close?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type HorarioUpsertWithWhereUniqueWithoutCompanyInput = {
  where: HorarioWhereUniqueInput;
  update: HorarioUpdateWithoutCompanyDataInput;
  create: HorarioCreateWithoutCompanyInput;
};

export type HorarioWhereInput = {
  id?: Maybe<StringFilter>;
  monday_open?: Maybe<StringFilter>;
  monday_close?: Maybe<StringFilter>;
  tuesday_open?: Maybe<StringFilter>;
  tuesday_close?: Maybe<StringFilter>;
  thursday_open?: Maybe<StringFilter>;
  thursday_close?: Maybe<StringFilter>;
  wednesday_open?: Maybe<StringFilter>;
  wednesday_close?: Maybe<StringFilter>;
  friday_open?: Maybe<StringFilter>;
  friday_close?: Maybe<StringFilter>;
  saturday_open?: Maybe<StringFilter>;
  saturday_close?: Maybe<StringFilter>;
  sunday_open?: Maybe<StringFilter>;
  sunday_close?: Maybe<StringFilter>;
  festive_open?: Maybe<StringFilter>;
  festive_close?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<HorarioWhereInput>>;
  OR?: Maybe<Array<HorarioWhereInput>>;
  NOT?: Maybe<Array<HorarioWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
};

export type HorarioWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type IntList = {
  ids?: Maybe<Array<Scalars['Int']>>;
};

export type Marketer = {
  __typename?: 'marketer';
  id: Scalars['String'];
  name: Scalars['String'];
  short_name: Scalars['String'];
  nit: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  code_movii?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  service_id: Scalars['String'];
  service: Service;
  send_prove?: Maybe<Scalars['Boolean']>;
  accounts: Array<Account>;
  bill: Array<Bill>;
  PaymentMethodMarketer: Array<PaymentMethodMarketer>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type MarketerAccountsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};


export type MarketerBillArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillWhereUniqueInput>;
  after?: Maybe<BillWhereUniqueInput>;
};


export type MarketerPaymentMethodMarketerArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
  after?: Maybe<PaymentMethodMarketerWhereUniqueInput>;
};

export type MarketerCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  short_name: Scalars['String'];
  nit: Scalars['String'];
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutMarketersInput;
  accounts?: Maybe<AccountCreateManyWithoutMarketerInput>;
  bill?: Maybe<BillCreateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerCreateManyWithoutMarketerInput>;
};

export type MarketerCreateManyWithoutServiceInput = {
  create?: Maybe<Array<MarketerCreateWithoutServiceInput>>;
  connect?: Maybe<Array<MarketerWhereUniqueInput>>;
};

export type MarketerCreateOneWithoutAccountsInput = {
  create?: Maybe<MarketerCreateWithoutAccountsInput>;
  connect?: Maybe<MarketerWhereUniqueInput>;
};

export type MarketerCreateOneWithoutBillInput = {
  create?: Maybe<MarketerCreateWithoutBillInput>;
  connect?: Maybe<MarketerWhereUniqueInput>;
};

export type MarketerCreateOneWithoutPaymentMethodMarketerInput = {
  create?: Maybe<MarketerCreateWithoutPaymentMethodMarketerInput>;
  connect?: Maybe<MarketerWhereUniqueInput>;
};

export type MarketerCreateWithoutAccountsInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  short_name: Scalars['String'];
  nit: Scalars['String'];
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutMarketersInput;
  bill?: Maybe<BillCreateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerCreateManyWithoutMarketerInput>;
};

export type MarketerCreateWithoutBillInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  short_name: Scalars['String'];
  nit: Scalars['String'];
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutMarketersInput;
  accounts?: Maybe<AccountCreateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerCreateManyWithoutMarketerInput>;
};

export type MarketerCreateWithoutPaymentMethodMarketerInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  short_name: Scalars['String'];
  nit: Scalars['String'];
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service: ServiceCreateOneWithoutMarketersInput;
  accounts?: Maybe<AccountCreateManyWithoutMarketerInput>;
  bill?: Maybe<BillCreateManyWithoutMarketerInput>;
};

export type MarketerCreateWithoutServiceInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  short_name: Scalars['String'];
  nit: Scalars['String'];
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountCreateManyWithoutMarketerInput>;
  bill?: Maybe<BillCreateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerCreateManyWithoutMarketerInput>;
};

export type MarketerFilter = {
  every?: Maybe<MarketerWhereInput>;
  some?: Maybe<MarketerWhereInput>;
  none?: Maybe<MarketerWhereInput>;
};

export type MarketerOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  short_name?: Maybe<OrderByArg>;
  nit?: Maybe<OrderByArg>;
  send_prove?: Maybe<OrderByArg>;
  code_movii?: Maybe<OrderByArg>;
  email?: Maybe<OrderByArg>;
  phone?: Maybe<OrderByArg>;
  type?: Maybe<OrderByArg>;
  service_id?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type MarketerScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  short_name?: Maybe<StringFilter>;
  nit?: Maybe<StringFilter>;
  send_prove?: Maybe<NullableBooleanFilter>;
  code_movii?: Maybe<NullableStringFilter>;
  email?: Maybe<NullableStringFilter>;
  phone?: Maybe<NullableStringFilter>;
  type?: Maybe<StringFilter>;
  service_id?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  bill?: Maybe<BillFilter>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<MarketerScalarWhereInput>>;
  OR?: Maybe<Array<MarketerScalarWhereInput>>;
  NOT?: Maybe<Array<MarketerScalarWhereInput>>;
};

export type MarketerUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutMarketersInput>;
  accounts?: Maybe<AccountUpdateManyWithoutMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerUpdateManyWithoutMarketerInput>;
};

export type MarketerUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type MarketerUpdateManyWithWhereNestedInput = {
  where: MarketerScalarWhereInput;
  data: MarketerUpdateManyDataInput;
};

export type MarketerUpdateManyWithoutServiceInput = {
  create?: Maybe<Array<MarketerCreateWithoutServiceInput>>;
  connect?: Maybe<Array<MarketerWhereUniqueInput>>;
  set?: Maybe<Array<MarketerWhereUniqueInput>>;
  disconnect?: Maybe<Array<MarketerWhereUniqueInput>>;
  delete?: Maybe<Array<MarketerWhereUniqueInput>>;
  update?: Maybe<Array<MarketerUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: Maybe<Array<MarketerUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<MarketerScalarWhereInput>>;
  upsert?: Maybe<Array<MarketerUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type MarketerUpdateOneRequiredWithoutPaymentMethodMarketerInput = {
  create?: Maybe<MarketerCreateWithoutPaymentMethodMarketerInput>;
  connect?: Maybe<MarketerWhereUniqueInput>;
  update?: Maybe<MarketerUpdateWithoutPaymentMethodMarketerDataInput>;
  upsert?: Maybe<MarketerUpsertWithoutPaymentMethodMarketerInput>;
};

export type MarketerUpdateOneWithoutAccountsInput = {
  create?: Maybe<MarketerCreateWithoutAccountsInput>;
  connect?: Maybe<MarketerWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MarketerUpdateWithoutAccountsDataInput>;
  upsert?: Maybe<MarketerUpsertWithoutAccountsInput>;
};

export type MarketerUpdateOneWithoutBillInput = {
  create?: Maybe<MarketerCreateWithoutBillInput>;
  connect?: Maybe<MarketerWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<MarketerUpdateWithoutBillDataInput>;
  upsert?: Maybe<MarketerUpsertWithoutBillInput>;
};

export type MarketerUpdateWithWhereUniqueWithoutServiceInput = {
  where: MarketerWhereUniqueInput;
  data: MarketerUpdateWithoutServiceDataInput;
};

export type MarketerUpdateWithoutAccountsDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutMarketersInput>;
  bill?: Maybe<BillUpdateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerUpdateManyWithoutMarketerInput>;
};

export type MarketerUpdateWithoutBillDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutMarketersInput>;
  accounts?: Maybe<AccountUpdateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerUpdateManyWithoutMarketerInput>;
};

export type MarketerUpdateWithoutPaymentMethodMarketerDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  service?: Maybe<ServiceUpdateOneRequiredWithoutMarketersInput>;
  accounts?: Maybe<AccountUpdateManyWithoutMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutMarketerInput>;
};

export type MarketerUpdateWithoutServiceDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  send_prove?: Maybe<Scalars['Boolean']>;
  code_movii?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountUpdateManyWithoutMarketerInput>;
  bill?: Maybe<BillUpdateManyWithoutMarketerInput>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerUpdateManyWithoutMarketerInput>;
};

export type MarketerUpsertWithWhereUniqueWithoutServiceInput = {
  where: MarketerWhereUniqueInput;
  update: MarketerUpdateWithoutServiceDataInput;
  create: MarketerCreateWithoutServiceInput;
};

export type MarketerUpsertWithoutAccountsInput = {
  update: MarketerUpdateWithoutAccountsDataInput;
  create: MarketerCreateWithoutAccountsInput;
};

export type MarketerUpsertWithoutBillInput = {
  update: MarketerUpdateWithoutBillDataInput;
  create: MarketerCreateWithoutBillInput;
};

export type MarketerUpsertWithoutPaymentMethodMarketerInput = {
  update: MarketerUpdateWithoutPaymentMethodMarketerDataInput;
  create: MarketerCreateWithoutPaymentMethodMarketerInput;
};

export type MarketerWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  short_name?: Maybe<StringFilter>;
  nit?: Maybe<StringFilter>;
  send_prove?: Maybe<NullableBooleanFilter>;
  code_movii?: Maybe<NullableStringFilter>;
  email?: Maybe<NullableStringFilter>;
  phone?: Maybe<NullableStringFilter>;
  type?: Maybe<StringFilter>;
  service_id?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  bill?: Maybe<BillFilter>;
  PaymentMethodMarketer?: Maybe<PaymentMethodMarketerFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<MarketerWhereInput>>;
  OR?: Maybe<Array<MarketerWhereInput>>;
  NOT?: Maybe<Array<MarketerWhereInput>>;
  service?: Maybe<ServiceWhereInput>;
};

export type MarketerWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
};

export type Meter = {
  __typename?: 'meter';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  status: Scalars['Boolean'];
  description: Scalars['Json'];
  company_id?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  place_id: Scalars['String'];
  place: Place;
  place_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type MeterCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<MeterCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<MeterWhereUniqueInput>>;
};

export type MeterCreateManyWithoutPlaceInput = {
  create?: Maybe<Array<MeterCreateWithoutPlaceInput>>;
  connect?: Maybe<Array<MeterWhereUniqueInput>>;
};

export type MeterCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  description: Scalars['Json'];
  place_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  place: PlaceCreateOneWithoutMetersInput;
};

export type MeterCreateWithoutPlaceInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  description: Scalars['Json'];
  place_name: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyCreateOneWithoutMeterInput>;
};

export type MeterFilter = {
  every?: Maybe<MeterWhereInput>;
  some?: Maybe<MeterWhereInput>;
  none?: Maybe<MeterWhereInput>;
};

export type MeterOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  type?: Maybe<OrderByArg>;
  status?: Maybe<OrderByArg>;
  description?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  place_id?: Maybe<OrderByArg>;
  place_name?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type MeterScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  status?: Maybe<BooleanFilter>;
  company_id?: Maybe<NullableStringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<MeterScalarWhereInput>>;
  OR?: Maybe<Array<MeterScalarWhereInput>>;
  NOT?: Maybe<Array<MeterScalarWhereInput>>;
};

export type MeterUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['Json']>;
  place_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type MeterUpdateManyWithWhereNestedInput = {
  where: MeterScalarWhereInput;
  data: MeterUpdateManyDataInput;
};

export type MeterUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<MeterCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<MeterWhereUniqueInput>>;
  set?: Maybe<Array<MeterWhereUniqueInput>>;
  disconnect?: Maybe<Array<MeterWhereUniqueInput>>;
  delete?: Maybe<Array<MeterWhereUniqueInput>>;
  update?: Maybe<Array<MeterUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<MeterUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<MeterScalarWhereInput>>;
  upsert?: Maybe<Array<MeterUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type MeterUpdateManyWithoutPlaceInput = {
  create?: Maybe<Array<MeterCreateWithoutPlaceInput>>;
  connect?: Maybe<Array<MeterWhereUniqueInput>>;
  set?: Maybe<Array<MeterWhereUniqueInput>>;
  disconnect?: Maybe<Array<MeterWhereUniqueInput>>;
  delete?: Maybe<Array<MeterWhereUniqueInput>>;
  update?: Maybe<Array<MeterUpdateWithWhereUniqueWithoutPlaceInput>>;
  updateMany?: Maybe<Array<MeterUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<MeterScalarWhereInput>>;
  upsert?: Maybe<Array<MeterUpsertWithWhereUniqueWithoutPlaceInput>>;
};

export type MeterUpdateWithWhereUniqueWithoutCompanyInput = {
  where: MeterWhereUniqueInput;
  data: MeterUpdateWithoutCompanyDataInput;
};

export type MeterUpdateWithWhereUniqueWithoutPlaceInput = {
  where: MeterWhereUniqueInput;
  data: MeterUpdateWithoutPlaceDataInput;
};

export type MeterUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['Json']>;
  place_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  place?: Maybe<PlaceUpdateOneRequiredWithoutMetersInput>;
};

export type MeterUpdateWithoutPlaceDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['Json']>;
  place_name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneWithoutMeterInput>;
};

export type MeterUpsertWithWhereUniqueWithoutCompanyInput = {
  where: MeterWhereUniqueInput;
  update: MeterUpdateWithoutCompanyDataInput;
  create: MeterCreateWithoutCompanyInput;
};

export type MeterUpsertWithWhereUniqueWithoutPlaceInput = {
  where: MeterWhereUniqueInput;
  update: MeterUpdateWithoutPlaceDataInput;
  create: MeterCreateWithoutPlaceInput;
};

export type MeterWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
  status?: Maybe<BooleanFilter>;
  company_id?: Maybe<NullableStringFilter>;
  place_id?: Maybe<StringFilter>;
  place_name?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<MeterWhereInput>>;
  OR?: Maybe<Array<MeterWhereInput>>;
  NOT?: Maybe<Array<MeterWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
  place?: Maybe<PlaceWhereInput>;
};

export type MeterWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type MoviiBill = {
  __typename?: 'moviiBill';
  billerName: Scalars['String'];
  referenceNumber: Scalars['String'];
  amount: Scalars['Float'];
};

export type MoviiResponse = {
  __typename?: 'moviiResponse';
  error: Scalars['String'];
  msg: Scalars['String'];
  data: Array<MoviiBill>;
};

export type Place = {
  __typename?: 'place';
  id: Scalars['String'];
  enable_notification: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  regional_id: Scalars['String'];
  regional: Regional;
  accounts: Array<Account>;
  meters: Array<Meter>;
  type_place?: Maybe<Scalars['String']>;
  company_id: Scalars['String'];
  company: Company;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
};


export type PlaceAccountsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};


export type PlaceMetersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<MeterWhereUniqueInput>;
  after?: Maybe<MeterWhereUniqueInput>;
};

export type PlaceCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional: RegionalCreateOneWithoutPlacesInput;
  accounts?: Maybe<AccountCreateManyWithoutPlaceInput>;
  meters?: Maybe<MeterCreateManyWithoutPlaceInput>;
  company: CompanyCreateOneWithoutPlaceInput;
};

export type PlaceCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<PlaceCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<PlaceWhereUniqueInput>>;
};

export type PlaceCreateManyWithoutRegionalInput = {
  create?: Maybe<Array<PlaceCreateWithoutRegionalInput>>;
  connect?: Maybe<Array<PlaceWhereUniqueInput>>;
};

export type PlaceCreateOneWithoutAccountsInput = {
  create?: Maybe<PlaceCreateWithoutAccountsInput>;
  connect?: Maybe<PlaceWhereUniqueInput>;
};

export type PlaceCreateOneWithoutMetersInput = {
  create?: Maybe<PlaceCreateWithoutMetersInput>;
  connect?: Maybe<PlaceWhereUniqueInput>;
};

export type PlaceCreateWithoutAccountsInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional: RegionalCreateOneWithoutPlacesInput;
  meters?: Maybe<MeterCreateManyWithoutPlaceInput>;
  company: CompanyCreateOneWithoutPlaceInput;
};

export type PlaceCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional: RegionalCreateOneWithoutPlacesInput;
  accounts?: Maybe<AccountCreateManyWithoutPlaceInput>;
  meters?: Maybe<MeterCreateManyWithoutPlaceInput>;
};

export type PlaceCreateWithoutMetersInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional: RegionalCreateOneWithoutPlacesInput;
  accounts?: Maybe<AccountCreateManyWithoutPlaceInput>;
  company: CompanyCreateOneWithoutPlaceInput;
};

export type PlaceCreateWithoutRegionalInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  accounts?: Maybe<AccountCreateManyWithoutPlaceInput>;
  meters?: Maybe<MeterCreateManyWithoutPlaceInput>;
  company: CompanyCreateOneWithoutPlaceInput;
};

export type PlaceFilter = {
  every?: Maybe<PlaceWhereInput>;
  some?: Maybe<PlaceWhereInput>;
  none?: Maybe<PlaceWhereInput>;
};

export type PlaceOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  name_two?: Maybe<OrderByArg>;
  phone?: Maybe<OrderByArg>;
  ceco?: Maybe<OrderByArg>;
  city?: Maybe<OrderByArg>;
  deparment?: Maybe<OrderByArg>;
  address?: Maybe<OrderByArg>;
  employers?: Maybe<OrderByArg>;
  area?: Maybe<OrderByArg>;
  regional_id?: Maybe<OrderByArg>;
  enable_notification?: Maybe<OrderByArg>;
  email?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  office_code?: Maybe<OrderByArg>;
  working_time?: Maybe<OrderByArg>;
  type_place?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
  is_active?: Maybe<OrderByArg>;
};

export type PlaceScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  name_two?: Maybe<NullableStringFilter>;
  phone?: Maybe<NullableStringFilter>;
  ceco?: Maybe<NullableStringFilter>;
  city?: Maybe<NullableStringFilter>;
  deparment?: Maybe<NullableStringFilter>;
  address?: Maybe<NullableStringFilter>;
  employers?: Maybe<NullableIntFilter>;
  area?: Maybe<NullableFloatFilter>;
  regional_id?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  meters?: Maybe<MeterFilter>;
  enable_notification?: Maybe<BooleanFilter>;
  email?: Maybe<NullableStringFilter>;
  company_id?: Maybe<StringFilter>;
  office_code?: Maybe<NullableStringFilter>;
  type_place?: Maybe<NullableStringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  AND?: Maybe<Array<PlaceScalarWhereInput>>;
  OR?: Maybe<Array<PlaceScalarWhereInput>>;
  NOT?: Maybe<Array<PlaceScalarWhereInput>>;
};

export type PlaceUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutPlacesInput>;
  accounts?: Maybe<AccountUpdateManyWithoutPlaceInput>;
  meters?: Maybe<MeterUpdateManyWithoutPlaceInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutPlaceInput>;
};

export type PlaceUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
};

export type PlaceUpdateManyWithWhereNestedInput = {
  where: PlaceScalarWhereInput;
  data: PlaceUpdateManyDataInput;
};

export type PlaceUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<PlaceCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<PlaceWhereUniqueInput>>;
  set?: Maybe<Array<PlaceWhereUniqueInput>>;
  disconnect?: Maybe<Array<PlaceWhereUniqueInput>>;
  delete?: Maybe<Array<PlaceWhereUniqueInput>>;
  update?: Maybe<Array<PlaceUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<PlaceUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<PlaceScalarWhereInput>>;
  upsert?: Maybe<Array<PlaceUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type PlaceUpdateManyWithoutRegionalInput = {
  create?: Maybe<Array<PlaceCreateWithoutRegionalInput>>;
  connect?: Maybe<Array<PlaceWhereUniqueInput>>;
  set?: Maybe<Array<PlaceWhereUniqueInput>>;
  disconnect?: Maybe<Array<PlaceWhereUniqueInput>>;
  delete?: Maybe<Array<PlaceWhereUniqueInput>>;
  update?: Maybe<Array<PlaceUpdateWithWhereUniqueWithoutRegionalInput>>;
  updateMany?: Maybe<Array<PlaceUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<PlaceScalarWhereInput>>;
  upsert?: Maybe<Array<PlaceUpsertWithWhereUniqueWithoutRegionalInput>>;
};

export type PlaceUpdateOneRequiredWithoutAccountsInput = {
  create?: Maybe<PlaceCreateWithoutAccountsInput>;
  connect?: Maybe<PlaceWhereUniqueInput>;
  update?: Maybe<PlaceUpdateWithoutAccountsDataInput>;
  upsert?: Maybe<PlaceUpsertWithoutAccountsInput>;
};

export type PlaceUpdateOneRequiredWithoutMetersInput = {
  create?: Maybe<PlaceCreateWithoutMetersInput>;
  connect?: Maybe<PlaceWhereUniqueInput>;
  update?: Maybe<PlaceUpdateWithoutMetersDataInput>;
  upsert?: Maybe<PlaceUpsertWithoutMetersInput>;
};

export type PlaceUpdateWithWhereUniqueWithoutCompanyInput = {
  where: PlaceWhereUniqueInput;
  data: PlaceUpdateWithoutCompanyDataInput;
};

export type PlaceUpdateWithWhereUniqueWithoutRegionalInput = {
  where: PlaceWhereUniqueInput;
  data: PlaceUpdateWithoutRegionalDataInput;
};

export type PlaceUpdateWithoutAccountsDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutPlacesInput>;
  meters?: Maybe<MeterUpdateManyWithoutPlaceInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutPlaceInput>;
};

export type PlaceUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutPlacesInput>;
  accounts?: Maybe<AccountUpdateManyWithoutPlaceInput>;
  meters?: Maybe<MeterUpdateManyWithoutPlaceInput>;
};

export type PlaceUpdateWithoutMetersDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  regional?: Maybe<RegionalUpdateOneRequiredWithoutPlacesInput>;
  accounts?: Maybe<AccountUpdateManyWithoutPlaceInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutPlaceInput>;
};

export type PlaceUpdateWithoutRegionalDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_two?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ceco?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deparment?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  employers?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['Float']>;
  enable_notification?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  office_code?: Maybe<Scalars['String']>;
  working_time?: Maybe<Scalars['Json']>;
  type_place?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  accounts?: Maybe<AccountUpdateManyWithoutPlaceInput>;
  meters?: Maybe<MeterUpdateManyWithoutPlaceInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutPlaceInput>;
};

export type PlaceUpsertWithWhereUniqueWithoutCompanyInput = {
  where: PlaceWhereUniqueInput;
  update: PlaceUpdateWithoutCompanyDataInput;
  create: PlaceCreateWithoutCompanyInput;
};

export type PlaceUpsertWithWhereUniqueWithoutRegionalInput = {
  where: PlaceWhereUniqueInput;
  update: PlaceUpdateWithoutRegionalDataInput;
  create: PlaceCreateWithoutRegionalInput;
};

export type PlaceUpsertWithoutAccountsInput = {
  update: PlaceUpdateWithoutAccountsDataInput;
  create: PlaceCreateWithoutAccountsInput;
};

export type PlaceUpsertWithoutMetersInput = {
  update: PlaceUpdateWithoutMetersDataInput;
  create: PlaceCreateWithoutMetersInput;
};

export type PlaceWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  name_two?: Maybe<NullableStringFilter>;
  phone?: Maybe<NullableStringFilter>;
  ceco?: Maybe<NullableStringFilter>;
  city?: Maybe<NullableStringFilter>;
  deparment?: Maybe<NullableStringFilter>;
  address?: Maybe<NullableStringFilter>;
  employers?: Maybe<NullableIntFilter>;
  area?: Maybe<NullableFloatFilter>;
  regional_id?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  meters?: Maybe<MeterFilter>;
  enable_notification?: Maybe<BooleanFilter>;
  email?: Maybe<NullableStringFilter>;
  company_id?: Maybe<StringFilter>;
  office_code?: Maybe<NullableStringFilter>;
  type_place?: Maybe<NullableStringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  AND?: Maybe<Array<PlaceWhereInput>>;
  OR?: Maybe<Array<PlaceWhereInput>>;
  NOT?: Maybe<Array<PlaceWhereInput>>;
  regional?: Maybe<RegionalWhereInput>;
  company?: Maybe<CompanyWhereInput>;
};

export type PlaceWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  UniquePlaceAndCompanyIndex?: Maybe<UniquePlaceAndCompanyIndexCompoundUniqueInput>;
};

export type Regional = {
  __typename?: 'regional';
  id: Scalars['String'];
  name: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  company_id: Scalars['String'];
  company: Company;
  places: Array<Place>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  account: Array<Account>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
};


export type RegionalPlacesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<PlaceWhereUniqueInput>;
  after?: Maybe<PlaceWhereUniqueInput>;
};


export type RegionalAccountArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};

export type RegionalCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  company: CompanyCreateOneWithoutRegionalsInput;
  places?: Maybe<PlaceCreateManyWithoutRegionalInput>;
  account?: Maybe<AccountCreateManyWithoutRegionalInput>;
};

export type RegionalCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<RegionalCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<RegionalWhereUniqueInput>>;
};

export type RegionalCreateOneWithoutAccountInput = {
  create?: Maybe<RegionalCreateWithoutAccountInput>;
  connect?: Maybe<RegionalWhereUniqueInput>;
};

export type RegionalCreateOneWithoutPlacesInput = {
  create?: Maybe<RegionalCreateWithoutPlacesInput>;
  connect?: Maybe<RegionalWhereUniqueInput>;
};

export type RegionalCreateWithoutAccountInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  company: CompanyCreateOneWithoutRegionalsInput;
  places?: Maybe<PlaceCreateManyWithoutRegionalInput>;
};

export type RegionalCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  places?: Maybe<PlaceCreateManyWithoutRegionalInput>;
  account?: Maybe<AccountCreateManyWithoutRegionalInput>;
};

export type RegionalCreateWithoutPlacesInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  manager?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  company: CompanyCreateOneWithoutRegionalsInput;
  account?: Maybe<AccountCreateManyWithoutRegionalInput>;
};

export type RegionalFilter = {
  every?: Maybe<RegionalWhereInput>;
  some?: Maybe<RegionalWhereInput>;
  none?: Maybe<RegionalWhereInput>;
};

export type RegionalOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  manager?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
  is_active?: Maybe<OrderByArg>;
};

export type RegionalScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  manager?: Maybe<NullableStringFilter>;
  company_id?: Maybe<StringFilter>;
  places?: Maybe<PlaceFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  account?: Maybe<AccountFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  AND?: Maybe<Array<RegionalScalarWhereInput>>;
  OR?: Maybe<Array<RegionalScalarWhereInput>>;
  NOT?: Maybe<Array<RegionalScalarWhereInput>>;
};

export type RegionalUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutRegionalsInput>;
  places?: Maybe<PlaceUpdateManyWithoutRegionalInput>;
  account?: Maybe<AccountUpdateManyWithoutRegionalInput>;
};

export type RegionalUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
};

export type RegionalUpdateManyWithWhereNestedInput = {
  where: RegionalScalarWhereInput;
  data: RegionalUpdateManyDataInput;
};

export type RegionalUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<RegionalCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<RegionalWhereUniqueInput>>;
  set?: Maybe<Array<RegionalWhereUniqueInput>>;
  disconnect?: Maybe<Array<RegionalWhereUniqueInput>>;
  delete?: Maybe<Array<RegionalWhereUniqueInput>>;
  update?: Maybe<Array<RegionalUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<RegionalUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<RegionalScalarWhereInput>>;
  upsert?: Maybe<Array<RegionalUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type RegionalUpdateOneRequiredWithoutAccountInput = {
  create?: Maybe<RegionalCreateWithoutAccountInput>;
  connect?: Maybe<RegionalWhereUniqueInput>;
  update?: Maybe<RegionalUpdateWithoutAccountDataInput>;
  upsert?: Maybe<RegionalUpsertWithoutAccountInput>;
};

export type RegionalUpdateOneRequiredWithoutPlacesInput = {
  create?: Maybe<RegionalCreateWithoutPlacesInput>;
  connect?: Maybe<RegionalWhereUniqueInput>;
  update?: Maybe<RegionalUpdateWithoutPlacesDataInput>;
  upsert?: Maybe<RegionalUpsertWithoutPlacesInput>;
};

export type RegionalUpdateWithWhereUniqueWithoutCompanyInput = {
  where: RegionalWhereUniqueInput;
  data: RegionalUpdateWithoutCompanyDataInput;
};

export type RegionalUpdateWithoutAccountDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutRegionalsInput>;
  places?: Maybe<PlaceUpdateManyWithoutRegionalInput>;
};

export type RegionalUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  places?: Maybe<PlaceUpdateManyWithoutRegionalInput>;
  account?: Maybe<AccountUpdateManyWithoutRegionalInput>;
};

export type RegionalUpdateWithoutPlacesDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  is_active?: Maybe<Scalars['Boolean']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutRegionalsInput>;
  account?: Maybe<AccountUpdateManyWithoutRegionalInput>;
};

export type RegionalUpsertWithWhereUniqueWithoutCompanyInput = {
  where: RegionalWhereUniqueInput;
  update: RegionalUpdateWithoutCompanyDataInput;
  create: RegionalCreateWithoutCompanyInput;
};

export type RegionalUpsertWithoutAccountInput = {
  update: RegionalUpdateWithoutAccountDataInput;
  create: RegionalCreateWithoutAccountInput;
};

export type RegionalUpsertWithoutPlacesInput = {
  update: RegionalUpdateWithoutPlacesDataInput;
  create: RegionalCreateWithoutPlacesInput;
};

export type RegionalWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  manager?: Maybe<NullableStringFilter>;
  company_id?: Maybe<StringFilter>;
  places?: Maybe<PlaceFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  account?: Maybe<AccountFilter>;
  is_active?: Maybe<NullableBooleanFilter>;
  AND?: Maybe<Array<RegionalWhereInput>>;
  OR?: Maybe<Array<RegionalWhereInput>>;
  NOT?: Maybe<Array<RegionalWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
};

export type RegionalWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  UniqueRegionalAndCompanyIndex?: Maybe<UniqueRegionalAndCompanyIndexCompoundUniqueInput>;
};

export type RepGeneralCarga = {
  __typename?: 'repGeneralCarga';
  id: Scalars['String'];
  name: Scalars['String'];
  reportgeneralcarga: Scalars['String'];
};

export type ReportConsolidados = {
  fecha_inicio?: Maybe<Scalars['String']>;
  fecha_fin?: Maybe<Scalars['String']>;
  separador?: Maybe<Scalars['String']>;
  proyecto?: Maybe<Scalars['Int']>;
  sucursales?: Maybe<Array<Scalars['Int']>>;
  metodo_relleno?: Maybe<Scalars['String']>;
};

export type ReportDigitadores = {
  proyectos?: Maybe<Array<Scalars['String']>>;
  sucursales?: Maybe<Array<Scalars['String']>>;
  fecha_inicio?: Maybe<Scalars['String']>;
  fecha_fin?: Maybe<Scalars['String']>;
  tipo?: Maybe<Scalars['String']>;
  digitadores?: Maybe<Array<Scalars['Int']>>;
};

export type ReportMeters = {
  fecha_inicio?: Maybe<Scalars['String']>;
  separador?: Maybe<Scalars['String']>;
  fecha_fin?: Maybe<Scalars['String']>;
  frecuencia?: Maybe<Scalars['String']>;
  meters?: Maybe<Array<Scalars['Int']>>;
};

export type ReportPagos = {
  fecha_inicio?: Maybe<Scalars['String']>;
  fecha_fin?: Maybe<Scalars['String']>;
  separador?: Maybe<Scalars['String']>;
  proyecto?: Maybe<Scalars['String']>;
  sucursales?: Maybe<Array<Scalars['String']>>;
};

export type ReportStatus = {
  __typename?: 'reportStatus';
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
  user_name: Scalars['String'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Json']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type ReportStatusCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<ReportStatusCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<ReportStatusWhereUniqueInput>>;
};

export type ReportStatusCreateManyWithoutUserInput = {
  create?: Maybe<Array<ReportStatusCreateWithoutUserInput>>;
  connect?: Maybe<Array<ReportStatusWhereUniqueInput>>;
};

export type ReportStatusCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
  user_name: Scalars['String'];
  data?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserCreateOneWithoutReportStatusInput>;
};

export type ReportStatusCreateWithoutUserInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
  user_name: Scalars['String'];
  data?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyCreateOneWithoutReportStatusInput>;
};

export type ReportStatusFilter = {
  every?: Maybe<ReportStatusWhereInput>;
  some?: Maybe<ReportStatusWhereInput>;
  none?: Maybe<ReportStatusWhereInput>;
};

export type ReportStatusOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  status?: Maybe<OrderByArg>;
  user_id?: Maybe<OrderByArg>;
  user_name?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  data?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type ReportStatusScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<StringFilter>;
  user_id?: Maybe<NullableStringFilter>;
  user_name?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<ReportStatusScalarWhereInput>>;
  OR?: Maybe<Array<ReportStatusScalarWhereInput>>;
  NOT?: Maybe<Array<ReportStatusScalarWhereInput>>;
};

export type ReportStatusUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type ReportStatusUpdateManyWithWhereNestedInput = {
  where: ReportStatusScalarWhereInput;
  data: ReportStatusUpdateManyDataInput;
};

export type ReportStatusUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<ReportStatusCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  set?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  disconnect?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  delete?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  update?: Maybe<Array<ReportStatusUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<ReportStatusUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<ReportStatusScalarWhereInput>>;
  upsert?: Maybe<Array<ReportStatusUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type ReportStatusUpdateManyWithoutUserInput = {
  create?: Maybe<Array<ReportStatusCreateWithoutUserInput>>;
  connect?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  set?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  disconnect?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  delete?: Maybe<Array<ReportStatusWhereUniqueInput>>;
  update?: Maybe<Array<ReportStatusUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ReportStatusUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<ReportStatusScalarWhereInput>>;
  upsert?: Maybe<Array<ReportStatusUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ReportStatusUpdateWithWhereUniqueWithoutCompanyInput = {
  where: ReportStatusWhereUniqueInput;
  data: ReportStatusUpdateWithoutCompanyDataInput;
};

export type ReportStatusUpdateWithWhereUniqueWithoutUserInput = {
  where: ReportStatusWhereUniqueInput;
  data: ReportStatusUpdateWithoutUserDataInput;
};

export type ReportStatusUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserUpdateOneWithoutReportStatusInput>;
};

export type ReportStatusUpdateWithoutUserDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneWithoutReportStatusInput>;
};

export type ReportStatusUpsertWithWhereUniqueWithoutCompanyInput = {
  where: ReportStatusWhereUniqueInput;
  update: ReportStatusUpdateWithoutCompanyDataInput;
  create: ReportStatusCreateWithoutCompanyInput;
};

export type ReportStatusUpsertWithWhereUniqueWithoutUserInput = {
  where: ReportStatusWhereUniqueInput;
  update: ReportStatusUpdateWithoutUserDataInput;
  create: ReportStatusCreateWithoutUserInput;
};

export type ReportStatusWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  status?: Maybe<StringFilter>;
  user_id?: Maybe<NullableStringFilter>;
  user_name?: Maybe<StringFilter>;
  company_id?: Maybe<NullableStringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<ReportStatusWhereInput>>;
  OR?: Maybe<Array<ReportStatusWhereInput>>;
  NOT?: Maybe<Array<ReportStatusWhereInput>>;
  user?: Maybe<UserWhereInput>;
  company?: Maybe<CompanyWhereInput>;
};

export type ReportStatusWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Rol = {
  __typename?: 'rol';
  id: Scalars['String'];
  name: Scalars['String'];
  permission: Scalars['Json'];
  application_id: Scalars['String'];
  application: Application;
  roles_aplication: Array<UserApplicationRol>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type RolRoles_AplicationArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<UserApplicationRolWhereUniqueInput>;
  after?: Maybe<UserApplicationRolWhereUniqueInput>;
};

export type RolCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permission: Scalars['Json'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  application: ApplicationCreateOneWithoutRolInput;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutRolsInput>;
};

export type RolCreateManyWithoutApplicationInput = {
  create?: Maybe<Array<RolCreateWithoutApplicationInput>>;
  connect?: Maybe<Array<RolWhereUniqueInput>>;
};

export type RolCreateOneWithoutRoles_AplicationInput = {
  create?: Maybe<RolCreateWithoutRoles_AplicationInput>;
  connect?: Maybe<RolWhereUniqueInput>;
};

export type RolCreateWithoutApplicationInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permission: Scalars['Json'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutRolsInput>;
};

export type RolCreateWithoutRoles_AplicationInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permission: Scalars['Json'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  application: ApplicationCreateOneWithoutRolInput;
};

export type RolFilter = {
  every?: Maybe<RolWhereInput>;
  some?: Maybe<RolWhereInput>;
  none?: Maybe<RolWhereInput>;
};

export type RolScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  application_id?: Maybe<StringFilter>;
  roles_aplication?: Maybe<UserApplicationRolFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<RolScalarWhereInput>>;
  OR?: Maybe<Array<RolScalarWhereInput>>;
  NOT?: Maybe<Array<RolScalarWhereInput>>;
};

export type RolUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  application?: Maybe<ApplicationUpdateOneRequiredWithoutRolInput>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutRolsInput>;
};

export type RolUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type RolUpdateManyWithWhereNestedInput = {
  where: RolScalarWhereInput;
  data: RolUpdateManyDataInput;
};

export type RolUpdateManyWithoutApplicationInput = {
  create?: Maybe<Array<RolCreateWithoutApplicationInput>>;
  connect?: Maybe<Array<RolWhereUniqueInput>>;
  set?: Maybe<Array<RolWhereUniqueInput>>;
  disconnect?: Maybe<Array<RolWhereUniqueInput>>;
  delete?: Maybe<Array<RolWhereUniqueInput>>;
  update?: Maybe<Array<RolUpdateWithWhereUniqueWithoutApplicationInput>>;
  updateMany?: Maybe<Array<RolUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<RolScalarWhereInput>>;
  upsert?: Maybe<Array<RolUpsertWithWhereUniqueWithoutApplicationInput>>;
};

export type RolUpdateOneRequiredWithoutRoles_AplicationInput = {
  create?: Maybe<RolCreateWithoutRoles_AplicationInput>;
  connect?: Maybe<RolWhereUniqueInput>;
  update?: Maybe<RolUpdateWithoutRoles_AplicationDataInput>;
  upsert?: Maybe<RolUpsertWithoutRoles_AplicationInput>;
};

export type RolUpdateWithWhereUniqueWithoutApplicationInput = {
  where: RolWhereUniqueInput;
  data: RolUpdateWithoutApplicationDataInput;
};

export type RolUpdateWithoutApplicationDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutRolsInput>;
};

export type RolUpdateWithoutRoles_AplicationDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  application?: Maybe<ApplicationUpdateOneRequiredWithoutRolInput>;
};

export type RolUpsertWithWhereUniqueWithoutApplicationInput = {
  where: RolWhereUniqueInput;
  update: RolUpdateWithoutApplicationDataInput;
  create: RolCreateWithoutApplicationInput;
};

export type RolUpsertWithoutRoles_AplicationInput = {
  update: RolUpdateWithoutRoles_AplicationDataInput;
  create: RolCreateWithoutRoles_AplicationInput;
};

export type RolWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  application_id?: Maybe<StringFilter>;
  roles_aplication?: Maybe<UserApplicationRolFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<RolWhereInput>>;
  OR?: Maybe<Array<RolWhereInput>>;
  NOT?: Maybe<Array<RolWhereInput>>;
  application?: Maybe<ApplicationWhereInput>;
};

export type RolWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Sdl = {
  __typename?: 'sdl';
  id: Scalars['String'];
  name: Scalars['String'];
  accounts: Array<Account>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type SdlAccountsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};

export type SdlCreateOneWithoutAccountsInput = {
  create?: Maybe<SdlCreateWithoutAccountsInput>;
  connect?: Maybe<SdlWhereUniqueInput>;
};

export type SdlCreateWithoutAccountsInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SdlUpdateOneWithoutAccountsInput = {
  create?: Maybe<SdlCreateWithoutAccountsInput>;
  connect?: Maybe<SdlWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<SdlUpdateWithoutAccountsDataInput>;
  upsert?: Maybe<SdlUpsertWithoutAccountsInput>;
};

export type SdlUpdateWithoutAccountsDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SdlUpsertWithoutAccountsInput = {
  update: SdlUpdateWithoutAccountsDataInput;
  create: SdlCreateWithoutAccountsInput;
};

export type SdlWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<SdlWhereInput>>;
  OR?: Maybe<Array<SdlWhereInput>>;
  NOT?: Maybe<Array<SdlWhereInput>>;
};

export type SdlWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'service';
  id: Scalars['String'];
  name: Scalars['String'];
  icon: Scalars['String'];
  accounts: Array<Account>;
  marketers: Array<Marketer>;
  bill: Array<Bill>;
  concept: Array<Concept>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type ServiceAccountsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<AccountWhereUniqueInput>;
  after?: Maybe<AccountWhereUniqueInput>;
};


export type ServiceMarketersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<MarketerWhereUniqueInput>;
  after?: Maybe<MarketerWhereUniqueInput>;
};


export type ServiceBillArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillWhereUniqueInput>;
  after?: Maybe<BillWhereUniqueInput>;
};


export type ServiceConceptArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ConceptWhereUniqueInput>;
  after?: Maybe<ConceptWhereUniqueInput>;
};

export type ServiceCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  icon: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountCreateManyWithoutServiceInput>;
  marketers?: Maybe<MarketerCreateManyWithoutServiceInput>;
  bill?: Maybe<BillCreateManyWithoutServiceInput>;
  concept?: Maybe<ConceptCreateManyWithoutServiceInput>;
};

export type ServiceCreateOneWithoutAccountsInput = {
  create?: Maybe<ServiceCreateWithoutAccountsInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
};

export type ServiceCreateOneWithoutBillInput = {
  create?: Maybe<ServiceCreateWithoutBillInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
};

export type ServiceCreateOneWithoutConceptInput = {
  create?: Maybe<ServiceCreateWithoutConceptInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
};

export type ServiceCreateOneWithoutMarketersInput = {
  create?: Maybe<ServiceCreateWithoutMarketersInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
};

export type ServiceCreateWithoutAccountsInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  icon: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketers?: Maybe<MarketerCreateManyWithoutServiceInput>;
  bill?: Maybe<BillCreateManyWithoutServiceInput>;
  concept?: Maybe<ConceptCreateManyWithoutServiceInput>;
};

export type ServiceCreateWithoutBillInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  icon: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountCreateManyWithoutServiceInput>;
  marketers?: Maybe<MarketerCreateManyWithoutServiceInput>;
  concept?: Maybe<ConceptCreateManyWithoutServiceInput>;
};

export type ServiceCreateWithoutConceptInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  icon: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountCreateManyWithoutServiceInput>;
  marketers?: Maybe<MarketerCreateManyWithoutServiceInput>;
  bill?: Maybe<BillCreateManyWithoutServiceInput>;
};

export type ServiceCreateWithoutMarketersInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  icon: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountCreateManyWithoutServiceInput>;
  bill?: Maybe<BillCreateManyWithoutServiceInput>;
  concept?: Maybe<ConceptCreateManyWithoutServiceInput>;
};

export type ServiceOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  icon?: Maybe<OrderByArg>;
  user_updated?: Maybe<OrderByArg>;
  user_deleted?: Maybe<OrderByArg>;
  user_created?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type ServiceUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountUpdateManyWithoutServiceInput>;
  marketers?: Maybe<MarketerUpdateManyWithoutServiceInput>;
  bill?: Maybe<BillUpdateManyWithoutServiceInput>;
  concept?: Maybe<ConceptUpdateManyWithoutServiceInput>;
};

export type ServiceUpdateOneRequiredWithoutBillInput = {
  create?: Maybe<ServiceCreateWithoutBillInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
  update?: Maybe<ServiceUpdateWithoutBillDataInput>;
  upsert?: Maybe<ServiceUpsertWithoutBillInput>;
};

export type ServiceUpdateOneRequiredWithoutConceptInput = {
  create?: Maybe<ServiceCreateWithoutConceptInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
  update?: Maybe<ServiceUpdateWithoutConceptDataInput>;
  upsert?: Maybe<ServiceUpsertWithoutConceptInput>;
};

export type ServiceUpdateOneRequiredWithoutMarketersInput = {
  create?: Maybe<ServiceCreateWithoutMarketersInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
  update?: Maybe<ServiceUpdateWithoutMarketersDataInput>;
  upsert?: Maybe<ServiceUpsertWithoutMarketersInput>;
};

export type ServiceUpdateOneWithoutAccountsInput = {
  create?: Maybe<ServiceCreateWithoutAccountsInput>;
  connect?: Maybe<ServiceWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<ServiceUpdateWithoutAccountsDataInput>;
  upsert?: Maybe<ServiceUpsertWithoutAccountsInput>;
};

export type ServiceUpdateWithoutAccountsDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  marketers?: Maybe<MarketerUpdateManyWithoutServiceInput>;
  bill?: Maybe<BillUpdateManyWithoutServiceInput>;
  concept?: Maybe<ConceptUpdateManyWithoutServiceInput>;
};

export type ServiceUpdateWithoutBillDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountUpdateManyWithoutServiceInput>;
  marketers?: Maybe<MarketerUpdateManyWithoutServiceInput>;
  concept?: Maybe<ConceptUpdateManyWithoutServiceInput>;
};

export type ServiceUpdateWithoutConceptDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountUpdateManyWithoutServiceInput>;
  marketers?: Maybe<MarketerUpdateManyWithoutServiceInput>;
  bill?: Maybe<BillUpdateManyWithoutServiceInput>;
};

export type ServiceUpdateWithoutMarketersDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  accounts?: Maybe<AccountUpdateManyWithoutServiceInput>;
  bill?: Maybe<BillUpdateManyWithoutServiceInput>;
  concept?: Maybe<ConceptUpdateManyWithoutServiceInput>;
};

export type ServiceUpsertWithoutAccountsInput = {
  update: ServiceUpdateWithoutAccountsDataInput;
  create: ServiceCreateWithoutAccountsInput;
};

export type ServiceUpsertWithoutBillInput = {
  update: ServiceUpdateWithoutBillDataInput;
  create: ServiceCreateWithoutBillInput;
};

export type ServiceUpsertWithoutConceptInput = {
  update: ServiceUpdateWithoutConceptDataInput;
  create: ServiceCreateWithoutConceptInput;
};

export type ServiceUpsertWithoutMarketersInput = {
  update: ServiceUpdateWithoutMarketersDataInput;
  create: ServiceCreateWithoutMarketersInput;
};

export type ServiceWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  icon?: Maybe<StringFilter>;
  accounts?: Maybe<AccountFilter>;
  marketers?: Maybe<MarketerFilter>;
  bill?: Maybe<BillFilter>;
  concept?: Maybe<ConceptFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<ServiceWhereInput>>;
  OR?: Maybe<Array<ServiceWhereInput>>;
  NOT?: Maybe<Array<ServiceWhereInput>>;
};

export type ServiceWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Session = {
  __typename?: 'session';
  id: Scalars['String'];
  application_id: Scalars['String'];
  user_id: Scalars['String'];
  token: Scalars['String'];
  ip?: Maybe<Scalars['String']>;
  browser?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SessionCreateInput = {
  id?: Maybe<Scalars['String']>;
  application_id: Scalars['String'];
  user_id: Scalars['String'];
  token: Scalars['String'];
  ip?: Maybe<Scalars['String']>;
  browser?: Maybe<Scalars['String']>;
  expires_at: Scalars['DateTime'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SessionUpdateInput = {
  id?: Maybe<Scalars['String']>;
  application_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  browser?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SessionWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Setting = {
  __typename?: 'setting';
  id: Scalars['String'];
  name: Scalars['String'];
  value?: Maybe<Scalars['Json']>;
  company_id: Scalars['String'];
  company: Company;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type SettingCreateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company: CompanyCreateOneWithoutSettingInput;
};

export type SettingCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<SettingCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<SettingWhereUniqueInput>>;
};

export type SettingCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SettingFilter = {
  every?: Maybe<SettingWhereInput>;
  some?: Maybe<SettingWhereInput>;
  none?: Maybe<SettingWhereInput>;
};

export type SettingOrderByInput = {
  id?: Maybe<OrderByArg>;
  name?: Maybe<OrderByArg>;
  value?: Maybe<OrderByArg>;
  company_id?: Maybe<OrderByArg>;
  created_at?: Maybe<OrderByArg>;
  updated_at?: Maybe<OrderByArg>;
  deleted_at?: Maybe<OrderByArg>;
};

export type SettingScalarWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<SettingScalarWhereInput>>;
  OR?: Maybe<Array<SettingScalarWhereInput>>;
  NOT?: Maybe<Array<SettingScalarWhereInput>>;
};

export type SettingUpdateInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutSettingInput>;
};

export type SettingUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SettingUpdateManyWithWhereNestedInput = {
  where: SettingScalarWhereInput;
  data: SettingUpdateManyDataInput;
};

export type SettingUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<SettingCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<SettingWhereUniqueInput>>;
  set?: Maybe<Array<SettingWhereUniqueInput>>;
  disconnect?: Maybe<Array<SettingWhereUniqueInput>>;
  delete?: Maybe<Array<SettingWhereUniqueInput>>;
  update?: Maybe<Array<SettingUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<SettingUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<SettingScalarWhereInput>>;
  upsert?: Maybe<Array<SettingUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type SettingUpdateWithWhereUniqueWithoutCompanyInput = {
  where: SettingWhereUniqueInput;
  data: SettingUpdateWithoutCompanyDataInput;
};

export type SettingUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type SettingUpsertWithWhereUniqueWithoutCompanyInput = {
  where: SettingWhereUniqueInput;
  update: SettingUpdateWithoutCompanyDataInput;
  create: SettingCreateWithoutCompanyInput;
};

export type SettingWhereInput = {
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<SettingWhereInput>>;
  OR?: Maybe<Array<SettingWhereInput>>;
  NOT?: Maybe<Array<SettingWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
};

export type SettingWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type SignIn = {
  user?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'user';
  id: Scalars['String'];
  email: Scalars['String'];
  nickname: Scalars['String'];
  password: Scalars['String'];
  names: Scalars['String'];
  lastnames: Scalars['String'];
  company_id: Scalars['String'];
  company: Company;
  bill: Array<Bill>;
  roles_aplication: Array<UserApplicationRol>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  last_login: Scalars['DateTime'];
  reportStatus: Array<ReportStatus>;
  status: Scalars['Boolean'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type UserBillArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<BillWhereUniqueInput>;
  after?: Maybe<BillWhereUniqueInput>;
};


export type UserRoles_AplicationArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<UserApplicationRolWhereUniqueInput>;
  after?: Maybe<UserApplicationRolWhereUniqueInput>;
};


export type UserReportStatusArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ReportStatusWhereUniqueInput>;
  after?: Maybe<ReportStatusWhereUniqueInput>;
};

export type UserApplicationRol = {
  __typename?: 'userApplicationRol';
  id: Scalars['String'];
  user_id: Scalars['String'];
  users: User;
  application_id: Scalars['String'];
  applications: Application;
  rol_id: Scalars['String'];
  rols: Rol;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type UserApplicationRolCreateInput = {
  id?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  users: UserCreateOneWithoutRoles_AplicationInput;
  applications: ApplicationCreateOneWithoutRoles_AplicationInput;
  rols: RolCreateOneWithoutRoles_AplicationInput;
};

export type UserApplicationRolCreateManyWithoutApplicationsInput = {
  create?: Maybe<Array<UserApplicationRolCreateWithoutApplicationsInput>>;
  connect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
};

export type UserApplicationRolCreateManyWithoutRolsInput = {
  create?: Maybe<Array<UserApplicationRolCreateWithoutRolsInput>>;
  connect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
};

export type UserApplicationRolCreateManyWithoutUsersInput = {
  create?: Maybe<Array<UserApplicationRolCreateWithoutUsersInput>>;
  connect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
};

export type UserApplicationRolCreateWithoutApplicationsInput = {
  id?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  users: UserCreateOneWithoutRoles_AplicationInput;
  rols: RolCreateOneWithoutRoles_AplicationInput;
};

export type UserApplicationRolCreateWithoutRolsInput = {
  id?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  users: UserCreateOneWithoutRoles_AplicationInput;
  applications: ApplicationCreateOneWithoutRoles_AplicationInput;
};

export type UserApplicationRolCreateWithoutUsersInput = {
  id?: Maybe<Scalars['String']>;
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  applications: ApplicationCreateOneWithoutRoles_AplicationInput;
  rols: RolCreateOneWithoutRoles_AplicationInput;
};

export type UserApplicationRolFilter = {
  every?: Maybe<UserApplicationRolWhereInput>;
  some?: Maybe<UserApplicationRolWhereInput>;
  none?: Maybe<UserApplicationRolWhereInput>;
};

export type UserApplicationRolScalarWhereInput = {
  id?: Maybe<StringFilter>;
  user_id?: Maybe<StringFilter>;
  application_id?: Maybe<StringFilter>;
  rol_id?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<UserApplicationRolScalarWhereInput>>;
  OR?: Maybe<Array<UserApplicationRolScalarWhereInput>>;
  NOT?: Maybe<Array<UserApplicationRolScalarWhereInput>>;
};

export type UserApplicationRolUpdateInput = {
  id?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateOneRequiredWithoutRoles_AplicationInput>;
  applications?: Maybe<ApplicationUpdateOneRequiredWithoutRoles_AplicationInput>;
  rols?: Maybe<RolUpdateOneRequiredWithoutRoles_AplicationInput>;
};

export type UserApplicationRolUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type UserApplicationRolUpdateManyWithWhereNestedInput = {
  where: UserApplicationRolScalarWhereInput;
  data: UserApplicationRolUpdateManyDataInput;
};

export type UserApplicationRolUpdateManyWithoutApplicationsInput = {
  create?: Maybe<Array<UserApplicationRolCreateWithoutApplicationsInput>>;
  connect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  set?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  delete?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  update?: Maybe<Array<UserApplicationRolUpdateWithWhereUniqueWithoutApplicationsInput>>;
  updateMany?: Maybe<Array<UserApplicationRolUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<UserApplicationRolScalarWhereInput>>;
  upsert?: Maybe<Array<UserApplicationRolUpsertWithWhereUniqueWithoutApplicationsInput>>;
};

export type UserApplicationRolUpdateManyWithoutRolsInput = {
  create?: Maybe<Array<UserApplicationRolCreateWithoutRolsInput>>;
  connect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  set?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  delete?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  update?: Maybe<Array<UserApplicationRolUpdateWithWhereUniqueWithoutRolsInput>>;
  updateMany?: Maybe<Array<UserApplicationRolUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<UserApplicationRolScalarWhereInput>>;
  upsert?: Maybe<Array<UserApplicationRolUpsertWithWhereUniqueWithoutRolsInput>>;
};

export type UserApplicationRolUpdateManyWithoutUsersInput = {
  create?: Maybe<Array<UserApplicationRolCreateWithoutUsersInput>>;
  connect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  set?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  delete?: Maybe<Array<UserApplicationRolWhereUniqueInput>>;
  update?: Maybe<Array<UserApplicationRolUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: Maybe<Array<UserApplicationRolUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<UserApplicationRolScalarWhereInput>>;
  upsert?: Maybe<Array<UserApplicationRolUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type UserApplicationRolUpdateWithWhereUniqueWithoutApplicationsInput = {
  where: UserApplicationRolWhereUniqueInput;
  data: UserApplicationRolUpdateWithoutApplicationsDataInput;
};

export type UserApplicationRolUpdateWithWhereUniqueWithoutRolsInput = {
  where: UserApplicationRolWhereUniqueInput;
  data: UserApplicationRolUpdateWithoutRolsDataInput;
};

export type UserApplicationRolUpdateWithWhereUniqueWithoutUsersInput = {
  where: UserApplicationRolWhereUniqueInput;
  data: UserApplicationRolUpdateWithoutUsersDataInput;
};

export type UserApplicationRolUpdateWithoutApplicationsDataInput = {
  id?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateOneRequiredWithoutRoles_AplicationInput>;
  rols?: Maybe<RolUpdateOneRequiredWithoutRoles_AplicationInput>;
};

export type UserApplicationRolUpdateWithoutRolsDataInput = {
  id?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UserUpdateOneRequiredWithoutRoles_AplicationInput>;
  applications?: Maybe<ApplicationUpdateOneRequiredWithoutRoles_AplicationInput>;
};

export type UserApplicationRolUpdateWithoutUsersDataInput = {
  id?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  applications?: Maybe<ApplicationUpdateOneRequiredWithoutRoles_AplicationInput>;
  rols?: Maybe<RolUpdateOneRequiredWithoutRoles_AplicationInput>;
};

export type UserApplicationRolUpsertWithWhereUniqueWithoutApplicationsInput = {
  where: UserApplicationRolWhereUniqueInput;
  update: UserApplicationRolUpdateWithoutApplicationsDataInput;
  create: UserApplicationRolCreateWithoutApplicationsInput;
};

export type UserApplicationRolUpsertWithWhereUniqueWithoutRolsInput = {
  where: UserApplicationRolWhereUniqueInput;
  update: UserApplicationRolUpdateWithoutRolsDataInput;
  create: UserApplicationRolCreateWithoutRolsInput;
};

export type UserApplicationRolUpsertWithWhereUniqueWithoutUsersInput = {
  where: UserApplicationRolWhereUniqueInput;
  update: UserApplicationRolUpdateWithoutUsersDataInput;
  create: UserApplicationRolCreateWithoutUsersInput;
};

export type UserApplicationRolWhereInput = {
  id?: Maybe<StringFilter>;
  user_id?: Maybe<StringFilter>;
  application_id?: Maybe<StringFilter>;
  rol_id?: Maybe<StringFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  AND?: Maybe<Array<UserApplicationRolWhereInput>>;
  OR?: Maybe<Array<UserApplicationRolWhereInput>>;
  NOT?: Maybe<Array<UserApplicationRolWhereInput>>;
  users?: Maybe<UserWhereInput>;
  applications?: Maybe<ApplicationWhereInput>;
  rols?: Maybe<RolWhereInput>;
};

export type UserApplicationRolWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type UserCreateInput = {
  id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  nickname: Scalars['String'];
  password: Scalars['String'];
  names: Scalars['String'];
  lastnames: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  last_login: Scalars['DateTime'];
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company: CompanyCreateOneWithoutUserInput;
  bill?: Maybe<BillCreateManyWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutUsersInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutUserInput>;
};

export type UserCreateManyWithoutCompanyInput = {
  create?: Maybe<Array<UserCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneWithoutBillInput = {
  create?: Maybe<UserCreateWithoutBillInput>;
  connect?: Maybe<UserWhereUniqueInput>;
};

export type UserCreateOneWithoutReportStatusInput = {
  create?: Maybe<UserCreateWithoutReportStatusInput>;
  connect?: Maybe<UserWhereUniqueInput>;
};

export type UserCreateOneWithoutRoles_AplicationInput = {
  create?: Maybe<UserCreateWithoutRoles_AplicationInput>;
  connect?: Maybe<UserWhereUniqueInput>;
};

export type UserCreateWithoutBillInput = {
  id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  nickname: Scalars['String'];
  password: Scalars['String'];
  names: Scalars['String'];
  lastnames: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  last_login: Scalars['DateTime'];
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company: CompanyCreateOneWithoutUserInput;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutUsersInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutUserInput>;
};

export type UserCreateWithoutCompanyInput = {
  id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  nickname: Scalars['String'];
  password: Scalars['String'];
  names: Scalars['String'];
  lastnames: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  last_login: Scalars['DateTime'];
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill?: Maybe<BillCreateManyWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutUsersInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutUserInput>;
};

export type UserCreateWithoutReportStatusInput = {
  id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  nickname: Scalars['String'];
  password: Scalars['String'];
  names: Scalars['String'];
  lastnames: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  last_login: Scalars['DateTime'];
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company: CompanyCreateOneWithoutUserInput;
  bill?: Maybe<BillCreateManyWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolCreateManyWithoutUsersInput>;
};

export type UserCreateWithoutRoles_AplicationInput = {
  id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  nickname: Scalars['String'];
  password: Scalars['String'];
  names: Scalars['String'];
  lastnames: Scalars['String'];
  user_updated: Scalars['String'];
  user_deleted?: Maybe<Scalars['String']>;
  user_created: Scalars['String'];
  last_login: Scalars['DateTime'];
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company: CompanyCreateOneWithoutUserInput;
  bill?: Maybe<BillCreateManyWithoutUserInput>;
  reportStatus?: Maybe<ReportStatusCreateManyWithoutUserInput>;
};

export type UserFilter = {
  every?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
};

export type UserScalarWhereInput = {
  id?: Maybe<StringFilter>;
  email?: Maybe<StringFilter>;
  nickname?: Maybe<StringFilter>;
  password?: Maybe<StringFilter>;
  names?: Maybe<StringFilter>;
  lastnames?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  bill?: Maybe<BillFilter>;
  roles_aplication?: Maybe<UserApplicationRolFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  last_login?: Maybe<DateTimeFilter>;
  status?: Maybe<BooleanFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  reportStatus?: Maybe<ReportStatusFilter>;
  AND?: Maybe<Array<UserScalarWhereInput>>;
  OR?: Maybe<Array<UserScalarWhereInput>>;
  NOT?: Maybe<Array<UserScalarWhereInput>>;
};

export type UserUpdateInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  lastnames?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutUserInput>;
  bill?: Maybe<BillUpdateManyWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutUsersInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutUserInput>;
};

export type UserUpdateManyDataInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  lastnames?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type UserUpdateManyWithWhereNestedInput = {
  where: UserScalarWhereInput;
  data: UserUpdateManyDataInput;
};

export type UserUpdateManyWithoutCompanyInput = {
  create?: Maybe<Array<UserCreateWithoutCompanyInput>>;
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereNestedInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type UserUpdateOneRequiredWithoutBillInput = {
  create?: Maybe<UserCreateWithoutBillInput>;
  connect?: Maybe<UserWhereUniqueInput>;
  update?: Maybe<UserUpdateWithoutBillDataInput>;
  upsert?: Maybe<UserUpsertWithoutBillInput>;
};

export type UserUpdateOneRequiredWithoutRoles_AplicationInput = {
  create?: Maybe<UserCreateWithoutRoles_AplicationInput>;
  connect?: Maybe<UserWhereUniqueInput>;
  update?: Maybe<UserUpdateWithoutRoles_AplicationDataInput>;
  upsert?: Maybe<UserUpsertWithoutRoles_AplicationInput>;
};

export type UserUpdateOneWithoutReportStatusInput = {
  create?: Maybe<UserCreateWithoutReportStatusInput>;
  connect?: Maybe<UserWhereUniqueInput>;
  disconnect?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateWithoutReportStatusDataInput>;
  upsert?: Maybe<UserUpsertWithoutReportStatusInput>;
};

export type UserUpdateWithWhereUniqueWithoutCompanyInput = {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutCompanyDataInput;
};

export type UserUpdateWithoutBillDataInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  lastnames?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutUsersInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutUserInput>;
};

export type UserUpdateWithoutCompanyDataInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  lastnames?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  bill?: Maybe<BillUpdateManyWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutUsersInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutUserInput>;
};

export type UserUpdateWithoutReportStatusDataInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  lastnames?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutUserInput>;
  bill?: Maybe<BillUpdateManyWithoutUserInput>;
  roles_aplication?: Maybe<UserApplicationRolUpdateManyWithoutUsersInput>;
};

export type UserUpdateWithoutRoles_AplicationDataInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  lastnames?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_deleted?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutUserInput>;
  bill?: Maybe<BillUpdateManyWithoutUserInput>;
  reportStatus?: Maybe<ReportStatusUpdateManyWithoutUserInput>;
};

export type UserUpsertWithWhereUniqueWithoutCompanyInput = {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutCompanyDataInput;
  create: UserCreateWithoutCompanyInput;
};

export type UserUpsertWithoutBillInput = {
  update: UserUpdateWithoutBillDataInput;
  create: UserCreateWithoutBillInput;
};

export type UserUpsertWithoutReportStatusInput = {
  update: UserUpdateWithoutReportStatusDataInput;
  create: UserCreateWithoutReportStatusInput;
};

export type UserUpsertWithoutRoles_AplicationInput = {
  update: UserUpdateWithoutRoles_AplicationDataInput;
  create: UserCreateWithoutRoles_AplicationInput;
};

export type UserWhereInput = {
  id?: Maybe<StringFilter>;
  email?: Maybe<StringFilter>;
  nickname?: Maybe<StringFilter>;
  password?: Maybe<StringFilter>;
  names?: Maybe<StringFilter>;
  lastnames?: Maybe<StringFilter>;
  company_id?: Maybe<StringFilter>;
  bill?: Maybe<BillFilter>;
  roles_aplication?: Maybe<UserApplicationRolFilter>;
  user_updated?: Maybe<StringFilter>;
  user_deleted?: Maybe<NullableStringFilter>;
  user_created?: Maybe<StringFilter>;
  last_login?: Maybe<DateTimeFilter>;
  status?: Maybe<BooleanFilter>;
  created_at?: Maybe<DateTimeFilter>;
  updated_at?: Maybe<NullableDateTimeFilter>;
  deleted_at?: Maybe<NullableDateTimeFilter>;
  reportStatus?: Maybe<ReportStatusFilter>;
  AND?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  NOT?: Maybe<Array<UserWhereInput>>;
  company?: Maybe<CompanyWhereInput>;
};

export type UserWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
};

export type BillsdatatableQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  DateBegind?: Maybe<Scalars['DateTime']>;
  DateEnd?: Maybe<Scalars['DateTime']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  state?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  regionals?: Maybe<Scalars['String']>;
  order?: Maybe<BillOrderByInput>;
  company_id?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
  payMethod?: Maybe<Scalars['String']>;
}>;


export type BillsdatatableQuery = (
  { __typename?: 'Query' }
  & { bills: Array<(
    { __typename?: 'bill' }
    & Pick<Bill, 'id' | 'vertebra_pay' | 'payment_aut' | 'payment_reference' | 'account_id' | 'marketer_name' | 'amounts_not_justificate' | 'average' | 'begin_date' | 'cash_source_name' | 'cleaning_contribution' | 'cleaning_price' | 'cleaning_total' | 'date_bill' | 'date_bill_uploaded' | 'date_paid' | 'date_voucher_uploaded' | 'company_id' | 'company_name' | 'account_name' | 'end_date' | 'energy_consumption_active' | 'energy_consumption_reactive' | 'energy_current_measure_active' | 'energy_current_measure_reactive' | 'energy_factor_active' | 'energy_factor_reactive' | 'energy_hours_interruption' | 'energy_last_measure_active' | 'energy_last_measure_reactive' | 'energy_price_active' | 'energy_price_reactive' | 'energy_price_contribution_active' | 'energy_price_contribution_reactive' | 'energy_rate_active' | 'energy_rate_reactive' | 'energy_total' | 'general_bill_amount' | 'general_bill_description' | 'image_bill' | 'image_voucher' | 'issue_date' | 'marketer_id' | 'number_bill' | 'observation' | 'payment_date' | 'payment_method_marketer_id' | 'payment_method_marketer_name' | 'place_id' | 'place_name' | 'public_lighting' | 'regional_id' | 'regional_name' | 'service_id' | 'service_name' | 'sewerage_total' | 'status_bill' | 'suspension_date' | 'timely_payment_date' | 'total' | 'total_others' | 'type_of_bill' | 'updated_at' | 'user_created' | 'user_name' | 'user_transcriber' | 'user_updated' | 'user_uploaded_bill' | 'user_uploaded_voucher' | 'voucher_number' | 'water_consumption' | 'water_contribution_aqueduct' | 'water_contribution_price_fixed_aqueduct' | 'water_contribution_price_fixed_sewerage' | 'water_contribution_sewerage' | 'water_current_measure' | 'water_last_measure' | 'water_price_fixed_sewerage' | 'water_price_aqueduct' | 'water_price_fixed_aqueduct' | 'water_price_fixed_basic_aqueduct' | 'water_price_fixed_basic_sewerage' | 'water_price_fixed_compl_aqueduct' | 'water_price_fixed_compl_sewerage' | 'water_price_fixed_sumpt_aqueduct' | 'water_price_fixed_sumpt_sewerage' | 'water_price_sewerage' | 'water_rate_basic_aqueduct' | 'water_rate_basic_sewerage' | 'water_rate_compl_aqueduct' | 'water_rate_compl_sewerage' | 'water_rate_sumpt_aqueduct' | 'water_rate_sumpt_sewerage' | 'water_total' | 'real_payment'>
  )> }
);

export type SelectstatequeryQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectstatequeryQuery = (
  { __typename?: 'Query' }
  & { billStates: Array<(
    { __typename?: 'BillState' }
    & Pick<BillState, 'id' | 'name' | 'is_visible'>
  )> }
);

export type UpdateonebillMutationVariables = Exact<{
  data: BillUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateonebillMutation = (
  { __typename?: 'Mutation' }
  & { updateOnebill?: Maybe<(
    { __typename?: 'bill' }
    & Pick<Bill, 'id'>
  )> }
);

export type UsersqueryQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type UsersqueryQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'user' }
    & Pick<User, 'id' | 'names' | 'lastnames' | 'nickname' | 'email' | 'last_login'>
    & { roles_aplication: Array<(
      { __typename?: 'userApplicationRol' }
      & Pick<UserApplicationRol, 'id'>
      & { rols: (
        { __typename?: 'rol' }
        & Pick<Rol, 'id' | 'name'>
      ), applications: (
        { __typename?: 'application' }
        & Pick<Application, 'id' | 'name'>
      ) }
    )> }
  )> }
);

export type RolsappQueryVariables = Exact<{ [key: string]: never; }>;


export type RolsappQuery = (
  { __typename?: 'Query' }
  & { rols: Array<(
    { __typename?: 'rol' }
    & Pick<Rol, 'id' | 'name'>
  )> }
);

export type DeleteoneuserMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
}>;


export type DeleteoneuserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneuser?: Maybe<(
    { __typename?: 'user' }
    & Pick<User, 'id'>
  )> }
);

export type CreateoneuserMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type CreateoneuserMutation = (
  { __typename?: 'Mutation' }
  & { createOneuser: (
    { __typename?: 'user' }
    & Pick<User, 'id'>
  ) }
);

export type UpdateuserMutationVariables = Exact<{
  data: UserUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateuserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneuser?: Maybe<(
    { __typename?: 'user' }
    & Pick<User, 'id'>
  )> }
);

export type RegionalbyuserdataQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type RegionalbyuserdataQuery = (
  { __typename?: 'Query' }
  & { regionalUsers: Array<(
    { __typename?: 'RegionalUser' }
    & Pick<RegionalUser, 'id' | 'user_id' | 'user_name' | 'regional_id' | 'regional_name' | 'user_type'>
  )> }
);

export type CreateregionaluserMutationVariables = Exact<{
  data: RegionalUserCreateInput;
}>;


export type CreateregionaluserMutation = (
  { __typename?: 'Mutation' }
  & { createOneRegionalUser: (
    { __typename?: 'RegionalUser' }
    & Pick<RegionalUser, 'id' | 'regional_name'>
  ) }
);

export type DeleteregionaluserMutationVariables = Exact<{
  date: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
}>;


export type DeleteregionaluserMutation = (
  { __typename?: 'Mutation' }
  & { updateOneRegionalUser?: Maybe<(
    { __typename?: 'RegionalUser' }
    & Pick<RegionalUser, 'id'>
  )> }
);

export type AcounpointsQueryVariables = Exact<{
  company?: Maybe<Scalars['String']>;
}>;


export type AcounpointsQuery = (
  { __typename?: 'Query' }
  & { places: Array<(
    { __typename?: 'place' }
    & Pick<Place, 'id' | 'name'>
  )> }
);

export type AcountsQueryVariables = Exact<{
  company_id?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  regionals?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type AcountsQuery = (
  { __typename?: 'Query' }
  & { accounts: Array<(
    { __typename?: 'account' }
    & Pick<Account, 'id' | 'company_id' | 'company_name' | 'created_at' | 'deleted_at' | 'is_active' | 'marketer_id' | 'marketer_name' | 'number' | 'numeral_v' | 'place_id' | 'place_name' | 'property_level_id' | 'regional_id' | 'regional_name' | 'sdl_id' | 'sdl_name' | 'service_id' | 'service_name' | 'updated_at' | 'user_created' | 'user_deleted' | 'user_updated' | 'frequency' | 'estimate_issue_date' | 'estimate_timely_payment_date'>
  )> }
);

export type UpdateoneacountMutationVariables = Exact<{
  data: AccountUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateoneacountMutation = (
  { __typename?: 'Mutation' }
  & { updateOneaccount?: Maybe<(
    { __typename?: 'account' }
    & Pick<Account, 'id'>
  )> }
);

export type DeleteacountMutationVariables = Exact<{
  date: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
}>;


export type DeleteacountMutation = (
  { __typename?: 'Mutation' }
  & { updateOneaccount?: Maybe<(
    { __typename?: 'account' }
    & Pick<Account, 'id'>
  )> }
);

export type CreateacountMutationVariables = Exact<{
  data: AccountCreateInput;
}>;


export type CreateacountMutation = (
  { __typename?: 'Mutation' }
  & { createOneaccount: (
    { __typename?: 'account' }
    & Pick<Account, 'id'>
  ) }
);

export type CounstfilltersQueryVariables = Exact<{ [key: string]: never; }>;


export type CounstfilltersQuery = (
  { __typename?: 'Query' }
  & { accounts: Array<(
    { __typename?: 'account' }
    & Pick<Account, 'budget' | 'vertebra_pay' | 'payment_aut'>
  )> }
);

export type LoginMutationVariables = Exact<{
  signIn: SignIn;
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { signIn: (
    { __typename?: 'AuthPayload' }
    & Pick<AuthPayload, 'token'>
  ) }
);

export type BanksdataQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type BanksdataQuery = (
  { __typename?: 'Query' }
  & { banks: Array<(
    { __typename?: 'bank' }
    & Pick<Bank, 'id' | 'nit' | 'name'>
  )> }
);

export type CreateonebankMutationVariables = Exact<{
  data: BankCreateInput;
}>;


export type CreateonebankMutation = (
  { __typename?: 'Mutation' }
  & { createOnebank: (
    { __typename?: 'bank' }
    & Pick<Bank, 'id'>
  ) }
);

export type UpdateonebankMutationVariables = Exact<{
  data: BankUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateonebankMutation = (
  { __typename?: 'Mutation' }
  & { updateOnebank?: Maybe<(
    { __typename?: 'bank' }
    & Pick<Bank, 'id'>
  )> }
);

export type DeleteonebankMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
}>;


export type DeleteonebankMutation = (
  { __typename?: 'Mutation' }
  & { updateOnebank?: Maybe<(
    { __typename?: 'bank' }
    & Pick<Bank, 'id'>
  )> }
);

export type UploaddataQueryVariables = Exact<{
  regional?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  order?: Maybe<SelectBillsOrder>;
  marketers?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UploaddataQuery = (
  { __typename?: 'Query' }
  & { selectBills: Array<(
    { __typename?: 'getBills' }
    & Pick<GetBills, 'company_id' | 'company_name' | 'regional_id' | 'regional_name' | 'place_id' | 'place_name' | 'number' | 'id' | 'numeral_v' | 'marketer_id' | 'marketer_name' | 'getbillsbyaccount' | 'sdl_name' | 'sdl_id' | 'service_name' | 'service_id' | 'property_level_id' | 'budget' | 'vertebra_pay' | 'payment_aut' | 'account_parent'>
  )> }
);

export type CompaniestableQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type CompaniestableQuery = (
  { __typename?: 'Query' }
  & { companies: Array<(
    { __typename?: 'company' }
    & Pick<Company, 'id' | 'nit' | 'name' | 'type' | 'manager' | 'imagen' | 'status'>
  )> }
);

export type UpdateBillsMutationVariables = Exact<{
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  regional_id?: Maybe<Scalars['String']>;
  regional_name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  place_name?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['String']>;
  service_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  type_of_bill?: Maybe<TypeOfBill>;
  date_bill?: Maybe<Scalars['String']>;
  image_bill?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  marketer_id?: Maybe<Scalars['String']>;
  marketer_name?: Maybe<Scalars['String']>;
  payment_aut?: Maybe<Scalars['Boolean']>;
  vertebra_pay?: Maybe<Scalars['Boolean']>;
  account_parent?: Maybe<Scalars['String']>;
}>;


export type UpdateBillsMutation = (
  { __typename?: 'Mutation' }
  & { createOneBill: (
    { __typename?: 'bill' }
    & Pick<Bill, 'id' | 'account_id'>
  ) }
);

export type DeteleonebillnewMutationVariables = Exact<{
  date: Scalars['DateTime'];
  id: Scalars['String'];
}>;


export type DeteleonebillnewMutation = (
  { __typename?: 'Mutation' }
  & { updateOnebill?: Maybe<(
    { __typename?: 'bill' }
    & Pick<Bill, 'id' | 'deleted_at'>
  )> }
);

export type DomainsQueryVariables = Exact<{
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
}>;


export type DomainsQuery = (
  { __typename?: 'Query' }
  & { domains: Array<(
    { __typename?: 'domain' }
    & Pick<Domain, 'id' | 'name' | 'type'>
  )> }
);

export type DomainsdataQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type DomainsdataQuery = (
  { __typename?: 'Query' }
  & { domains: Array<(
    { __typename?: 'domain' }
    & Pick<Domain, 'id' | 'name' | 'type'>
  )> }
);

export type CreateonedomainMutationVariables = Exact<{
  data: DomainCreateInput;
}>;


export type CreateonedomainMutation = (
  { __typename?: 'Mutation' }
  & { createOnedomain: (
    { __typename?: 'domain' }
    & Pick<Domain, 'id'>
  ) }
);

export type UpdateonedomainMutationVariables = Exact<{
  data: DomainUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateonedomainMutation = (
  { __typename?: 'Mutation' }
  & { updateOnedomain?: Maybe<(
    { __typename?: 'domain' }
    & Pick<Domain, 'id'>
  )> }
);

export type DeleteonedomainMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
}>;


export type DeleteonedomainMutation = (
  { __typename?: 'Mutation' }
  & { updateOnedomain?: Maybe<(
    { __typename?: 'domain' }
    & Pick<Domain, 'id'>
  )> }
);

export type ReportgeneralcargaQueryVariables = Exact<{
  year: Scalars['Int'];
  search?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  last: Scalars['Int'];
}>;


export type ReportgeneralcargaQuery = (
  { __typename?: 'Query' }
  & { RepGeneralCarga: Array<(
    { __typename?: 'repGeneralCarga' }
    & Pick<RepGeneralCarga, 'id' | 'name' | 'reportgeneralcarga'>
  )> }
);

export type GenerealreportstatusQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type GenerealreportstatusQuery = (
  { __typename?: 'Query' }
  & { perBillPaidTotal: Array<(
    { __typename?: 'PerBillsTotal' }
    & Pick<PerBillsTotal, 'company_id' | 'total_facturas' | 'total_reportadas'>
  )> }
);

export type CompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesQuery = (
  { __typename?: 'Query' }
  & { companies: Array<(
    { __typename?: 'company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type GetmoviiMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetmoviiMutation = (
  { __typename?: 'Mutation' }
  & { getMoviiBill: (
    { __typename?: 'moviiResponse' }
    & { data: Array<(
      { __typename?: 'moviiBill' }
      & Pick<MoviiBill, 'billerName' | 'referenceNumber' | 'amount'>
    )> }
  ) }
);

export type MarketerdataQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type MarketerdataQuery = (
  { __typename?: 'Query' }
  & { marketers: Array<(
    { __typename?: 'marketer' }
    & Pick<Marketer, 'id' | 'name' | 'short_name' | 'type' | 'nit' | 'email' | 'phone' | 'code_movii' | 'service_id' | 'send_prove'>
    & { service: (
      { __typename?: 'service' }
      & Pick<Service, 'name'>
    ), PaymentMethodMarketer: Array<(
      { __typename?: 'PaymentMethodMarketer' }
      & Pick<PaymentMethodMarketer, 'bank_name' | 'priority' | 'reference_number' | 'type'>
      & { payment_method: (
        { __typename?: 'PaymentMethod' }
        & Pick<PaymentMethod, 'id' | 'name'>
      ) }
    )>, accounts: Array<(
      { __typename?: 'account' }
      & Pick<Account, 'place_name'>
      & { property_level?: Maybe<(
        { __typename?: 'PropertyLevel' }
        & Pick<PropertyLevel, 'name'>
      )> }
    )>, bill: Array<(
      { __typename?: 'bill' }
      & Pick<Bill, 'number_bill'>
    )> }
  )> }
);

export type CreateonemarketerMutationVariables = Exact<{
  data: MarketerCreateInput;
}>;


export type CreateonemarketerMutation = (
  { __typename?: 'Mutation' }
  & { createOnemarketer: (
    { __typename?: 'marketer' }
    & Pick<Marketer, 'id'>
  ) }
);

export type EditonemarketerMutationVariables = Exact<{
  data: MarketerUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type EditonemarketerMutation = (
  { __typename?: 'Mutation' }
  & { updateOnemarketer?: Maybe<(
    { __typename?: 'marketer' }
    & Pick<Marketer, 'id'>
  )> }
);

export type DeleteonemarketerMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
}>;


export type DeleteonemarketerMutation = (
  { __typename?: 'Mutation' }
  & { updateOnemarketer?: Maybe<(
    { __typename?: 'marketer' }
    & Pick<Marketer, 'id'>
  )> }
);

export type MarketersfilterQueryVariables = Exact<{
  filter?: Maybe<Scalars['String']>;
}>;


export type MarketersfilterQuery = (
  { __typename?: 'Query' }
  & { marketers: Array<(
    { __typename?: 'marketer' }
    & Pick<Marketer, 'id' | 'short_name'>
  )> }
);

export type ReportmetersMutationVariables = Exact<{
  fecha_inicio: Scalars['String'];
  fecha_fin: Scalars['String'];
  frecuencia: Scalars['String'];
  meters: Array<Scalars['Int']> | Scalars['Int'];
  separador: Scalars['String'];
}>;


export type ReportmetersMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'Reportdatameters'>
);

export type PaymethodQueryVariables = Exact<{
  marketer_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}>;


export type PaymethodQuery = (
  { __typename?: 'Query' }
  & { paymentMethodMarketers: Array<(
    { __typename?: 'PaymentMethodMarketer' }
    & Pick<PaymentMethodMarketer, 'id' | 'priority' | 'bank_name' | 'payment_method_name' | 'reference_number'>
  )> }
);

export type CashsourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type CashsourcesQuery = (
  { __typename?: 'Query' }
  & { cashSources: Array<(
    { __typename?: 'CashSource' }
    & Pick<CashSource, 'id' | 'name'>
  )> }
);

export type PaysreportMutationVariables = Exact<{
  fecha_inicio?: Maybe<Scalars['String']>;
  fecha_fin?: Maybe<Scalars['String']>;
  proyecto?: Maybe<Scalars['String']>;
  regional?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  separador: Scalars['String'];
}>;


export type PaysreportMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'ReportPagos'>
);

export type PointsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['String']>;
  regionals?: Maybe<Scalars['String']>;
}>;


export type PointsQuery = (
  { __typename?: 'Query' }
  & { places: Array<(
    { __typename?: 'place' }
    & Pick<Place, 'id' | 'name' | 'name_two' | 'address' | 'city' | 'deparment' | 'phone' | 'ceco' | 'employers' | 'office_code' | 'is_active' | 'regional_id' | 'type_place' | 'area' | 'working_time'>
    & { regional: (
      { __typename?: 'regional' }
      & Pick<Regional, 'name'>
    ), company: (
      { __typename?: 'company' }
      & Pick<Company, 'name'>
    ) }
  )> }
);

export type UpdateplaceMutationVariables = Exact<{
  data: PlaceUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdateplaceMutation = (
  { __typename?: 'Mutation' }
  & { updateOneplace?: Maybe<(
    { __typename?: 'place' }
    & Pick<Place, 'id'>
  )> }
);

export type CreateplaceMutationVariables = Exact<{
  data: PlaceCreateInput;
}>;


export type CreateplaceMutation = (
  { __typename?: 'Mutation' }
  & { createOneplace: (
    { __typename?: 'place' }
    & Pick<Place, 'id'>
  ) }
);

export type DeleteoneplaceMutationVariables = Exact<{
  date: Scalars['DateTime'];
  id: Scalars['String'];
}>;


export type DeleteoneplaceMutation = (
  { __typename?: 'Mutation' }
  & { updateOneplace?: Maybe<(
    { __typename?: 'place' }
    & Pick<Place, 'id'>
  )> }
);

export type PercentagebillsQueryVariables = Exact<{
  regional?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  DateBegind?: Maybe<Scalars['String']>;
  DateEnd?: Maybe<Scalars['String']>;
}>;


export type PercentagebillsQuery = (
  { __typename?: 'Query' }
  & { perBillPaid: Array<(
    { __typename?: 'PerBills' }
    & Pick<PerBills, 'percentage'>
  )> }
);

export type RegionalsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  proyecto?: Maybe<Scalars['String']>;
}>;


export type RegionalsQuery = (
  { __typename?: 'Query' }
  & { regionals: Array<(
    { __typename?: 'regional' }
    & Pick<Regional, 'id' | 'name'>
  )> }
);

export type GroupsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['String']>;
}>;


export type GroupsQuery = (
  { __typename?: 'Query' }
  & { regionals: Array<(
    { __typename?: 'regional' }
    & Pick<Regional, 'id' | 'name' | 'is_active' | 'company_id'>
  )> }
);

export type UpdategroupregionalMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
}>;


export type UpdategroupregionalMutation = (
  { __typename?: 'Mutation' }
  & { updateOneregional?: Maybe<(
    { __typename?: 'regional' }
    & Pick<Regional, 'id'>
  )> }
);

export type DeleteregionalMutationVariables = Exact<{
  date: Scalars['DateTime'];
  id: Scalars['String'];
}>;


export type DeleteregionalMutation = (
  { __typename?: 'Mutation' }
  & { updateOneregional?: Maybe<(
    { __typename?: 'regional' }
    & Pick<Regional, 'id'>
  )> }
);

export type CreateoneregionalgroupMutationVariables = Exact<{
  data: RegionalCreateInput;
}>;


export type CreateoneregionalgroupMutation = (
  { __typename?: 'Mutation' }
  & { createOneregional: (
    { __typename?: 'regional' }
    & Pick<Regional, 'id'>
  ) }
);

export type RegionalsbyuserQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionalsbyuserQuery = (
  { __typename?: 'Query' }
  & { RegionalsByUser: Array<(
    { __typename?: 'RegionalUser' }
    & Pick<RegionalUser, 'regional_id' | 'regional_name'>
  )> }
);

export type ReportstatustableQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filter_user?: Maybe<Scalars['String']>;
}>;


export type ReportstatustableQuery = (
  { __typename?: 'Query' }
  & { reportStatuses: Array<(
    { __typename?: 'reportStatus' }
    & Pick<ReportStatus, 'id' | 'name' | 'user_name' | 'status' | 'data' | 'created_at' | 'updated_at'>
  )> }
);

export type SelectmetersQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectmetersQuery = (
  { __typename?: 'Query' }
  & { meters: Array<(
    { __typename?: 'meter' }
    & Pick<Meter, 'id' | 'place_name'>
  )> }
);

export type ServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesQuery = (
  { __typename?: 'Query' }
  & { services: Array<(
    { __typename?: 'service' }
    & Pick<Service, 'id' | 'name'>
  )> }
);

export type MarketersQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketersQuery = (
  { __typename?: 'Query' }
  & { marketers: Array<(
    { __typename?: 'marketer' }
    & Pick<Marketer, 'id' | 'name'>
  )> }
);

export type UpdatebillMutationVariables = Exact<{
  data: BillUpdateInput;
  id?: Maybe<Scalars['String']>;
}>;


export type UpdatebillMutation = (
  { __typename?: 'Mutation' }
  & { updateOnebill?: Maybe<(
    { __typename?: 'bill' }
    & Pick<Bill, 'id'>
  )> }
);

export type UsersQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'user' }
    & Pick<User, 'id' | 'names' | 'nickname'>
  )> }
);

export type TransquibersQueryVariables = Exact<{ [key: string]: never; }>;


export type TransquibersQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'user' }
    & Pick<User, 'id' | 'nickname'>
  )> }
);


export const BillsdatatableDocument = gql`
    query BILLSDATATABLE($search: String, $DateBegind: DateTime, $DateEnd: DateTime, $first: Int, $last: Int, $state: [String!], $regionals: String, $order: billOrderByInput, $company_id: String, $filter: String, $payMethod: String) {
  bills(
    where: {company_id: {equals: $company_id}, OR: [{place_name: {contains: $search}}, {account_name: {contains: $search}}, {number_bill: {contains: $search}}, {marketer_name: {contains: $search}}, {voucher_number: {contains: $search}}, {payment_method_marketer_name: {contains: $search}}, {status_bill: {contains: $search}}], AND: [{regional_id: {equals: $regionals}}, {status_bill: {in: $state}}, {marketer_id: {contains: $filter}}, {date_bill: {gte: $DateBegind}}, {date_bill: {lte: $DateEnd}}, {payment_method_marketer_name: {contains: $payMethod}}]}
    orderBy: $order
    first: $first
    last: $last
  ) {
    id
    vertebra_pay
    payment_aut
    payment_reference
    account_id
    marketer_name
    amounts_not_justificate
    average
    begin_date
    cash_source_name
    cleaning_contribution
    cleaning_price
    cleaning_total
    date_bill
    date_bill_uploaded
    date_paid
    date_voucher_uploaded
    company_id
    company_name
    account_id
    account_name
    end_date
    energy_consumption_active
    energy_consumption_reactive
    energy_current_measure_active
    energy_current_measure_reactive
    energy_factor_active
    energy_factor_reactive
    energy_hours_interruption
    energy_last_measure_active
    energy_last_measure_reactive
    energy_price_active
    energy_price_reactive
    energy_price_contribution_active
    energy_price_contribution_reactive
    energy_rate_active
    energy_rate_reactive
    energy_total
    general_bill_amount
    general_bill_description
    image_bill
    image_voucher
    issue_date
    marketer_id
    marketer_name
    number_bill
    observation
    payment_date
    payment_method_marketer_id
    payment_method_marketer_name
    place_id
    place_name
    public_lighting
    regional_id
    regional_name
    service_id
    service_name
    sewerage_total
    status_bill
    suspension_date
    timely_payment_date
    total
    total_others
    type_of_bill
    updated_at
    user_created
    user_name
    user_transcriber
    user_updated
    user_uploaded_bill
    user_uploaded_voucher
    voucher_number
    water_consumption
    water_contribution_aqueduct
    water_contribution_price_fixed_aqueduct
    water_contribution_price_fixed_sewerage
    water_contribution_sewerage
    water_current_measure
    water_last_measure
    water_price_fixed_sewerage
    water_price_aqueduct
    water_price_fixed_aqueduct
    water_price_fixed_basic_aqueduct
    water_price_fixed_basic_sewerage
    water_price_fixed_compl_aqueduct
    water_price_fixed_compl_sewerage
    water_price_fixed_sumpt_aqueduct
    water_price_fixed_sumpt_sewerage
    water_price_sewerage
    water_rate_basic_aqueduct
    water_rate_basic_sewerage
    water_rate_compl_aqueduct
    water_rate_compl_sewerage
    water_rate_sumpt_aqueduct
    water_rate_sumpt_sewerage
    water_total
    real_payment
  }
}
    `;

/**
 * __useBillsdatatableQuery__
 *
 * To run a query within a React component, call `useBillsdatatableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsdatatableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsdatatableQuery({
 *   variables: {
 *      search: // value for 'search'
 *      DateBegind: // value for 'DateBegind'
 *      DateEnd: // value for 'DateEnd'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      state: // value for 'state'
 *      regionals: // value for 'regionals'
 *      order: // value for 'order'
 *      company_id: // value for 'company_id'
 *      filter: // value for 'filter'
 *      payMethod: // value for 'payMethod'
 *   },
 * });
 */
export function useBillsdatatableQuery(baseOptions?: Apollo.QueryHookOptions<BillsdatatableQuery, BillsdatatableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillsdatatableQuery, BillsdatatableQueryVariables>(BillsdatatableDocument, options);
      }
export function useBillsdatatableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillsdatatableQuery, BillsdatatableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillsdatatableQuery, BillsdatatableQueryVariables>(BillsdatatableDocument, options);
        }
export type BillsdatatableQueryHookResult = ReturnType<typeof useBillsdatatableQuery>;
export type BillsdatatableLazyQueryHookResult = ReturnType<typeof useBillsdatatableLazyQuery>;
export type BillsdatatableQueryResult = Apollo.QueryResult<BillsdatatableQuery, BillsdatatableQueryVariables>;
export const SelectstatequeryDocument = gql`
    query SELECTSTATEQUERY {
  billStates(where: {is_visible: {equals: true}}, orderBy: {order: asc}) {
    id
    name
    is_visible
  }
}
    `;

/**
 * __useSelectstatequeryQuery__
 *
 * To run a query within a React component, call `useSelectstatequeryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectstatequeryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectstatequeryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectstatequeryQuery(baseOptions?: Apollo.QueryHookOptions<SelectstatequeryQuery, SelectstatequeryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectstatequeryQuery, SelectstatequeryQueryVariables>(SelectstatequeryDocument, options);
      }
export function useSelectstatequeryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectstatequeryQuery, SelectstatequeryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectstatequeryQuery, SelectstatequeryQueryVariables>(SelectstatequeryDocument, options);
        }
export type SelectstatequeryQueryHookResult = ReturnType<typeof useSelectstatequeryQuery>;
export type SelectstatequeryLazyQueryHookResult = ReturnType<typeof useSelectstatequeryLazyQuery>;
export type SelectstatequeryQueryResult = Apollo.QueryResult<SelectstatequeryQuery, SelectstatequeryQueryVariables>;
export const UpdateonebillDocument = gql`
    mutation UPDATEONEBILL($data: billUpdateInput!, $id: String) {
  updateOnebill(where: {id: $id}, data: $data) {
    id
  }
}
    `;
export type UpdateonebillMutationFn = Apollo.MutationFunction<UpdateonebillMutation, UpdateonebillMutationVariables>;

/**
 * __useUpdateonebillMutation__
 *
 * To run a mutation, you first call `useUpdateonebillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateonebillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateonebillMutation, { data, loading, error }] = useUpdateonebillMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateonebillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateonebillMutation, UpdateonebillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateonebillMutation, UpdateonebillMutationVariables>(UpdateonebillDocument, options);
      }
export type UpdateonebillMutationHookResult = ReturnType<typeof useUpdateonebillMutation>;
export type UpdateonebillMutationResult = Apollo.MutationResult<UpdateonebillMutation>;
export type UpdateonebillMutationOptions = Apollo.BaseMutationOptions<UpdateonebillMutation, UpdateonebillMutationVariables>;
export const UsersqueryDocument = gql`
    query USERSQUERY($search: String, $filter: String, $last: Int, $first: Int) {
  users(
    where: {OR: [{names: {contains: $search}}, {lastnames: {contains: $search}}, {nickname: {contains: $search}}, {email: {contains: $search}}], AND: [{roles_aplication: {some: {application_id: {equals: "2"}}}}, {roles_aplication: {some: {rols: {name: {contains: $filter}}}}}]}
    first: $first
    last: $last
  ) {
    id
    names
    lastnames
    nickname
    email
    last_login
    roles_aplication {
      id
      rols {
        id
        name
      }
      applications {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUsersqueryQuery__
 *
 * To run a query within a React component, call `useUsersqueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersqueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersqueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUsersqueryQuery(baseOptions?: Apollo.QueryHookOptions<UsersqueryQuery, UsersqueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersqueryQuery, UsersqueryQueryVariables>(UsersqueryDocument, options);
      }
export function useUsersqueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersqueryQuery, UsersqueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersqueryQuery, UsersqueryQueryVariables>(UsersqueryDocument, options);
        }
export type UsersqueryQueryHookResult = ReturnType<typeof useUsersqueryQuery>;
export type UsersqueryLazyQueryHookResult = ReturnType<typeof useUsersqueryLazyQuery>;
export type UsersqueryQueryResult = Apollo.QueryResult<UsersqueryQuery, UsersqueryQueryVariables>;
export const RolsappDocument = gql`
    query ROLSAPP {
  rols(
    where: {AND: [{roles_aplication: {every: {application_id: {equals: "2"}}}}]}
  ) {
    id
    name
  }
}
    `;

/**
 * __useRolsappQuery__
 *
 * To run a query within a React component, call `useRolsappQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolsappQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolsappQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolsappQuery(baseOptions?: Apollo.QueryHookOptions<RolsappQuery, RolsappQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolsappQuery, RolsappQueryVariables>(RolsappDocument, options);
      }
export function useRolsappLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolsappQuery, RolsappQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolsappQuery, RolsappQueryVariables>(RolsappDocument, options);
        }
export type RolsappQueryHookResult = ReturnType<typeof useRolsappQuery>;
export type RolsappLazyQueryHookResult = ReturnType<typeof useRolsappLazyQuery>;
export type RolsappQueryResult = Apollo.QueryResult<RolsappQuery, RolsappQueryVariables>;
export const DeleteoneuserDocument = gql`
    mutation DELETEONEUSER($id: String, $deleted_at: DateTime) {
  updateOneuser(where: {id: $id}, data: {deleted_at: $deleted_at}) {
    id
  }
}
    `;
export type DeleteoneuserMutationFn = Apollo.MutationFunction<DeleteoneuserMutation, DeleteoneuserMutationVariables>;

/**
 * __useDeleteoneuserMutation__
 *
 * To run a mutation, you first call `useDeleteoneuserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteoneuserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteoneuserMutation, { data, loading, error }] = useDeleteoneuserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleted_at: // value for 'deleted_at'
 *   },
 * });
 */
export function useDeleteoneuserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteoneuserMutation, DeleteoneuserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteoneuserMutation, DeleteoneuserMutationVariables>(DeleteoneuserDocument, options);
      }
export type DeleteoneuserMutationHookResult = ReturnType<typeof useDeleteoneuserMutation>;
export type DeleteoneuserMutationResult = Apollo.MutationResult<DeleteoneuserMutation>;
export type DeleteoneuserMutationOptions = Apollo.BaseMutationOptions<DeleteoneuserMutation, DeleteoneuserMutationVariables>;
export const CreateoneuserDocument = gql`
    mutation CREATEONEUSER($data: userCreateInput!) {
  createOneuser(data: $data) {
    id
  }
}
    `;
export type CreateoneuserMutationFn = Apollo.MutationFunction<CreateoneuserMutation, CreateoneuserMutationVariables>;

/**
 * __useCreateoneuserMutation__
 *
 * To run a mutation, you first call `useCreateoneuserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateoneuserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createoneuserMutation, { data, loading, error }] = useCreateoneuserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateoneuserMutation(baseOptions?: Apollo.MutationHookOptions<CreateoneuserMutation, CreateoneuserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateoneuserMutation, CreateoneuserMutationVariables>(CreateoneuserDocument, options);
      }
export type CreateoneuserMutationHookResult = ReturnType<typeof useCreateoneuserMutation>;
export type CreateoneuserMutationResult = Apollo.MutationResult<CreateoneuserMutation>;
export type CreateoneuserMutationOptions = Apollo.BaseMutationOptions<CreateoneuserMutation, CreateoneuserMutationVariables>;
export const UpdateuserDocument = gql`
    mutation UPDATEUSER($data: userUpdateInput!, $id: String) {
  updateOneuser(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateuserMutationFn = Apollo.MutationFunction<UpdateuserMutation, UpdateuserMutationVariables>;

/**
 * __useUpdateuserMutation__
 *
 * To run a mutation, you first call `useUpdateuserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateuserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateuserMutation, { data, loading, error }] = useUpdateuserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateuserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateuserMutation, UpdateuserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateuserMutation, UpdateuserMutationVariables>(UpdateuserDocument, options);
      }
export type UpdateuserMutationHookResult = ReturnType<typeof useUpdateuserMutation>;
export type UpdateuserMutationResult = Apollo.MutationResult<UpdateuserMutation>;
export type UpdateuserMutationOptions = Apollo.BaseMutationOptions<UpdateuserMutation, UpdateuserMutationVariables>;
export const RegionalbyuserdataDocument = gql`
    query REGIONALBYUSERDATA($id: String) {
  regionalUsers(where: {user_id: {contains: $id}}) {
    id
    user_id
    user_name
    regional_id
    regional_name
    user_type
  }
}
    `;

/**
 * __useRegionalbyuserdataQuery__
 *
 * To run a query within a React component, call `useRegionalbyuserdataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionalbyuserdataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionalbyuserdataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegionalbyuserdataQuery(baseOptions?: Apollo.QueryHookOptions<RegionalbyuserdataQuery, RegionalbyuserdataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionalbyuserdataQuery, RegionalbyuserdataQueryVariables>(RegionalbyuserdataDocument, options);
      }
export function useRegionalbyuserdataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionalbyuserdataQuery, RegionalbyuserdataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionalbyuserdataQuery, RegionalbyuserdataQueryVariables>(RegionalbyuserdataDocument, options);
        }
export type RegionalbyuserdataQueryHookResult = ReturnType<typeof useRegionalbyuserdataQuery>;
export type RegionalbyuserdataLazyQueryHookResult = ReturnType<typeof useRegionalbyuserdataLazyQuery>;
export type RegionalbyuserdataQueryResult = Apollo.QueryResult<RegionalbyuserdataQuery, RegionalbyuserdataQueryVariables>;
export const CreateregionaluserDocument = gql`
    mutation CREATEREGIONALUSER($data: RegionalUserCreateInput!) {
  createOneRegionalUser(data: $data) {
    id
    regional_name
  }
}
    `;
export type CreateregionaluserMutationFn = Apollo.MutationFunction<CreateregionaluserMutation, CreateregionaluserMutationVariables>;

/**
 * __useCreateregionaluserMutation__
 *
 * To run a mutation, you first call `useCreateregionaluserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateregionaluserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createregionaluserMutation, { data, loading, error }] = useCreateregionaluserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateregionaluserMutation(baseOptions?: Apollo.MutationHookOptions<CreateregionaluserMutation, CreateregionaluserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateregionaluserMutation, CreateregionaluserMutationVariables>(CreateregionaluserDocument, options);
      }
export type CreateregionaluserMutationHookResult = ReturnType<typeof useCreateregionaluserMutation>;
export type CreateregionaluserMutationResult = Apollo.MutationResult<CreateregionaluserMutation>;
export type CreateregionaluserMutationOptions = Apollo.BaseMutationOptions<CreateregionaluserMutation, CreateregionaluserMutationVariables>;
export const DeleteregionaluserDocument = gql`
    mutation DELETEREGIONALUSER($date: DateTime!, $id: String) {
  updateOneRegionalUser(data: {deleted_at: $date}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteregionaluserMutationFn = Apollo.MutationFunction<DeleteregionaluserMutation, DeleteregionaluserMutationVariables>;

/**
 * __useDeleteregionaluserMutation__
 *
 * To run a mutation, you first call `useDeleteregionaluserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteregionaluserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteregionaluserMutation, { data, loading, error }] = useDeleteregionaluserMutation({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteregionaluserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteregionaluserMutation, DeleteregionaluserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteregionaluserMutation, DeleteregionaluserMutationVariables>(DeleteregionaluserDocument, options);
      }
export type DeleteregionaluserMutationHookResult = ReturnType<typeof useDeleteregionaluserMutation>;
export type DeleteregionaluserMutationResult = Apollo.MutationResult<DeleteregionaluserMutation>;
export type DeleteregionaluserMutationOptions = Apollo.BaseMutationOptions<DeleteregionaluserMutation, DeleteregionaluserMutationVariables>;
export const AcounpointsDocument = gql`
    query ACOUNPOINTS($company: String) {
  places(where: {company_id: {equals: $company}}) {
    id
    name
  }
}
    `;

/**
 * __useAcounpointsQuery__
 *
 * To run a query within a React component, call `useAcounpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcounpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcounpointsQuery({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useAcounpointsQuery(baseOptions?: Apollo.QueryHookOptions<AcounpointsQuery, AcounpointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcounpointsQuery, AcounpointsQueryVariables>(AcounpointsDocument, options);
      }
export function useAcounpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcounpointsQuery, AcounpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcounpointsQuery, AcounpointsQueryVariables>(AcounpointsDocument, options);
        }
export type AcounpointsQueryHookResult = ReturnType<typeof useAcounpointsQuery>;
export type AcounpointsLazyQueryHookResult = ReturnType<typeof useAcounpointsLazyQuery>;
export type AcounpointsQueryResult = Apollo.QueryResult<AcounpointsQuery, AcounpointsQueryVariables>;
export const AcountsDocument = gql`
    query ACOUNTS($company_id: String, $search: String, $regionals: String, $first: Int, $last: Int) {
  accounts(
    where: {company_id: {equals: $company_id}, OR: [{number: {contains: $search}}, {numeral_v: {contains: $search}}, {marketer_name: {contains: $search}}, {place_name: {contains: $search}}, {service_name: {contains: $search}}], AND: [{regional_id: {equals: $regionals}}]}
    first: $first
    last: $last
  ) {
    id
    company_id
    company_name
    created_at
    deleted_at
    is_active
    marketer_id
    marketer_name
    number
    numeral_v
    place_id
    place_name
    property_level_id
    regional_id
    regional_name
    sdl_id
    sdl_name
    service_id
    service_name
    updated_at
    user_created
    user_deleted
    user_updated
    frequency
    estimate_issue_date
    estimate_timely_payment_date
  }
}
    `;

/**
 * __useAcountsQuery__
 *
 * To run a query within a React component, call `useAcountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcountsQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      search: // value for 'search'
 *      regionals: // value for 'regionals'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAcountsQuery(baseOptions?: Apollo.QueryHookOptions<AcountsQuery, AcountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcountsQuery, AcountsQueryVariables>(AcountsDocument, options);
      }
export function useAcountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcountsQuery, AcountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcountsQuery, AcountsQueryVariables>(AcountsDocument, options);
        }
export type AcountsQueryHookResult = ReturnType<typeof useAcountsQuery>;
export type AcountsLazyQueryHookResult = ReturnType<typeof useAcountsLazyQuery>;
export type AcountsQueryResult = Apollo.QueryResult<AcountsQuery, AcountsQueryVariables>;
export const UpdateoneacountDocument = gql`
    mutation UPDATEONEACOUNT($data: accountUpdateInput!, $id: String) {
  updateOneaccount(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateoneacountMutationFn = Apollo.MutationFunction<UpdateoneacountMutation, UpdateoneacountMutationVariables>;

/**
 * __useUpdateoneacountMutation__
 *
 * To run a mutation, you first call `useUpdateoneacountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateoneacountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateoneacountMutation, { data, loading, error }] = useUpdateoneacountMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateoneacountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateoneacountMutation, UpdateoneacountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateoneacountMutation, UpdateoneacountMutationVariables>(UpdateoneacountDocument, options);
      }
export type UpdateoneacountMutationHookResult = ReturnType<typeof useUpdateoneacountMutation>;
export type UpdateoneacountMutationResult = Apollo.MutationResult<UpdateoneacountMutation>;
export type UpdateoneacountMutationOptions = Apollo.BaseMutationOptions<UpdateoneacountMutation, UpdateoneacountMutationVariables>;
export const DeleteacountDocument = gql`
    mutation DELETEACOUNT($date: DateTime!, $id: String) {
  updateOneaccount(data: {deleted_at: $date}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteacountMutationFn = Apollo.MutationFunction<DeleteacountMutation, DeleteacountMutationVariables>;

/**
 * __useDeleteacountMutation__
 *
 * To run a mutation, you first call `useDeleteacountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteacountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteacountMutation, { data, loading, error }] = useDeleteacountMutation({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteacountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteacountMutation, DeleteacountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteacountMutation, DeleteacountMutationVariables>(DeleteacountDocument, options);
      }
export type DeleteacountMutationHookResult = ReturnType<typeof useDeleteacountMutation>;
export type DeleteacountMutationResult = Apollo.MutationResult<DeleteacountMutation>;
export type DeleteacountMutationOptions = Apollo.BaseMutationOptions<DeleteacountMutation, DeleteacountMutationVariables>;
export const CreateacountDocument = gql`
    mutation CREATEACOUNT($data: accountCreateInput!) {
  createOneaccount(data: $data) {
    id
  }
}
    `;
export type CreateacountMutationFn = Apollo.MutationFunction<CreateacountMutation, CreateacountMutationVariables>;

/**
 * __useCreateacountMutation__
 *
 * To run a mutation, you first call `useCreateacountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateacountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createacountMutation, { data, loading, error }] = useCreateacountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateacountMutation(baseOptions?: Apollo.MutationHookOptions<CreateacountMutation, CreateacountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateacountMutation, CreateacountMutationVariables>(CreateacountDocument, options);
      }
export type CreateacountMutationHookResult = ReturnType<typeof useCreateacountMutation>;
export type CreateacountMutationResult = Apollo.MutationResult<CreateacountMutation>;
export type CreateacountMutationOptions = Apollo.BaseMutationOptions<CreateacountMutation, CreateacountMutationVariables>;
export const CounstfilltersDocument = gql`
    query COUNSTFILLTERS {
  accounts(where: {}) {
    budget
    vertebra_pay
    payment_aut
  }
}
    `;

/**
 * __useCounstfilltersQuery__
 *
 * To run a query within a React component, call `useCounstfilltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounstfilltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCounstfilltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCounstfilltersQuery(baseOptions?: Apollo.QueryHookOptions<CounstfilltersQuery, CounstfilltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CounstfilltersQuery, CounstfilltersQueryVariables>(CounstfilltersDocument, options);
      }
export function useCounstfilltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CounstfilltersQuery, CounstfilltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CounstfilltersQuery, CounstfilltersQueryVariables>(CounstfilltersDocument, options);
        }
export type CounstfilltersQueryHookResult = ReturnType<typeof useCounstfilltersQuery>;
export type CounstfilltersLazyQueryHookResult = ReturnType<typeof useCounstfilltersLazyQuery>;
export type CounstfilltersQueryResult = Apollo.QueryResult<CounstfilltersQuery, CounstfilltersQueryVariables>;
export const LoginDocument = gql`
    mutation LOGIN($signIn: signIn!) {
  signIn(payload: $signIn) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      signIn: // value for 'signIn'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const BanksdataDocument = gql`
    query BANKSDATA($search: String, $first: Int, $last: Int) {
  banks(
    where: {OR: [{name: {contains: $search}}, {nit: {contains: $search}}]}
    first: $first
    last: $last
  ) {
    id
    nit
    name
  }
}
    `;

/**
 * __useBanksdataQuery__
 *
 * To run a query within a React component, call `useBanksdataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBanksdataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBanksdataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useBanksdataQuery(baseOptions?: Apollo.QueryHookOptions<BanksdataQuery, BanksdataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BanksdataQuery, BanksdataQueryVariables>(BanksdataDocument, options);
      }
export function useBanksdataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BanksdataQuery, BanksdataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BanksdataQuery, BanksdataQueryVariables>(BanksdataDocument, options);
        }
export type BanksdataQueryHookResult = ReturnType<typeof useBanksdataQuery>;
export type BanksdataLazyQueryHookResult = ReturnType<typeof useBanksdataLazyQuery>;
export type BanksdataQueryResult = Apollo.QueryResult<BanksdataQuery, BanksdataQueryVariables>;
export const CreateonebankDocument = gql`
    mutation CREATEONEBANK($data: bankCreateInput!) {
  createOnebank(data: $data) {
    id
  }
}
    `;
export type CreateonebankMutationFn = Apollo.MutationFunction<CreateonebankMutation, CreateonebankMutationVariables>;

/**
 * __useCreateonebankMutation__
 *
 * To run a mutation, you first call `useCreateonebankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateonebankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createonebankMutation, { data, loading, error }] = useCreateonebankMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateonebankMutation(baseOptions?: Apollo.MutationHookOptions<CreateonebankMutation, CreateonebankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateonebankMutation, CreateonebankMutationVariables>(CreateonebankDocument, options);
      }
export type CreateonebankMutationHookResult = ReturnType<typeof useCreateonebankMutation>;
export type CreateonebankMutationResult = Apollo.MutationResult<CreateonebankMutation>;
export type CreateonebankMutationOptions = Apollo.BaseMutationOptions<CreateonebankMutation, CreateonebankMutationVariables>;
export const UpdateonebankDocument = gql`
    mutation UPDATEONEBANK($data: bankUpdateInput!, $id: String) {
  updateOnebank(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateonebankMutationFn = Apollo.MutationFunction<UpdateonebankMutation, UpdateonebankMutationVariables>;

/**
 * __useUpdateonebankMutation__
 *
 * To run a mutation, you first call `useUpdateonebankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateonebankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateonebankMutation, { data, loading, error }] = useUpdateonebankMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateonebankMutation(baseOptions?: Apollo.MutationHookOptions<UpdateonebankMutation, UpdateonebankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateonebankMutation, UpdateonebankMutationVariables>(UpdateonebankDocument, options);
      }
export type UpdateonebankMutationHookResult = ReturnType<typeof useUpdateonebankMutation>;
export type UpdateonebankMutationResult = Apollo.MutationResult<UpdateonebankMutation>;
export type UpdateonebankMutationOptions = Apollo.BaseMutationOptions<UpdateonebankMutation, UpdateonebankMutationVariables>;
export const DeleteonebankDocument = gql`
    mutation DELETEONEBANK($id: String, $deleted_at: DateTime) {
  updateOnebank(data: {deleted_at: $deleted_at}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteonebankMutationFn = Apollo.MutationFunction<DeleteonebankMutation, DeleteonebankMutationVariables>;

/**
 * __useDeleteonebankMutation__
 *
 * To run a mutation, you first call `useDeleteonebankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteonebankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteonebankMutation, { data, loading, error }] = useDeleteonebankMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleted_at: // value for 'deleted_at'
 *   },
 * });
 */
export function useDeleteonebankMutation(baseOptions?: Apollo.MutationHookOptions<DeleteonebankMutation, DeleteonebankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteonebankMutation, DeleteonebankMutationVariables>(DeleteonebankDocument, options);
      }
export type DeleteonebankMutationHookResult = ReturnType<typeof useDeleteonebankMutation>;
export type DeleteonebankMutationResult = Apollo.MutationResult<DeleteonebankMutation>;
export type DeleteonebankMutationOptions = Apollo.BaseMutationOptions<DeleteonebankMutation, DeleteonebankMutationVariables>;
export const UploaddataDocument = gql`
    query UPLOADDATA($regional: String, $year: Int, $limit: Int, $offset: Int, $search: String, $order: SelectBillsOrder, $marketers: [String!]) {
  selectBills(
    payload: {regional: $regional, year: $year, limit: $limit, offset: $offset, search: $search, marketers: $marketers, order_by: $order}
  ) {
    company_id
    company_name
    regional_id
    regional_name
    place_id
    place_name
    number
    id
    numeral_v
    marketer_id
    marketer_name
    getbillsbyaccount
    sdl_name
    sdl_id
    service_name
    service_id
    property_level_id
    budget
    vertebra_pay
    payment_aut
    account_parent
  }
}
    `;

/**
 * __useUploaddataQuery__
 *
 * To run a query within a React component, call `useUploaddataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploaddataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploaddataQuery({
 *   variables: {
 *      regional: // value for 'regional'
 *      year: // value for 'year'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      order: // value for 'order'
 *      marketers: // value for 'marketers'
 *   },
 * });
 */
export function useUploaddataQuery(baseOptions?: Apollo.QueryHookOptions<UploaddataQuery, UploaddataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploaddataQuery, UploaddataQueryVariables>(UploaddataDocument, options);
      }
export function useUploaddataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploaddataQuery, UploaddataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploaddataQuery, UploaddataQueryVariables>(UploaddataDocument, options);
        }
export type UploaddataQueryHookResult = ReturnType<typeof useUploaddataQuery>;
export type UploaddataLazyQueryHookResult = ReturnType<typeof useUploaddataLazyQuery>;
export type UploaddataQueryResult = Apollo.QueryResult<UploaddataQuery, UploaddataQueryVariables>;
export const CompaniestableDocument = gql`
    query COMPANIESTABLE($search: String, $first: Int, $last: Int) {
  companies(
    where: {OR: [{name: {contains: $search}}, {nit: {contains: $search}}, {type: {contains: $search}}]}
    first: $first
    last: $last
  ) {
    id
    nit
    name
    type
    manager
    imagen
    status
  }
}
    `;

/**
 * __useCompaniestableQuery__
 *
 * To run a query within a React component, call `useCompaniestableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniestableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniestableQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCompaniestableQuery(baseOptions?: Apollo.QueryHookOptions<CompaniestableQuery, CompaniestableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniestableQuery, CompaniestableQueryVariables>(CompaniestableDocument, options);
      }
export function useCompaniestableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniestableQuery, CompaniestableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniestableQuery, CompaniestableQueryVariables>(CompaniestableDocument, options);
        }
export type CompaniestableQueryHookResult = ReturnType<typeof useCompaniestableQuery>;
export type CompaniestableLazyQueryHookResult = ReturnType<typeof useCompaniestableLazyQuery>;
export type CompaniestableQueryResult = Apollo.QueryResult<CompaniestableQuery, CompaniestableQueryVariables>;
export const UpdateBillsDocument = gql`
    mutation UPDATEBills($company_id: String, $company_name: String, $regional_id: String, $regional_name: String, $place_id: String, $place_name: String, $account_id: String, $service_id: String, $account_name: String, $service_name: String, $type_of_bill: TypeOfBill, $date_bill: String, $image_bill: String, $observation: String, $status: String, $marketer_id: String, $marketer_name: String, $payment_aut: Boolean, $vertebra_pay: Boolean, $account_parent: String) {
  createOneBill(
    BillCreate: {company_id: $company_id, company_name: $company_name, regional_id: $regional_id, regional_name: $regional_name, place_id: $place_id, place_name: $place_name, account_id: $account_id, service_id: $service_id, account_name: $account_name, service_name: $service_name, type_of_bill: $type_of_bill, image_bill: $image_bill, observation: $observation, status_bill: $status, marketer_id: $marketer_id, date_bill: $date_bill, marketer_name: $marketer_name, payment_aut: $payment_aut, vertebra_pay: $vertebra_pay, account_parent: $account_parent}
  ) {
    id
    account_id
  }
}
    `;
export type UpdateBillsMutationFn = Apollo.MutationFunction<UpdateBillsMutation, UpdateBillsMutationVariables>;

/**
 * __useUpdateBillsMutation__
 *
 * To run a mutation, you first call `useUpdateBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillsMutation, { data, loading, error }] = useUpdateBillsMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      company_name: // value for 'company_name'
 *      regional_id: // value for 'regional_id'
 *      regional_name: // value for 'regional_name'
 *      place_id: // value for 'place_id'
 *      place_name: // value for 'place_name'
 *      account_id: // value for 'account_id'
 *      service_id: // value for 'service_id'
 *      account_name: // value for 'account_name'
 *      service_name: // value for 'service_name'
 *      type_of_bill: // value for 'type_of_bill'
 *      date_bill: // value for 'date_bill'
 *      image_bill: // value for 'image_bill'
 *      observation: // value for 'observation'
 *      status: // value for 'status'
 *      marketer_id: // value for 'marketer_id'
 *      marketer_name: // value for 'marketer_name'
 *      payment_aut: // value for 'payment_aut'
 *      vertebra_pay: // value for 'vertebra_pay'
 *      account_parent: // value for 'account_parent'
 *   },
 * });
 */
export function useUpdateBillsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillsMutation, UpdateBillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillsMutation, UpdateBillsMutationVariables>(UpdateBillsDocument, options);
      }
export type UpdateBillsMutationHookResult = ReturnType<typeof useUpdateBillsMutation>;
export type UpdateBillsMutationResult = Apollo.MutationResult<UpdateBillsMutation>;
export type UpdateBillsMutationOptions = Apollo.BaseMutationOptions<UpdateBillsMutation, UpdateBillsMutationVariables>;
export const DeteleonebillnewDocument = gql`
    mutation DETELEONEBILLNEW($date: DateTime!, $id: String!) {
  updateOnebill(data: {deleted_at: $date}, where: {id: $id}) {
    id
    deleted_at
  }
}
    `;
export type DeteleonebillnewMutationFn = Apollo.MutationFunction<DeteleonebillnewMutation, DeteleonebillnewMutationVariables>;

/**
 * __useDeteleonebillnewMutation__
 *
 * To run a mutation, you first call `useDeteleonebillnewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeteleonebillnewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deteleonebillnewMutation, { data, loading, error }] = useDeteleonebillnewMutation({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeteleonebillnewMutation(baseOptions?: Apollo.MutationHookOptions<DeteleonebillnewMutation, DeteleonebillnewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeteleonebillnewMutation, DeteleonebillnewMutationVariables>(DeteleonebillnewDocument, options);
      }
export type DeteleonebillnewMutationHookResult = ReturnType<typeof useDeteleonebillnewMutation>;
export type DeteleonebillnewMutationResult = Apollo.MutationResult<DeteleonebillnewMutation>;
export type DeteleonebillnewMutationOptions = Apollo.BaseMutationOptions<DeteleonebillnewMutation, DeteleonebillnewMutationVariables>;
export const DomainsDocument = gql`
    query DOMAINS($type: String, $id: String) {
  domains(where: {type: {equals: $type}, parent: {equals: $id}}) {
    id
    name
    type
  }
}
    `;

/**
 * __useDomainsQuery__
 *
 * To run a query within a React component, call `useDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDomainsQuery(baseOptions?: Apollo.QueryHookOptions<DomainsQuery, DomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainsQuery, DomainsQueryVariables>(DomainsDocument, options);
      }
export function useDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainsQuery, DomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainsQuery, DomainsQueryVariables>(DomainsDocument, options);
        }
export type DomainsQueryHookResult = ReturnType<typeof useDomainsQuery>;
export type DomainsLazyQueryHookResult = ReturnType<typeof useDomainsLazyQuery>;
export type DomainsQueryResult = Apollo.QueryResult<DomainsQuery, DomainsQueryVariables>;
export const DomainsdataDocument = gql`
    query DOMAINSDATA($search: String, $first: Int, $last: Int) {
  domains(
    where: {OR: [{name: {contains: $search}}, {type: {contains: $search}}]}
    first: $first
    last: $last
  ) {
    id
    name
    type
  }
}
    `;

/**
 * __useDomainsdataQuery__
 *
 * To run a query within a React component, call `useDomainsdataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainsdataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainsdataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDomainsdataQuery(baseOptions?: Apollo.QueryHookOptions<DomainsdataQuery, DomainsdataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainsdataQuery, DomainsdataQueryVariables>(DomainsdataDocument, options);
      }
export function useDomainsdataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainsdataQuery, DomainsdataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainsdataQuery, DomainsdataQueryVariables>(DomainsdataDocument, options);
        }
export type DomainsdataQueryHookResult = ReturnType<typeof useDomainsdataQuery>;
export type DomainsdataLazyQueryHookResult = ReturnType<typeof useDomainsdataLazyQuery>;
export type DomainsdataQueryResult = Apollo.QueryResult<DomainsdataQuery, DomainsdataQueryVariables>;
export const CreateonedomainDocument = gql`
    mutation CREATEONEDOMAIN($data: domainCreateInput!) {
  createOnedomain(data: $data) {
    id
  }
}
    `;
export type CreateonedomainMutationFn = Apollo.MutationFunction<CreateonedomainMutation, CreateonedomainMutationVariables>;

/**
 * __useCreateonedomainMutation__
 *
 * To run a mutation, you first call `useCreateonedomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateonedomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createonedomainMutation, { data, loading, error }] = useCreateonedomainMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateonedomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateonedomainMutation, CreateonedomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateonedomainMutation, CreateonedomainMutationVariables>(CreateonedomainDocument, options);
      }
export type CreateonedomainMutationHookResult = ReturnType<typeof useCreateonedomainMutation>;
export type CreateonedomainMutationResult = Apollo.MutationResult<CreateonedomainMutation>;
export type CreateonedomainMutationOptions = Apollo.BaseMutationOptions<CreateonedomainMutation, CreateonedomainMutationVariables>;
export const UpdateonedomainDocument = gql`
    mutation UPDATEONEDOMAIN($data: domainUpdateInput!, $id: String) {
  updateOnedomain(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateonedomainMutationFn = Apollo.MutationFunction<UpdateonedomainMutation, UpdateonedomainMutationVariables>;

/**
 * __useUpdateonedomainMutation__
 *
 * To run a mutation, you first call `useUpdateonedomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateonedomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateonedomainMutation, { data, loading, error }] = useUpdateonedomainMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateonedomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateonedomainMutation, UpdateonedomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateonedomainMutation, UpdateonedomainMutationVariables>(UpdateonedomainDocument, options);
      }
export type UpdateonedomainMutationHookResult = ReturnType<typeof useUpdateonedomainMutation>;
export type UpdateonedomainMutationResult = Apollo.MutationResult<UpdateonedomainMutation>;
export type UpdateonedomainMutationOptions = Apollo.BaseMutationOptions<UpdateonedomainMutation, UpdateonedomainMutationVariables>;
export const DeleteonedomainDocument = gql`
    mutation DELETEONEDOMAIN($id: String, $deleted_at: DateTime) {
  updateOnedomain(data: {deleted_at: $deleted_at}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteonedomainMutationFn = Apollo.MutationFunction<DeleteonedomainMutation, DeleteonedomainMutationVariables>;

/**
 * __useDeleteonedomainMutation__
 *
 * To run a mutation, you first call `useDeleteonedomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteonedomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteonedomainMutation, { data, loading, error }] = useDeleteonedomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleted_at: // value for 'deleted_at'
 *   },
 * });
 */
export function useDeleteonedomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteonedomainMutation, DeleteonedomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteonedomainMutation, DeleteonedomainMutationVariables>(DeleteonedomainDocument, options);
      }
export type DeleteonedomainMutationHookResult = ReturnType<typeof useDeleteonedomainMutation>;
export type DeleteonedomainMutationResult = Apollo.MutationResult<DeleteonedomainMutation>;
export type DeleteonedomainMutationOptions = Apollo.BaseMutationOptions<DeleteonedomainMutation, DeleteonedomainMutationVariables>;
export const ReportgeneralcargaDocument = gql`
    query REPORTGENERALCARGA($year: Int!, $search: String, $first: Int!, $last: Int!) {
  RepGeneralCarga(year: $year, search: $search, first: $first, last: $last) {
    id
    name
    reportgeneralcarga
  }
}
    `;

/**
 * __useReportgeneralcargaQuery__
 *
 * To run a query within a React component, call `useReportgeneralcargaQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportgeneralcargaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportgeneralcargaQuery({
 *   variables: {
 *      year: // value for 'year'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useReportgeneralcargaQuery(baseOptions: Apollo.QueryHookOptions<ReportgeneralcargaQuery, ReportgeneralcargaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportgeneralcargaQuery, ReportgeneralcargaQueryVariables>(ReportgeneralcargaDocument, options);
      }
export function useReportgeneralcargaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportgeneralcargaQuery, ReportgeneralcargaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportgeneralcargaQuery, ReportgeneralcargaQueryVariables>(ReportgeneralcargaDocument, options);
        }
export type ReportgeneralcargaQueryHookResult = ReturnType<typeof useReportgeneralcargaQuery>;
export type ReportgeneralcargaLazyQueryHookResult = ReturnType<typeof useReportgeneralcargaLazyQuery>;
export type ReportgeneralcargaQueryResult = Apollo.QueryResult<ReportgeneralcargaQuery, ReportgeneralcargaQueryVariables>;
export const GenerealreportstatusDocument = gql`
    query GENEREALREPORTSTATUS($year: Int!) {
  perBillPaidTotal(year: $year) {
    company_id
    total_facturas
    total_reportadas
  }
}
    `;

/**
 * __useGenerealreportstatusQuery__
 *
 * To run a query within a React component, call `useGenerealreportstatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerealreportstatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerealreportstatusQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGenerealreportstatusQuery(baseOptions: Apollo.QueryHookOptions<GenerealreportstatusQuery, GenerealreportstatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerealreportstatusQuery, GenerealreportstatusQueryVariables>(GenerealreportstatusDocument, options);
      }
export function useGenerealreportstatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerealreportstatusQuery, GenerealreportstatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerealreportstatusQuery, GenerealreportstatusQueryVariables>(GenerealreportstatusDocument, options);
        }
export type GenerealreportstatusQueryHookResult = ReturnType<typeof useGenerealreportstatusQuery>;
export type GenerealreportstatusLazyQueryHookResult = ReturnType<typeof useGenerealreportstatusLazyQuery>;
export type GenerealreportstatusQueryResult = Apollo.QueryResult<GenerealreportstatusQuery, GenerealreportstatusQueryVariables>;
export const CompaniesDocument = gql`
    query COMPANIES {
  companies(where: {}) {
    id
    name
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const GetmoviiDocument = gql`
    mutation GETMOVII($id: String!) {
  getMoviiBill(bill_id: $id) {
    data {
      billerName
      referenceNumber
      amount
    }
  }
}
    `;
export type GetmoviiMutationFn = Apollo.MutationFunction<GetmoviiMutation, GetmoviiMutationVariables>;

/**
 * __useGetmoviiMutation__
 *
 * To run a mutation, you first call `useGetmoviiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetmoviiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getmoviiMutation, { data, loading, error }] = useGetmoviiMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetmoviiMutation(baseOptions?: Apollo.MutationHookOptions<GetmoviiMutation, GetmoviiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetmoviiMutation, GetmoviiMutationVariables>(GetmoviiDocument, options);
      }
export type GetmoviiMutationHookResult = ReturnType<typeof useGetmoviiMutation>;
export type GetmoviiMutationResult = Apollo.MutationResult<GetmoviiMutation>;
export type GetmoviiMutationOptions = Apollo.BaseMutationOptions<GetmoviiMutation, GetmoviiMutationVariables>;
export const MarketerdataDocument = gql`
    query MARKETERDATA($search: String, $last: Int, $first: Int) {
  marketers(
    where: {OR: [{name: {contains: $search}}, {short_name: {contains: $search}}, {type: {contains: $search}}, {email: {contains: $search}}, {nit: {contains: $search}}, {service: {name: {contains: $search}}}, {PaymentMethodMarketer: {every: {bank_name: {contains: $search}}}}, {phone: {contains: $search}}, {code_movii: {contains: $search}}, {accounts: {every: {place_name: {contains: $search}}}}, {bill: {every: {number_bill: {contains: $search}}}}], AND: []}
    first: $first
    last: $last
  ) {
    id
    name
    short_name
    type
    nit
    service {
      name
    }
    email
    PaymentMethodMarketer {
      bank_name
      priority
      reference_number
      type
      payment_method {
        id
        name
      }
    }
    phone
    code_movii
    service_id
    send_prove
    accounts {
      place_name
      property_level {
        name
      }
    }
    bill {
      number_bill
    }
  }
}
    `;

/**
 * __useMarketerdataQuery__
 *
 * To run a query within a React component, call `useMarketerdataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketerdataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketerdataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMarketerdataQuery(baseOptions?: Apollo.QueryHookOptions<MarketerdataQuery, MarketerdataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketerdataQuery, MarketerdataQueryVariables>(MarketerdataDocument, options);
      }
export function useMarketerdataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketerdataQuery, MarketerdataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketerdataQuery, MarketerdataQueryVariables>(MarketerdataDocument, options);
        }
export type MarketerdataQueryHookResult = ReturnType<typeof useMarketerdataQuery>;
export type MarketerdataLazyQueryHookResult = ReturnType<typeof useMarketerdataLazyQuery>;
export type MarketerdataQueryResult = Apollo.QueryResult<MarketerdataQuery, MarketerdataQueryVariables>;
export const CreateonemarketerDocument = gql`
    mutation CREATEONEMARKETER($data: marketerCreateInput!) {
  createOnemarketer(data: $data) {
    id
  }
}
    `;
export type CreateonemarketerMutationFn = Apollo.MutationFunction<CreateonemarketerMutation, CreateonemarketerMutationVariables>;

/**
 * __useCreateonemarketerMutation__
 *
 * To run a mutation, you first call `useCreateonemarketerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateonemarketerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createonemarketerMutation, { data, loading, error }] = useCreateonemarketerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateonemarketerMutation(baseOptions?: Apollo.MutationHookOptions<CreateonemarketerMutation, CreateonemarketerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateonemarketerMutation, CreateonemarketerMutationVariables>(CreateonemarketerDocument, options);
      }
export type CreateonemarketerMutationHookResult = ReturnType<typeof useCreateonemarketerMutation>;
export type CreateonemarketerMutationResult = Apollo.MutationResult<CreateonemarketerMutation>;
export type CreateonemarketerMutationOptions = Apollo.BaseMutationOptions<CreateonemarketerMutation, CreateonemarketerMutationVariables>;
export const EditonemarketerDocument = gql`
    mutation EDITONEMARKETER($data: marketerUpdateInput!, $id: String) {
  updateOnemarketer(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type EditonemarketerMutationFn = Apollo.MutationFunction<EditonemarketerMutation, EditonemarketerMutationVariables>;

/**
 * __useEditonemarketerMutation__
 *
 * To run a mutation, you first call `useEditonemarketerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditonemarketerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editonemarketerMutation, { data, loading, error }] = useEditonemarketerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditonemarketerMutation(baseOptions?: Apollo.MutationHookOptions<EditonemarketerMutation, EditonemarketerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditonemarketerMutation, EditonemarketerMutationVariables>(EditonemarketerDocument, options);
      }
export type EditonemarketerMutationHookResult = ReturnType<typeof useEditonemarketerMutation>;
export type EditonemarketerMutationResult = Apollo.MutationResult<EditonemarketerMutation>;
export type EditonemarketerMutationOptions = Apollo.BaseMutationOptions<EditonemarketerMutation, EditonemarketerMutationVariables>;
export const DeleteonemarketerDocument = gql`
    mutation DELETEONEMARKETER($id: String, $deleted_at: DateTime) {
  updateOnemarketer(data: {deleted_at: $deleted_at}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteonemarketerMutationFn = Apollo.MutationFunction<DeleteonemarketerMutation, DeleteonemarketerMutationVariables>;

/**
 * __useDeleteonemarketerMutation__
 *
 * To run a mutation, you first call `useDeleteonemarketerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteonemarketerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteonemarketerMutation, { data, loading, error }] = useDeleteonemarketerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleted_at: // value for 'deleted_at'
 *   },
 * });
 */
export function useDeleteonemarketerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteonemarketerMutation, DeleteonemarketerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteonemarketerMutation, DeleteonemarketerMutationVariables>(DeleteonemarketerDocument, options);
      }
export type DeleteonemarketerMutationHookResult = ReturnType<typeof useDeleteonemarketerMutation>;
export type DeleteonemarketerMutationResult = Apollo.MutationResult<DeleteonemarketerMutation>;
export type DeleteonemarketerMutationOptions = Apollo.BaseMutationOptions<DeleteonemarketerMutation, DeleteonemarketerMutationVariables>;
export const MarketersfilterDocument = gql`
    query MARKETERSFILTER($filter: String) {
  marketers(where: {AND: [{short_name: {contains: $filter}}]}) {
    id
    short_name
  }
}
    `;

/**
 * __useMarketersfilterQuery__
 *
 * To run a query within a React component, call `useMarketersfilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketersfilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketersfilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketersfilterQuery(baseOptions?: Apollo.QueryHookOptions<MarketersfilterQuery, MarketersfilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketersfilterQuery, MarketersfilterQueryVariables>(MarketersfilterDocument, options);
      }
export function useMarketersfilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketersfilterQuery, MarketersfilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketersfilterQuery, MarketersfilterQueryVariables>(MarketersfilterDocument, options);
        }
export type MarketersfilterQueryHookResult = ReturnType<typeof useMarketersfilterQuery>;
export type MarketersfilterLazyQueryHookResult = ReturnType<typeof useMarketersfilterLazyQuery>;
export type MarketersfilterQueryResult = Apollo.QueryResult<MarketersfilterQuery, MarketersfilterQueryVariables>;
export const ReportmetersDocument = gql`
    mutation REPORTMETERS($fecha_inicio: String!, $fecha_fin: String!, $frecuencia: String!, $meters: [Int!]!, $separador: String!) {
  Reportdatameters(
    ReportMeters: {fecha_inicio: $fecha_inicio, fecha_fin: $fecha_fin, frecuencia: $frecuencia, meters: $meters, separador: $separador}
  )
}
    `;
export type ReportmetersMutationFn = Apollo.MutationFunction<ReportmetersMutation, ReportmetersMutationVariables>;

/**
 * __useReportmetersMutation__
 *
 * To run a mutation, you first call `useReportmetersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportmetersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportmetersMutation, { data, loading, error }] = useReportmetersMutation({
 *   variables: {
 *      fecha_inicio: // value for 'fecha_inicio'
 *      fecha_fin: // value for 'fecha_fin'
 *      frecuencia: // value for 'frecuencia'
 *      meters: // value for 'meters'
 *      separador: // value for 'separador'
 *   },
 * });
 */
export function useReportmetersMutation(baseOptions?: Apollo.MutationHookOptions<ReportmetersMutation, ReportmetersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportmetersMutation, ReportmetersMutationVariables>(ReportmetersDocument, options);
      }
export type ReportmetersMutationHookResult = ReturnType<typeof useReportmetersMutation>;
export type ReportmetersMutationResult = Apollo.MutationResult<ReportmetersMutation>;
export type ReportmetersMutationOptions = Apollo.BaseMutationOptions<ReportmetersMutation, ReportmetersMutationVariables>;
export const PaymethodDocument = gql`
    query PAYMETHOD($marketer_id: String, $type: String) {
  paymentMethodMarketers(
    where: {marketer_id: {equals: $marketer_id}, type: {equals: $type}}
    orderBy: {priority: desc}
  ) {
    id
    priority
    bank_name
    payment_method_name
    reference_number
  }
}
    `;

/**
 * __usePaymethodQuery__
 *
 * To run a query within a React component, call `usePaymethodQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymethodQuery({
 *   variables: {
 *      marketer_id: // value for 'marketer_id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePaymethodQuery(baseOptions?: Apollo.QueryHookOptions<PaymethodQuery, PaymethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymethodQuery, PaymethodQueryVariables>(PaymethodDocument, options);
      }
export function usePaymethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymethodQuery, PaymethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymethodQuery, PaymethodQueryVariables>(PaymethodDocument, options);
        }
export type PaymethodQueryHookResult = ReturnType<typeof usePaymethodQuery>;
export type PaymethodLazyQueryHookResult = ReturnType<typeof usePaymethodLazyQuery>;
export type PaymethodQueryResult = Apollo.QueryResult<PaymethodQuery, PaymethodQueryVariables>;
export const CashsourcesDocument = gql`
    query CASHSOURCES {
  cashSources(where: {}) {
    id
    name
  }
}
    `;

/**
 * __useCashsourcesQuery__
 *
 * To run a query within a React component, call `useCashsourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashsourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashsourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCashsourcesQuery(baseOptions?: Apollo.QueryHookOptions<CashsourcesQuery, CashsourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashsourcesQuery, CashsourcesQueryVariables>(CashsourcesDocument, options);
      }
export function useCashsourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashsourcesQuery, CashsourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashsourcesQuery, CashsourcesQueryVariables>(CashsourcesDocument, options);
        }
export type CashsourcesQueryHookResult = ReturnType<typeof useCashsourcesQuery>;
export type CashsourcesLazyQueryHookResult = ReturnType<typeof useCashsourcesLazyQuery>;
export type CashsourcesQueryResult = Apollo.QueryResult<CashsourcesQuery, CashsourcesQueryVariables>;
export const PaysreportDocument = gql`
    mutation PAYSREPORT($fecha_inicio: String, $fecha_fin: String, $proyecto: String, $regional: [String!], $separador: String!) {
  ReportPagos(
    ReportPagos: {fecha_inicio: $fecha_inicio, fecha_fin: $fecha_fin, proyecto: $proyecto, sucursales: $regional, separador: $separador}
  )
}
    `;
export type PaysreportMutationFn = Apollo.MutationFunction<PaysreportMutation, PaysreportMutationVariables>;

/**
 * __usePaysreportMutation__
 *
 * To run a mutation, you first call `usePaysreportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaysreportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paysreportMutation, { data, loading, error }] = usePaysreportMutation({
 *   variables: {
 *      fecha_inicio: // value for 'fecha_inicio'
 *      fecha_fin: // value for 'fecha_fin'
 *      proyecto: // value for 'proyecto'
 *      regional: // value for 'regional'
 *      separador: // value for 'separador'
 *   },
 * });
 */
export function usePaysreportMutation(baseOptions?: Apollo.MutationHookOptions<PaysreportMutation, PaysreportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaysreportMutation, PaysreportMutationVariables>(PaysreportDocument, options);
      }
export type PaysreportMutationHookResult = ReturnType<typeof usePaysreportMutation>;
export type PaysreportMutationResult = Apollo.MutationResult<PaysreportMutation>;
export type PaysreportMutationOptions = Apollo.BaseMutationOptions<PaysreportMutation, PaysreportMutationVariables>;
export const PointsDocument = gql`
    query POINTS($search: String, $first: Int, $last: Int, $company_id: String, $regionals: String) {
  places(
    where: {company_id: {equals: $company_id}, OR: [{name: {contains: $search}}], AND: [{regional_id: {equals: $regionals}}]}
    first: $first
    last: $last
  ) {
    id
    name
    name_two
    address
    city
    deparment
    phone
    ceco
    employers
    office_code
    is_active
    regional_id
    type_place
    regional {
      name
    }
    company {
      name
    }
    area
    working_time
  }
}
    `;

/**
 * __usePointsQuery__
 *
 * To run a query within a React component, call `usePointsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      company_id: // value for 'company_id'
 *      regionals: // value for 'regionals'
 *   },
 * });
 */
export function usePointsQuery(baseOptions?: Apollo.QueryHookOptions<PointsQuery, PointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointsQuery, PointsQueryVariables>(PointsDocument, options);
      }
export function usePointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointsQuery, PointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointsQuery, PointsQueryVariables>(PointsDocument, options);
        }
export type PointsQueryHookResult = ReturnType<typeof usePointsQuery>;
export type PointsLazyQueryHookResult = ReturnType<typeof usePointsLazyQuery>;
export type PointsQueryResult = Apollo.QueryResult<PointsQuery, PointsQueryVariables>;
export const UpdateplaceDocument = gql`
    mutation UPDATEPLACE($data: placeUpdateInput!, $id: String) {
  updateOneplace(where: {id: $id}, data: $data) {
    id
  }
}
    `;
export type UpdateplaceMutationFn = Apollo.MutationFunction<UpdateplaceMutation, UpdateplaceMutationVariables>;

/**
 * __useUpdateplaceMutation__
 *
 * To run a mutation, you first call `useUpdateplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateplaceMutation, { data, loading, error }] = useUpdateplaceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateplaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateplaceMutation, UpdateplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateplaceMutation, UpdateplaceMutationVariables>(UpdateplaceDocument, options);
      }
export type UpdateplaceMutationHookResult = ReturnType<typeof useUpdateplaceMutation>;
export type UpdateplaceMutationResult = Apollo.MutationResult<UpdateplaceMutation>;
export type UpdateplaceMutationOptions = Apollo.BaseMutationOptions<UpdateplaceMutation, UpdateplaceMutationVariables>;
export const CreateplaceDocument = gql`
    mutation CREATEPLACE($data: placeCreateInput!) {
  createOneplace(data: $data) {
    id
  }
}
    `;
export type CreateplaceMutationFn = Apollo.MutationFunction<CreateplaceMutation, CreateplaceMutationVariables>;

/**
 * __useCreateplaceMutation__
 *
 * To run a mutation, you first call `useCreateplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createplaceMutation, { data, loading, error }] = useCreateplaceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateplaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateplaceMutation, CreateplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateplaceMutation, CreateplaceMutationVariables>(CreateplaceDocument, options);
      }
export type CreateplaceMutationHookResult = ReturnType<typeof useCreateplaceMutation>;
export type CreateplaceMutationResult = Apollo.MutationResult<CreateplaceMutation>;
export type CreateplaceMutationOptions = Apollo.BaseMutationOptions<CreateplaceMutation, CreateplaceMutationVariables>;
export const DeleteoneplaceDocument = gql`
    mutation DELETEONEPLACE($date: DateTime!, $id: String!) {
  updateOneplace(data: {deleted_at: $date}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteoneplaceMutationFn = Apollo.MutationFunction<DeleteoneplaceMutation, DeleteoneplaceMutationVariables>;

/**
 * __useDeleteoneplaceMutation__
 *
 * To run a mutation, you first call `useDeleteoneplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteoneplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteoneplaceMutation, { data, loading, error }] = useDeleteoneplaceMutation({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteoneplaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteoneplaceMutation, DeleteoneplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteoneplaceMutation, DeleteoneplaceMutationVariables>(DeleteoneplaceDocument, options);
      }
export type DeleteoneplaceMutationHookResult = ReturnType<typeof useDeleteoneplaceMutation>;
export type DeleteoneplaceMutationResult = Apollo.MutationResult<DeleteoneplaceMutation>;
export type DeleteoneplaceMutationOptions = Apollo.BaseMutationOptions<DeleteoneplaceMutation, DeleteoneplaceMutationVariables>;
export const PercentagebillsDocument = gql`
    query PERCENTAGEBILLS($regional: String, $status: [String!], $DateBegind: String, $DateEnd: String) {
  perBillPaid(
    payload: {regional: $regional, status: $status, date_begin: $DateBegind, date_end: $DateEnd}
  ) {
    percentage
  }
}
    `;

/**
 * __usePercentagebillsQuery__
 *
 * To run a query within a React component, call `usePercentagebillsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePercentagebillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePercentagebillsQuery({
 *   variables: {
 *      regional: // value for 'regional'
 *      status: // value for 'status'
 *      DateBegind: // value for 'DateBegind'
 *      DateEnd: // value for 'DateEnd'
 *   },
 * });
 */
export function usePercentagebillsQuery(baseOptions?: Apollo.QueryHookOptions<PercentagebillsQuery, PercentagebillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PercentagebillsQuery, PercentagebillsQueryVariables>(PercentagebillsDocument, options);
      }
export function usePercentagebillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PercentagebillsQuery, PercentagebillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PercentagebillsQuery, PercentagebillsQueryVariables>(PercentagebillsDocument, options);
        }
export type PercentagebillsQueryHookResult = ReturnType<typeof usePercentagebillsQuery>;
export type PercentagebillsLazyQueryHookResult = ReturnType<typeof usePercentagebillsLazyQuery>;
export type PercentagebillsQueryResult = Apollo.QueryResult<PercentagebillsQuery, PercentagebillsQueryVariables>;
export const RegionalsDocument = gql`
    query REGIONALS($id: String, $proyecto: String) {
  regionals(
    where: {company_id: {equals: $id}, company: {name: {equals: $proyecto}}}
  ) {
    id
    name
  }
}
    `;

/**
 * __useRegionalsQuery__
 *
 * To run a query within a React component, call `useRegionalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      proyecto: // value for 'proyecto'
 *   },
 * });
 */
export function useRegionalsQuery(baseOptions?: Apollo.QueryHookOptions<RegionalsQuery, RegionalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionalsQuery, RegionalsQueryVariables>(RegionalsDocument, options);
      }
export function useRegionalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionalsQuery, RegionalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionalsQuery, RegionalsQueryVariables>(RegionalsDocument, options);
        }
export type RegionalsQueryHookResult = ReturnType<typeof useRegionalsQuery>;
export type RegionalsLazyQueryHookResult = ReturnType<typeof useRegionalsLazyQuery>;
export type RegionalsQueryResult = Apollo.QueryResult<RegionalsQuery, RegionalsQueryVariables>;
export const GroupsDocument = gql`
    query GROUPS($search: String, $first: Int, $last: Int, $filter: Boolean, $company_id: String) {
  regionals(
    where: {company_id: {equals: $company_id}, is_active: {equals: $filter}, OR: [{name: {contains: $search}}]}
    first: $first
    last: $last
  ) {
    id
    name
    is_active
    company_id
  }
}
    `;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const UpdategroupregionalDocument = gql`
    mutation UPDATEGROUPREGIONAL($id: String, $company_id: String, $name: String, $user_updated: String, $user_created: String, $is_active: Boolean) {
  updateOneregional(
    where: {id: $id}
    data: {company: {connect: {id: $company_id}}, name: $name, user_updated: $user_updated, user_created: $user_created, is_active: $is_active}
  ) {
    id
  }
}
    `;
export type UpdategroupregionalMutationFn = Apollo.MutationFunction<UpdategroupregionalMutation, UpdategroupregionalMutationVariables>;

/**
 * __useUpdategroupregionalMutation__
 *
 * To run a mutation, you first call `useUpdategroupregionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdategroupregionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updategroupregionalMutation, { data, loading, error }] = useUpdategroupregionalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      company_id: // value for 'company_id'
 *      name: // value for 'name'
 *      user_updated: // value for 'user_updated'
 *      user_created: // value for 'user_created'
 *      is_active: // value for 'is_active'
 *   },
 * });
 */
export function useUpdategroupregionalMutation(baseOptions?: Apollo.MutationHookOptions<UpdategroupregionalMutation, UpdategroupregionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdategroupregionalMutation, UpdategroupregionalMutationVariables>(UpdategroupregionalDocument, options);
      }
export type UpdategroupregionalMutationHookResult = ReturnType<typeof useUpdategroupregionalMutation>;
export type UpdategroupregionalMutationResult = Apollo.MutationResult<UpdategroupregionalMutation>;
export type UpdategroupregionalMutationOptions = Apollo.BaseMutationOptions<UpdategroupregionalMutation, UpdategroupregionalMutationVariables>;
export const DeleteregionalDocument = gql`
    mutation DELETEREGIONAL($date: DateTime!, $id: String!) {
  updateOneregional(data: {deleted_at: $date}, where: {id: $id}) {
    id
  }
}
    `;
export type DeleteregionalMutationFn = Apollo.MutationFunction<DeleteregionalMutation, DeleteregionalMutationVariables>;

/**
 * __useDeleteregionalMutation__
 *
 * To run a mutation, you first call `useDeleteregionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteregionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteregionalMutation, { data, loading, error }] = useDeleteregionalMutation({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteregionalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteregionalMutation, DeleteregionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteregionalMutation, DeleteregionalMutationVariables>(DeleteregionalDocument, options);
      }
export type DeleteregionalMutationHookResult = ReturnType<typeof useDeleteregionalMutation>;
export type DeleteregionalMutationResult = Apollo.MutationResult<DeleteregionalMutation>;
export type DeleteregionalMutationOptions = Apollo.BaseMutationOptions<DeleteregionalMutation, DeleteregionalMutationVariables>;
export const CreateoneregionalgroupDocument = gql`
    mutation CREATEONEREGIONALGROUP($data: regionalCreateInput!) {
  createOneregional(data: $data) {
    id
  }
}
    `;
export type CreateoneregionalgroupMutationFn = Apollo.MutationFunction<CreateoneregionalgroupMutation, CreateoneregionalgroupMutationVariables>;

/**
 * __useCreateoneregionalgroupMutation__
 *
 * To run a mutation, you first call `useCreateoneregionalgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateoneregionalgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createoneregionalgroupMutation, { data, loading, error }] = useCreateoneregionalgroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateoneregionalgroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateoneregionalgroupMutation, CreateoneregionalgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateoneregionalgroupMutation, CreateoneregionalgroupMutationVariables>(CreateoneregionalgroupDocument, options);
      }
export type CreateoneregionalgroupMutationHookResult = ReturnType<typeof useCreateoneregionalgroupMutation>;
export type CreateoneregionalgroupMutationResult = Apollo.MutationResult<CreateoneregionalgroupMutation>;
export type CreateoneregionalgroupMutationOptions = Apollo.BaseMutationOptions<CreateoneregionalgroupMutation, CreateoneregionalgroupMutationVariables>;
export const RegionalsbyuserDocument = gql`
    query REGIONALSBYUSER {
  RegionalsByUser {
    regional_id
    regional_name
  }
}
    `;

/**
 * __useRegionalsbyuserQuery__
 *
 * To run a query within a React component, call `useRegionalsbyuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionalsbyuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionalsbyuserQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionalsbyuserQuery(baseOptions?: Apollo.QueryHookOptions<RegionalsbyuserQuery, RegionalsbyuserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionalsbyuserQuery, RegionalsbyuserQueryVariables>(RegionalsbyuserDocument, options);
      }
export function useRegionalsbyuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionalsbyuserQuery, RegionalsbyuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionalsbyuserQuery, RegionalsbyuserQueryVariables>(RegionalsbyuserDocument, options);
        }
export type RegionalsbyuserQueryHookResult = ReturnType<typeof useRegionalsbyuserQuery>;
export type RegionalsbyuserLazyQueryHookResult = ReturnType<typeof useRegionalsbyuserLazyQuery>;
export type RegionalsbyuserQueryResult = Apollo.QueryResult<RegionalsbyuserQuery, RegionalsbyuserQueryVariables>;
export const ReportstatustableDocument = gql`
    query REPORTSTATUSTABLE($search: String, $first: Int, $last: Int, $filter_user: String) {
  reportStatuses(
    where: {OR: [{user_name: {contains: $search}}, {status: {contains: $search}}, {name: {contains: $search}}], AND: [{user_name: {equals: $filter_user}}]}
    first: $first
    last: $last
    orderBy: {id: desc}
  ) {
    id
    name
    user_name
    status
    data
    created_at
    updated_at
  }
}
    `;

/**
 * __useReportstatustableQuery__
 *
 * To run a query within a React component, call `useReportstatustableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportstatustableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportstatustableQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter_user: // value for 'filter_user'
 *   },
 * });
 */
export function useReportstatustableQuery(baseOptions?: Apollo.QueryHookOptions<ReportstatustableQuery, ReportstatustableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportstatustableQuery, ReportstatustableQueryVariables>(ReportstatustableDocument, options);
      }
export function useReportstatustableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportstatustableQuery, ReportstatustableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportstatustableQuery, ReportstatustableQueryVariables>(ReportstatustableDocument, options);
        }
export type ReportstatustableQueryHookResult = ReturnType<typeof useReportstatustableQuery>;
export type ReportstatustableLazyQueryHookResult = ReturnType<typeof useReportstatustableLazyQuery>;
export type ReportstatustableQueryResult = Apollo.QueryResult<ReportstatustableQuery, ReportstatustableQueryVariables>;
export const SelectmetersDocument = gql`
    query SELECTMETERS {
  meters(where: {}) {
    id
    place_name
  }
}
    `;

/**
 * __useSelectmetersQuery__
 *
 * To run a query within a React component, call `useSelectmetersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectmetersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectmetersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectmetersQuery(baseOptions?: Apollo.QueryHookOptions<SelectmetersQuery, SelectmetersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectmetersQuery, SelectmetersQueryVariables>(SelectmetersDocument, options);
      }
export function useSelectmetersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectmetersQuery, SelectmetersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectmetersQuery, SelectmetersQueryVariables>(SelectmetersDocument, options);
        }
export type SelectmetersQueryHookResult = ReturnType<typeof useSelectmetersQuery>;
export type SelectmetersLazyQueryHookResult = ReturnType<typeof useSelectmetersLazyQuery>;
export type SelectmetersQueryResult = Apollo.QueryResult<SelectmetersQuery, SelectmetersQueryVariables>;
export const ServicesDocument = gql`
    query SERVICES {
  services(where: {}) {
    id
    name
  }
}
    `;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesQuery(baseOptions?: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const MarketersDocument = gql`
    query MARKETERS {
  marketers(where: {}) {
    id
    name
  }
}
    `;

/**
 * __useMarketersQuery__
 *
 * To run a query within a React component, call `useMarketersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketersQuery(baseOptions?: Apollo.QueryHookOptions<MarketersQuery, MarketersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketersQuery, MarketersQueryVariables>(MarketersDocument, options);
      }
export function useMarketersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketersQuery, MarketersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketersQuery, MarketersQueryVariables>(MarketersDocument, options);
        }
export type MarketersQueryHookResult = ReturnType<typeof useMarketersQuery>;
export type MarketersLazyQueryHookResult = ReturnType<typeof useMarketersLazyQuery>;
export type MarketersQueryResult = Apollo.QueryResult<MarketersQuery, MarketersQueryVariables>;
export const UpdatebillDocument = gql`
    mutation UPDATEBILL($data: billUpdateInput!, $id: String) {
  updateOnebill(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdatebillMutationFn = Apollo.MutationFunction<UpdatebillMutation, UpdatebillMutationVariables>;

/**
 * __useUpdatebillMutation__
 *
 * To run a mutation, you first call `useUpdatebillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatebillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatebillMutation, { data, loading, error }] = useUpdatebillMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatebillMutation(baseOptions?: Apollo.MutationHookOptions<UpdatebillMutation, UpdatebillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatebillMutation, UpdatebillMutationVariables>(UpdatebillDocument, options);
      }
export type UpdatebillMutationHookResult = ReturnType<typeof useUpdatebillMutation>;
export type UpdatebillMutationResult = Apollo.MutationResult<UpdatebillMutation>;
export type UpdatebillMutationOptions = Apollo.BaseMutationOptions<UpdatebillMutation, UpdatebillMutationVariables>;
export const UsersDocument = gql`
    query USERS($search: String) {
  users(where: {nickname: {contains: $search}}) {
    id
    names
    nickname
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const TransquibersDocument = gql`
    query TRANSQUIBERS {
  users(where: {}) {
    id
    nickname
  }
}
    `;

/**
 * __useTransquibersQuery__
 *
 * To run a query within a React component, call `useTransquibersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransquibersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransquibersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransquibersQuery(baseOptions?: Apollo.QueryHookOptions<TransquibersQuery, TransquibersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransquibersQuery, TransquibersQueryVariables>(TransquibersDocument, options);
      }
export function useTransquibersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransquibersQuery, TransquibersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransquibersQuery, TransquibersQueryVariables>(TransquibersDocument, options);
        }
export type TransquibersQueryHookResult = ReturnType<typeof useTransquibersQuery>;
export type TransquibersLazyQueryHookResult = ReturnType<typeof useTransquibersLazyQuery>;
export type TransquibersQueryResult = Apollo.QueryResult<TransquibersQuery, TransquibersQueryVariables>;